// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/vuzes.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/images/profile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/images/challenge.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/images/challenge_menu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/images/school.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/images/serts.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/images/prize.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/images/excel.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/images/users.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/images/test.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/images/money.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/images/tarif.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../assets/images/preview.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../assets/images/work.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../assets/images/lock.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../assets/images/complete.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../assets/images/kubok.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../assets/images/profile_menu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../assets/images/results_menu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../assets/images/jury_menu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../assets/images/ocenka_menu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../assets/images/exit_menu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../assets/images/students_menu.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../assets/images/exit_btn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../assets/images/alarm.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../assets/images/arrow-btn.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../assets/images/arrow-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../assets/images/answer.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../assets/images/back.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../assets/images/arrow_back.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../assets/images/lock_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../assets/images/plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../assets/images/settings_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../assets/images/btn_ok.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../assets/images/delete.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../assets/images/time.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../assets/images/Logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../assets/images/site.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../assets/images/email.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../assets/images/call.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../assets/images/del_comand.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../assets/images/huy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../assets/images/welcome.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../assets/images/btn_ok_green.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../assets/images/fale.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../assets/images/clock.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../assets/images/done.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../assets/images/close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../assets/images/preview_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../assets/images/settings_white_new.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../assets/images/load_img.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../assets/images/ok_answer.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../assets/images/delete_red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../assets/images/ok_answer_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../assets/images/info.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../assets/images/plus_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../assets/images/settings_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../assets/images/edit_blue.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../assets/images/done_green.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../assets/images/print_doc.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../assets/images/link_landing.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../assets/images/question.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("../assets/images/Star_2.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../assets/images/done_stroke.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("../assets/images/loopa.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../assets/images/close_white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --menu-padding: 30%;
  --header-padding: 50px;
  --block-padding: 50px;
  --header-height: 100px;
  --font-size: 16px;
  --logo-width: 100px;
  --fio-name: 21px;
  --user-avatar-size: 100px;
  --legend-size: 18px;
  --user-profile-padding: 20px;
  --block-size: 50%;
  --block-center: 70%;
  --padding-btn: 20px 30px 20px 50px;
  --btn-description: 15px;
  --menu-link: 16px;
  --menu-width: 250px;
  --menu-link-height: 19px;
  --padding-btn: 20px 25px 20px 50px;
  --icon-padding: 25px;
  --main-center-head: 160px;
  --text-size: 16px;
  --text-lineheight: 22px;
  --padding-input: 20px 25px;
  --blue-main: rgba(54, 110, 255, 1);
  --text-grey: #33353a;
  --cert-height: 90vh;
  --cert-height-full: 100vh;
}

@media (max-width: 1600px) {
  :root {
    --menu-padding: 30%;
    --header-padding: 30px;
    --block-padding: 30px;
    --header-height: 80px;
    --font-size: 16px;
    --logo-width: 80px;
    --fio-name: 21px;
    --user-avatar-size: 80px;
    --legend-size: 16px;
    --user-profile-padding: 20px;
    --block-size: 50%;
    --block-center: 70%;
    --btn-description: 14px;
    --menu-link: 16px;
    --menu-link-height: 19px;
    --main-center-head: 140px;
    --text-size: 16px;
    --text-lineheight: 22px;
    --padding-input: 20px 25px;
    --blue-main: rgba(54, 110, 255, 1);
    --text-grey: #33353a;
  }
}

@media (max-width: 1280px) {
  :root {
    --menu-padding: 30%;
    --header-padding: 30px;
    --block-padding: 30px;
    --header-height: 70px;
    --font-size: 14px;
    --logo-width: 70px;
    --fio-name: 18px;
    --user-avatar-size: 70px;
    --legend-size: 14px;
    --user-profile-padding: 20px;
    --block-size: 50%;
    --block-center: 70%;
    --btn-description: 12px;
    --menu-link: 14px;
    --menu-link-height: 19px;
    --main-center-head: 140px;
  }
}

@media (max-width: 800px) {
  :root {
    --menu-padding: 30%;
    --header-padding: 30px;
    --block-padding: 20px;
    --header-height: 70px;
    --font-size: 13px;
    --logo-width: 70px;
    --fio-name: 16px;
    --user-avatar-size: 70px;
    --legend-size: 14px;
    --user-profile-padding: 20px;
    --block-size: 100vw;
    --block-center: 70%;
    --btn-description: 12px;
    --menu-link: 14px;
    --menu-link-height: 19px;
    --main-center-head: 140px;
    --cert-height: 65vh;
  }
}

@media (max-width: 600px) {
  :root {
    --menu-padding: 30%;
    --header-padding: 30px;
    --block-padding: 15px;
    --header-height: 60px;
    --font-size: 13px;
    --logo-width: 70px;
    --fio-name: 18px;
    --user-avatar-size: 70px;
    --legend-size: 14px;
    --user-profile-padding: 20px;
    --block-size: 100vw;
    --block-center: 100%;
    --menu-link: 24px;
    --menu-link-height: 24px;
    --main-center-head: 120px;
  }
}

/* icons */

.vuz-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.profile-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.challenge-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.challenge-challenge-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.school-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.certification-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.loot-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.unloads-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.users-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.tests-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.bills-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.plans-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.preview {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-size: var(--font-size) auto;
}

.work {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-repeat: no-repeat;
  background-size: var(--font-size) auto;
}

.lock {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-size: var(--font-size) auto;
}

.complete {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  background-size: var(--font-size) auto;
  color: var(--blue-main);
}

.kubok {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  background-size: var(--font-size) auto;
}

.kabinet {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
}

.sorev {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
}

.profile {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  background-size: auto var(--font-size);
  background-position: left center;
}

.results-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.jury-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.ocenka-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.exit-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

.students-menu {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-repeat: no-repeat;
  background-size: var(--menu-link-height) auto;
  background-position: left center;
}

button:hover,
button:focus,
button:active {
  outline: none;
}

/* КНОПКИ */

.btn {
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
  width: 100%;
  padding: var(--padding-input);
  border: 0;
  border-radius: 5px;
  border: 2px solid #abaeb852;
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  background: none;
  color: var(--text-grey);
  cursor: pointer;
  transition: ease-in-out 0.3s;
}

.btn:hover {
  border: 2px solid #dee8ff91;
  background-color: #dee8ff91;
  transition: ease-in-out 0.3s;
}

.btn-deactive {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--padding-input);
  border: 0;
  border-radius: 5px;
  border: 2px solid #81869752;
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  background: none;
  color: var(--text-grey);
  cursor: pointer;
  opacity: 0.5;
  gap: 10px;
}

.btn-complete {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--padding-input);
  border: 0;
  border-radius: 5px;
  border: 2px solid var(--blue-main);
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  background: none;
  color: var(--text-grey);
  cursor: pointer;
  gap: 10px;
  -webkit-gap: 10px;
  transition: ease-in-out 0.3s;
}

.btn-complete:hover {
  border: 2px solid #dee8ff91;
  background-color: #dee8ff91;
  transition: ease-in-out 0.3s;
}

.btn-heading {
  font-weight: 600;
  font-size: var(--font-size);
  line-height: var(--font-size);
  padding-left: calc(var(--font-size) + 5px);
}

.btn-description {
  font-size: var(--btn-description);
  line-height: calc(var(--btn-description) + 8px);
  letter-spacing: 0.02em;
  color: var(--text-grey);
}

.lock + .btn-description {
  color: var(--blue-main);
}

.btn-no {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  border: 0;
  border-radius: 5px;
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: center;
  background: #FF6666;
  color: white;
  cursor: pointer;
}

.btn-exit {
  display: block;
  width: 100%;
  padding: var(--padding-btn);
  border: 0;
  border-radius: 5px;
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  color: white;
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-size: auto var(--font-size);
  background-position: left center;
  background-position-x: var(--icon-padding);
  background-repeat: no-repeat;
  background-color: #FF6666;
}

.btn-exit:hover {
  background-color: red;
  transition: ease-in-out 0.3s;
}

.error-message {
  display: block;
  width: 100%;
  padding: var(--padding-btn);
  border: 0;
  border-radius: 5px;
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  color: white;
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-size: auto var(--font-size);
  background-position: left center;
  background-position-x: var(--icon-padding);
  background-repeat: no-repeat;
  background-color: #FF6666;
}

.success-message {
  display: block;
  width: 100%;
  padding: var(--padding-btn);
  border: 0;
  border-radius: 5px;
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  color: white;
  cursor: default;
  opacity: 0.6;
  background-size: auto var(--font-size);
  background-position: left center;
  background-position-x: var(--icon-padding);
  background-repeat: no-repeat;
  background-color: #19CB6B;
}


.message-for-sure {
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 8px);
}

.btn-arrow {
  display: block;
  width: 100%;
  padding: var(--padding-btn);
  border: 0;
  border-radius: 5px;
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  color: white;
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-size: auto var(--font-size);
  background-position: left center;
  background-position-x: var(--icon-padding);
  background-repeat: no-repeat;
  background-color: var(--blue-main);
  transition: ease-in-out 0.3s;
}

.btn-arrow:hover {
  background-color: #174bce;
  transition: ease-in-out 0.3s;
}

.btn-wrapper {
  display: flex;
  flex-direction: row;
  gap: 15px;
  -webkit-gap: 15px;
}

.btn-main {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  background: linear-gradient(90.01deg, #366EFF 0.01%, #FA00FF 49.61%, #FF3D00 99.21%);
  border: 0;
  border-radius: 5px;
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 700;
  color: white;
  cursor: pointer;
  transition: ease-in-out 0.3s;
}

.btn-blue {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  background: var(--blue-main);
  border: 0;
  border-radius: 5px;
  font-size: var(--text-size);
  line-height: var(--text-lineheight);
  font-weight: 700;
  color: white;
  cursor: pointer;
}

.btn-landing {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  background-color: var(--blue-main);
  border: 0;
  border-radius: 5px;
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 700;
  color: white;
  cursor: pointer;
  transition: ease-in-out 0.3s;
}

/* INPUT AND FORM */

/* MAIN FORM RIGHT BLOCK */
.menu-challenge {
  position: relative;
  background-color: white;
  padding: 30px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
}

@media (max-width: 1280px) {
  .menu-challenge {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    -webkit-gap: 15px;
  }
}

@media (max-width: 800px) {
  .menu-challenge {
    background-color: white;
    padding: 15px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    -webkit-gap: 15px;
  }
}

.legend-about {
  display: block;
  font-size: var(--legend-size);
  line-height: var(--legend-size);
  font-weight: 700;
}

input {
  font-size: var(--text-size);
  line-height: var(--text-lineheight);
  transition: ease-in-out 0.2s;
  outline: none;
}

input:focus,
input:active {

  transition: ease-in-out 0.2s;
  outline: none;
}

input:hover {

  transition: ease-in-out 0.2s;
  outline: none;
}

input::placeholder {
  color: #847E95;
}

input[type='checkbox']:before {
  outline: none;
  border: 0;
}

input[type='checkbox']:checked:before {
  outline: none;
  border: 0;
}

input[type='checkbox']:checked:after {
  outline: none;
  border: 0;
}

input[type='submit']:hover,
input[type='submit']:active,
input[type='submit']:focus {
  outline: none;
}

.white-input {
  background-color: white;
}

.input-standart {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  background-color: rgba(255, 255, 255, 0.5);
  border: 0;
  border-radius: 5px;
}

.input-standart:focus,
.input-standart:active,
.input-standart:hover {
  background-color: rgba(255, 255, 255, 1);
  outline: none;
  border: 0;
}

.label-checkbox-radio {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 10px;
  -webkit-gap: 10px;
}

.checkbox-radio {
  display: block;
  position: relative;
  top: 5px;
}

.btn-select {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  background: rgba(255, 255, 255, 0.5);
  border: 0;
  border-radius: 5px;
  font-size: var(--text-size);
  line-height: var(--text-lineheight);
  font-weight: 700;
  color: black;
  cursor: pointer;
}

.input-challenges {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid rgba(175, 180, 202, 0.5);
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
}

.input-challenges:hover {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid var(--blue-main);
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
}

.input-challenges-select {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat right center ;
  background-position-x: 97%;
  background-color: white;
  border-radius: 5px;
  border: 2px solid rgba(175, 180, 202, 0.5);
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
}

select::-ms-expand {
  display: none;
}

.input-challenges-flex {
  display: flex;
  align-self: center;
  gap: 5px;
  -webkit-gap: 5px;
  width: 100%;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid rgba(175, 180, 202, 0.5);
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  background-color: white;
}

.block-input {
  position: relative;
  display: flex;
  border: 0;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
  max-width: 100%;
}

.answer {
  position: absolute;
  bottom: 15px;
  right: 15px;
  width: 35px;
  height: 35px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) center center no-repeat;
  background-size: contain;
  border-radius: 5px;
}

.answer-text {
  position: absolute;
  bottom: 15px;
  right: 55px;
  max-width: 80%;
  border-radius: 5px;
  padding: var(--padding-input);
  background-color: white;
  border: 1px solid #001AFF;
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 6px);
}

@media (max-width: 1600px) {
  .answer {
    position: absolute;
    bottom: 7px;
    right: 10px;
    width: 35px;
    height: 35px;
    background-color: blue;
    border-radius: 8px;
  }

  .answer-text {
    position: absolute;
    bottom: 7px;
    right: 55px;
    max-width: 80%;
    border-radius: 5px;
    padding: var(--padding-input);
    background-color: white;
    border: 1px solid #001AFF;
    font-size: var(--font-size);
    line-height: calc(var(--font-size) + 6px);
  }
}

.profile-flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.link-all-challenges {
  font-size: var(--btn-description);
  color: var(--blue-main);
}

.link-all-challenges:hover {
  color: #174bce;
  transition: ease-in-out 0.3s;
}

.challenges-profile-heading {
  font-weight: 600;
  font-size: var(--font-size);
  line-height: var(--font-size);
}

.block-input-flex {
  display: flex;
  border: 0;
  display: flex;
  flex-direction: row;
  gap: 10px;
  -webkit-gap: 10px;
}

.radio-btn {
  display: inline-block;
  margin-right: 5px;
}

.span-radio {
  display: block;
}

.legend {
  display: block;
  max-width: 100%;
  font-size: var(--legend-size);
  line-height: var(--legend-size);
  padding-bottom: 10px;
  font-weight: 700;
}

/* BACKGROUNDS */

.platform-background {
  background: linear-gradient(147.75deg, #E7A4FF 0%, #001AFF 100%);
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
}

@media (max-width: 600px) {
  .platform-background {
    background: linear-gradient(147.75deg, #E7A4FF 0%, #001AFF 100%);
    max-height: 100vh;
    width: 100vw;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }
}

.image-back {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 50%;
  right: 0;
  bottom: 0;
  display: block;
  width: 50vw;
  height: 100vh;
  object-fit: cover;
}

.image-back-video {
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  display: block;
  width: 50vw;
  height: 100vh;
  object-fit: cover;
}

.flex-platform {
  display: flex;
  flex-direction: row;
  background-color: white;
  margin: 0 auto;
}


/* BLOCK SYSTEM */

.left-block {
  width: var(--block-size);
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 2;
  overflow: hidden;
}


.right-block {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 4;
  width: var(--block-size);
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  transition: ease-in-out 0.5s;
}

.block-center {
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  width: var(--block-center);
  padding: var(--block-padding);
  padding-top: calc(var(--user-avatar-size) + 40px);
  padding-bottom: 0;
  height: calc(100vh - var(--header-height));
}

.main-list-center {
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  /* width: var(--block-center); */
  padding: var(--block-padding);
  padding-top: var(--main-center-head);
  padding-bottom: 0;
  height: calc(100vh - var(--header-height));
  width: 100%;
}

.main-list-center-comand {
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  /* width: var(--block-center); */
  padding: var(--block-padding);
  padding-top: var(--main-center-head);
  padding-bottom: 55px;
  height: calc(100vh - var(--header-height));
  width: 100%;
}

.notifications-search {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
  background-color: #001AFF;
}

.notifications-search-mobile {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
  background-color: #001AFF;
}

@media (max-width: 700px) {
  .notifications-search {
    display: none;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
    background-color: #001AFF;
  }

  .notifications-search-mobile {
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
    background-color: #001AFF;
  }
}

.nav-notification-list {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 30px;
  -webkit-gap: 30px;
  padding: 0 30px;
  font-size: var(--font-size);
  line-height: var(--font-size);
  color: white;
  align-items: center;
}

.nav-notification-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  -webkit-gap: 7px;
  color: rgba(255, 255, 255, 0.7);
}

.notification-notification {
  display: block;
  padding: 8px 9px;
  background-color: #FF3D00;
  color: white;
  border-radius: 5px;
}

.notification-notification::before {
  content: '+';
}

.notification-link {
  padding: 20px 0;
  cursor: pointer;
}

.nav-notification-item-active {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
  -webkit-gap: 7px;
  color: rgba(255, 255, 255, 1);
}

@media (max-width: 1200px) and (min-width: 800px) {
  .block-center {
    display: flex;
    flex-direction: column;
    gap: 20px;
    -webkit-gap: 20px;
    width: 100%;
    padding: var(--block-padding);
    padding-top: calc(var(--user-avatar-size) + 40px);
    padding-bottom: 0;
  }
}

.block-center-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  padding-top: calc(69px + 20px);
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: var(--block-padding);
  overflow: auto;
}

/* HEADER BURGER MENU */

.burger {
  display: none;
  position: relative;
  width: 30px;
  height: 21px;
  cursor: pointer;
}

@media (max-width: 1200px) and (min-width: 800px) {
  .burger {
    display: block;
    position: relative;
    width: 30px;
    height: 21px;
  }
}

@media (max-width: 600px) {
  .burger {
    display: block;
    position: relative;
    width: 30px;
    height: 21px;
  }
}

.first-line {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 3px;
  background-color: black;
}

.two-line {
  position: absolute;
  top: 9px;
  right: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 3px;
  background-color: black;
}

.three-line {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 3px;
  background-color: black;
}

.header-avatar {
  display: block;
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 20px;
}

.header-logo {
  width: var(--logo-width);
  margin-right: auto;
  margin-left: 15px;
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: var(--header-padding);
  height: var(--header-height);
  /* border-bottom: 1px solid #DCDDE0; */
  background-color: white;
}

.username {
  display: flex;
  align-items: center;
  gap: 15px;
  -webkit-gap: 15px;
  cursor: pointer;
}

.header-username {
  font-size: 21px;
  line-height: 21px;
  font-weight: 800;
  letter-spacing: 0;
}

.header-back {
  font-size: var(--fio-name);
  line-height: var(--fio-name);
  font-weight: 700;
  letter-spacing: 0;
  padding-left: 18px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  background-size: 8px auto;
  background-repeat: no-repeat;
  background-position: left center;
  color: #847E95;
  cursor: pointer;
}

.name-menu {
  font-size: var(--fio-name);
  line-height: var(--fio-name);
  font-weight: 700;
  color: var(--blue-main);
}

.content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  height: calc(100vh - var(--header-height));
}


/* MENU */

.menu {
  display: flex;
  padding: var(--header-padding);
  width: var(--menu-padding);
  height: 100vh;
  flex-direction: column;
  z-index: 999
}

@media (max-width: 1200px) and (min-width: 800px) {
  .menu {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: none;
    padding: var(--header-padding);
    width: 50%;
    height: 100vh;
    background-color: white;
    z-index: 999;
  }
}

@media (max-width: 800px) {
  .menu {
    display: flex;
    padding: var(--header-padding);
    width: 50%;
    background-color: white;
    height: 100vh;
    z-index: 999
  }
}

@media (max-width: 600px) {
  .menu {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: none;
    padding: var(--header-padding);
    width: 100vw;
    height: 100vh;
    background-color: white;
    z-index: 999;
  }
}

.menu-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 25px;
  -webkit-gap: 25px;
}

@media (max-width: 600px) {
  .menu-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 35px;
    -webkit-gap: 35px;
  }
}

.menu-link {
  font-weight: 600;
  font-size: var(--menu-link);
  line-height: var(--menu-link-height);
  color: var(--text-grey);
  padding-left: calc(var(--menu-link-height) + 6px);
  filter: saturate(0);
  opacity: 0.6;
}

.menu-link:hover {
  font-weight: 600;
  font-size: var(--menu-link);
  line-height: var(--menu-link-height);
  color: var(--blue-main);
  padding-left: calc(var(--menu-link-height) + 6px);
  filter: saturate(1);
  opacity: 0.6;
}

.acvtive-menu {
  filter: saturate(1);
  opacity: 1;
  color: var(--blue-main);
}

.burger-back {
  display: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) left center no-repeat;
  margin-bottom: 20px;
  padding: 20px 20px 20px 40px;
  font-size: var(--menu-link);
  border-radius: 5px;
  cursor: pointer;
}

@media (max-width: 1200px) and (min-width: 800px) {
  .burger-back {
    display: block;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) left center no-repeat;
    margin-bottom: 20px;
    padding: 20px 20px 20px 40px;
    font-size: var(--menu-link);
    border-radius: 5px;
  }
}

@media (max-width: 600px) {
  .burger-back {
    display: block;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) left center no-repeat;
    margin-bottom: 20px;
    padding: 20px 20px 20px 40px;
    font-size: var(--menu-link);
    border-radius: 5px;
  }
}

.arrow-back {
  color: var(--blue-main);
  font-weight: 600;
  font-size: var(--menu-link);
  line-height: var(--menu-link);
}

/* CONTENT STYLES */

.first-message {
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
  padding: var(--padding-input);
  background-color: #ebebeb;
  border-radius: 5px;
}

.first-message-error {
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
  padding: var(--padding-input);
  background-color: rgba(255, 61, 0, 0.1);
  border-radius: 5px;
}

.user-profile {
  position: absolute;
  top: 0;
  left: 20px;
  right: 20px;
  height: calc(var(--user-avatar-size) + 40px);
  /* border-radius: 15px; */
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  -webkit-gap: 20px;
  padding: var(--user-profile-padding);
  border-radius: 30px;
  box-shadow: 2px 5px 30px #B9CDFF;
  /* border: 2px solid #d1d1d3; */
  background-color: white;
}

@media (max-width: 600px) {
  .user-profile {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: calc(var(--user-avatar-size) + 40px);
    /* border-radius: 15px; */
    background-color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    -webkit-gap: 20px;
    padding: var(--user-profile-padding);
    border-radius: 0;
    /* box-shadow: 2px 5px 30px #B9CDFF; */
    /* border: 2px solid #d1d1d3; */
    /* background-color: rgb(240, 240, 240); */
  }
}

.user-profile-info {
  display: flex;
  padding: 20px 2px 30px 2px;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  overflow-y: auto;
}

.challenge-info {
  display: flex;
  padding: 20px 2px 30px 2px;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  overflow-y: auto;
}


.avater-user {
  width: var(--user-avatar-size);
  height: var(--user-avatar-size);
  display: block;
  object-fit: cover;
  border-radius: 20px;
  cursor: pointer;
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
  -webkit-gap: 5px;
}

.fio-or-name {
  font-size: var(--fio-name);
  font-weight: 800;
}

.city {
  font-size: var(--font-size);
  line-height: var(--font-size);
}

.city-student {
  font-size: var(--font-size);
  line-height: var(--font-size);
  margin-left: auto;
}

.interests {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  -webkit-gap: 5px;
}

.interest-item {
  display: inline-block;
  width: fit-content;
  padding: 10px 15px;
  font-size: 14px;
  line-height: 14px;
  color: white;
  background-color: var(--blue-main);
  cursor: pointer;
  border-radius: 5px;
  transition: ease-in-out 0.3s;
}

.interest-item:hover {
  background-color: #174bce;
  transition: ease-in-out 0.3s;
}

@media (max-width: 800px) {
  .interest-item {
    display: inline-block;
    width: fit-content;
    padding: 10px 15px;
    font-size: 12px;
    line-height: 12px;
    color: white;
    background-color: var(--blue-main);
    border-radius: 5px;
  }
}

.interest-item-comand {
  display: inline-block;
  width: fit-content;
  padding: 10px 15px;
  font-size: 14px;
  line-height: 14px;
  background-color: white;
  border-radius: 5px;
}


.career-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  -webkit-gap: 5px;
}

.career-item {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  padding: 20px;
  background-color: rgba(208, 208, 255, 0.3);
  border-radius: 5px;
}

.career-heading {
  font-size: calc(var(--font-size) + 4px);
  font-weight: 600;
  line-height: calc(var(--font-size) + 8px);
}

.career-description {
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 8px);
  white-space: pre-wrap;
}

.link-no {
  color: #FF6666;
  text-decoration: underline;
}

.right-menu {
  padding: var(--block-padding);
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  overflow: auto;
}

.right-menu-anketa {
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  overflow: auto;
}

.ur-profile-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
}


.nav-block-center {
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  flex-direction: row;
  gap: 25px;
  -webkit-gap: 25px;
  padding: 30px;
  padding-top: 15px;
  padding-bottom: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  overflow-y: scroll;
}

.link-nav-center-item {
  display: block;
  padding-bottom: 15px;
  border-bottom: 2px solid white;
  color: white;
  font-size: var(--font-size);
  font-weight: 600;
}

.lock-link {
  display: block;
  padding-bottom: 15px;
  color: white;
  font-size: var(--font-size);
  border: 0;
  font-weight: 600;
  padding-left: calc(var(--font-size) + 6px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) no-repeat left 2px;
  background-size: var(--font-size) auto;
  opacity: 0.6;
}

.non-active-nav {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  font-size: var(--font-size);
  border-bottom: 2px solid rgba(175, 180, 202, 0);
}

.button-add {
  display: block;
  position: absolute;
  z-index: 8;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px 10px 45px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  background-position-x: 18px;
  background-position-y: center;
  background-repeat: no-repeat;
  background-color: #001AFF;
  box-shadow: 2px 5px 30px #B9CDFF;
  border: 0;
  border-radius: 20px;
  color: white;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
}

.button-add-popup {
  flex-direction: column;
  gap: 0;
  -webkit-gap: 0;
  position: absolute;
  z-index: 9;
  bottom: 20px;
  right: 20px;
  background-color: white;
  box-shadow: 2px 5px 30px #B9CDFF;
  border: 0;
  border-radius: 5px;
  overflow: hidden;
}

.add-stage {
  width: 200px;
  padding: var(--padding-input);
  font-size: var(--font-size);
  line-height: var(--font-size);
  background-color: white;
  border: 0;
  transition: ease-in-out 0.3s;
  cursor: pointer;
}

.add-stage:not(:last-child) {
  border-bottom: 1px solid rgba(54, 110, 255, 0.3);
}

.add-stage:hover {
  background-color: var(--blue-main);
  color: white;
  transition: ease-in-out 0.3s;
}

.container-right-block {
  display: flex;
  flex-direction: column;
  padding: var(--block-padding);
  border-radius: 5px;
  overflow: auto;
  gap: 20px;
  -webkit-gap: 20px;
}

@media (max-width: 1000px) {
  .container-right-block {
    display: flex;
    flex-direction: column;
    padding: 20px;
    border-radius: 5px;
    overflow: auto;
    gap: 20px;
    -webkit-gap: 20px;
  }
}

@media (max-width: 800px) {
  .container-right-block {
    display: flex;
    flex-direction: column;
    padding: 15px;
    border-radius: 5px;
    overflow: auto;
    gap: 20px;
    -webkit-gap: 20px;
  }
}


.text-about p {
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 8px);
}

.challenge-btn {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid var(--blue-main);
  font-weight: 600;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  background: none;
  color: var(--blue-main);
  cursor: pointer;
}

.headline-right-block {
  font-size: 28px;
  line-height: 33px;
  font-weight: 800;
  white-space:pre-wrap;
}

.block-settings-challenge {
  display: flex;
  gap: 15px;
  -webkit-gap: 15px;
}

.settings-challenge {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  border: none;
  border-radius: 5px;
  font-weight: 600;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  background: #8D9CC3;
  color: white;
  cursor: pointer;
}

.settings-challenge-button {
  display: inline-block;
  width: 100%;
  padding: var(--padding-input);
  padding-left: calc(var(--font-size) + 30px);
  border: none;
  border-radius: 5px;
  font-weight: 600;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) no-repeat left center;
  background-size: var(--font-size) auto;
  background-position-x: 20px;
  background-color: #8D9CC3;
  color: white;
  cursor: pointer;
}

.settings-jury {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  border: none;
  border-radius: 5px;
  font-weight: 600;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  background: #8D9CC3;
  color: white;
  cursor: pointer;
}

.avatar-right-block {
  width: 100%;
  border-radius: 30px;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  -webkit-gap: 20px;
  padding: var(--user-profile-padding);
  /* box-shadow: 2px 5px 30px #B9CDFF; */
}

.img-place {
  width: 50%;
  height: auto;
  aspect-ratio: 1;
  background-color: var(--text-grey);
}

.city-search {
  position: relative;
}

.container-city {
  position: relative;
  width: 100%;
  max-height: 400px;
  z-index: 9;
  overflow: auto;
  border-radius: 5px;
}

.city-input {
  position: relative;
  display: flex;
  align-items: center;
  padding: var(--padding-input);
  width: 100%;
  background-color: white;
  color: black;
  transition: ease-in-out 0.2s;
  cursor: pointer;
}

.city-input:not(:last-child) {
  border-bottom: 1px solid #cecece;
}

.city-input:hover {
  background-color: var(--blue-main);
  color: white;
  transition: ease-in-out 0.2s;
}

.add-image {
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
}

.disable {
  display: block;
  width: 0;
  height: 0;
  background: none;
  border: 0;
}

.disable,
.disable:hover,
.disable:active,
.disable:focus {
  outline: none;
}

.nav-search-right {
  display: flex;
  flex-direction: row;
  gap: 20px;
  -webkit-gap: 20px;
}

.search-right-block {
  display: block;
  padding-bottom: 15px;
  color: var(--text-grey);
  border-bottom: 2px solid rgba(175, 180, 202, 0);
  font-weight: 600;
}

.active-link {
  border-bottom: 2px solid var(--blue-main);
  color: var(--blue-main);
  cursor: pointer;
}

.people-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
  -webkit-gap: 30px;
}

.admin-people-list {
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  -webkit-gap: 30px;
}

.people-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.people-avatar {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 50%;
}

.people-description {
  display: flex;
  flex-direction: column;
  gap: 5px;
  -webkit-gap: 5px;
  margin-left: 10px;
  margin-right: auto;
}

.people-username {
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 800;
}

.people-city-comp {
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 400;
}

.people-ok {
  display: block;
  width: fit-content;
  border: 0;
  padding: 18px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) no-repeat center center;
  background-color: #D1D1D1;
  border-radius: 5px;
  transition: ease-in-out 0.2s;
  cursor: pointer;
}

.people-ok:hover {
  background-color: #001AFF;
  transition: ease-in-out 0.2s;
}

.people-delete {
  display: block;
  width: fit-content;
  border: 0;
  padding: 18px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_34___}) no-repeat center center;
  background-color: #D1D1D1;
  border-radius: 5px;
  transition: ease-in-out 0.2s;
  cursor: pointer;
}

.people-delete:hover {
  background-color: #FF6666;
  transition: ease-in-out 0.2s;
}

.btn-people {
  display: flex;
  flex-direction: row;
  gap: 10px;
  -webkit-gap: 10px;
}

.rules {
  position: relative;
  display: block;
  max-width: 100%;
  padding: var(--padding-input);
  background-color: var(--blue-main);
  border: 0;
  border-radius: 5px;
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  color: white;
  transition: ease-in-out 0.2s;
  text-overflow: ellipsis;
}

.rules:hover {
  background-color: #001AFF;
  transition: ease-in-out 0.2s;
}

.challenge-list {
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
}

.challenge-card {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  padding: 20px;
  background-color: rgba(208, 208, 255, 0.3);
  border-radius: 5px;
}

@media (max-width: 800px) {
  .challenge-card {
    display: flex;
    flex-direction: column;
    gap: 15px;
    -webkit-gap: 15px;
    padding: 15px;
    background-color: rgba(208, 208, 255, 0.3);
    border-radius: 5px;
  }
}

.challenge-card-mini {
  display: flex;
  flex-direction: row;
  gap: 15px;
  -webkit-gap: 15px;
  align-items: center;
}

.challenge-card-main {
  display: flex;
  flex-direction: row;
  gap: 15px;
  -webkit-gap: 15px;
  align-items: center;
  padding-bottom: 15px;
  transition: ease-in-out 0.3s;
}

.challenge-card-main:hover {
  padding: 15px;
  background-color: white;
  border-radius: 5px;
  transition: ease-in-out 0.3s;
}

.challenge-header {
  font-size: calc(var(--font-size) + 4px);
  font-weight: 600;
  line-height: calc(var(--font-size) + 8px);
  cursor: pointer;
}

.challenge-company {
  font-size: 14px;
  line-height: 18px;
}

.challenge-landing {
  display: inline-block;
  padding: 10px 20px;
  color: white;
  background-color: var(--blue-main);
  width: fit-content;
  border-radius: 5px;
  border: none;
  transition: ease-in-out 0.3s;
  cursor: pointer;
}

.challenge-landing:hover {
  background-color: #174bce;
  transition: ease-in-out 0.3s;
}

.challenge-avatar {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 15px;
}

.my-challenge {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: var(--main-center-head);
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  -webkit-gap: 12px;
  padding: var(--block-padding);
  padding-top: 20px;
  padding-bottom: 0;
  background: linear-gradient(147.75deg, #d153ff 0%, #001AFF 100%);
}

.my-challenge p {
  color: white;
  font-size: calc(var(--font-size) + 2px);
  font-weight: 500;
}

.challenge-information {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  -webkit-gap: 10px;
  justify-content: space-between;
  align-items: center;
}

.challenge-date {
  color: var(--blue-main);
  font-size: 14px;
  padding-left: calc(var(--font-size) + 5px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  background-repeat: no-repeat;
  background-size: var(--font-size);
  background-position: left center;
}

.challenge-description {
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 6px);
}

.challenge-activity {
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  line-height: 16px;
  color: white;
  background-color: var(--blue-main);
  width: fit-content;
  border-radius: 5px;
  cursor: pointer;
  transition: ease-in-out 0.3s;
}

.challenge-activity:hover {
  background-color: #174bce;
  transition: ease-in-out 0.3s;
}

.challenge-activity-no {
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  line-height: 16px;
  color: white;
  background-color: #FF6666;
  width: fit-content;
  border-radius: 5px;
  cursor: pointer;
  transition: ease-in-out 0.3s;
}

.challenge-activity-no:hover {
  background-color: red;
  transition: ease-in-out 0.3s;
}

.challenge-activity-yes {
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  line-height: 16px;
  color: white;
  background-color: var(--blue-main);
  width: fit-content;
  border-radius: 5px;
  cursor: pointer;
  transition: ease-in-out 0.3s;
}

.challenge-activity-yes:hover {
  background-color: darkblue;
  transition: ease-in-out 0.3s;
}

@media (max-width: 1000px) {
  .challenge-activity {
    display: inline-block;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 14px;
    color: white;
    background-color: var(--blue-main);
    width: fit-content;
    border-radius: 5px;
  }

  .challenge-activity-no {
    display: inline-block;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 14px;
    color: white;
    background-color: #FF6666;
    width: fit-content;
    border-radius: 5px;
    cursor: pointer;
  }
}

.message-user {
  color: #28A8E9;
  font-size: 14px;
  padding-left: calc(var(--font-size) + 5px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  background-repeat: no-repeat;
  background-size: var(--font-size);
  background-position: left center;
}

.challenge-money {
  font-size: calc(var(--font-size) + 10px);
}

.input-work {
  display: block;
  font-size: calc(var(--font-size) + 10px);
  line-height: calc(var(--font-size) + 15px);
  font-weight: 600;
  padding: 15px 0;
  margin-bottom: 20px;
  outline: none;
  border: 0;
  border-bottom: 2px solid rgba(200, 200, 200, 1);
}

.input-work:hover,
.input-work:active,
.input-work:focus {
  outline: none;
}

.responses-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
}

.respose-item {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  padding: 20px;
  border: 2px solid rgba(175, 180, 202, 0.5);
  border-radius: 5px;
}

@media (max-width: 800px) {
  .respose-item {
    display: flex;
    flex-direction: column;
    gap: 15px;
    -webkit-gap: 15px;
    padding: 15px;
    border: 2px solid rgba(175, 180, 202, 0.5);
    border-radius: 5px;
  }
}

.or-or {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.accept {
  font-size: var(--font-size);
  color: #19CB6B;
  font-weight: 500;
}

.no-accept {
  font-size: var(--font-size);
  color: #FF6666;
  font-weight: 500;
}

.right-block-nav {
  display: flex;
  flex-direction: row;
  gap: 25px;
  -webkit-gap: 25px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.right-block-nav-item {
  display: block;
  padding-bottom: 15px;
  border-bottom: 2px solid white;
  color: var(--blue-main);
  font-size: var(--font-size);
  font-weight: 600;
}

.right-block-link-no {
  color: var(--text-grey);
  font-weight: 500;
  font-size: var(--font-size);
  border-bottom: 2px solid rgba(175, 180, 202, 0);
}

.block-info-card {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 8px);
  gap: 20px;
  -webkit-gap: 20px;
  justify-content: space-between;
  padding: 15px 0 0 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.block-info-card-column {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 8px);
  padding: 15px 0 0 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.link-site {
  color: var(--blue-main);
  font-size: 16px;
  line-height: 18px;
  padding-left: 23px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_37___}) no-repeat;
  background-size: 18px auto;
  background-position: left center;
}

.link-mail {
  color: var(--blue-main);
  font-size: 16px;
  line-height: 18px;
  padding-left: 23px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_38___}) no-repeat;
  background-size: 18px auto;
  background-position: left center;
}

.link-call {
  color: var(--blue-main);
  font-size: 16px;
  line-height: 18px;
  padding-left: 23px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_39___}) no-repeat;
  background-size: 18px auto;
  background-position: left center;
}

.healine-info-block {
  color: var(--blue-main);
  font-size: 16px;
  line-height: 18px;
}

.first-message .city {
  font-size: 14px;
  line-height: calc(var(--font-size) + 4px);
}

.important-message {
  display: block;
  width: 100%;
  padding: var(--padding-btn);
  border: 0;
  border-radius: 5px;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
  color: white;
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-size: 24px 24px;
  background-position: left top;
  background-position-y: 20px;
  background-position-x: calc(var(--icon-padding) - 8px);
  background-repeat: no-repeat;
  background-color: #FF6666;
}

.comand-card {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  padding: 20px;
  background-color: white;
  border: 2px solid #81869752;
  border-radius: 5px;
  transition: ease-in-out 0.3s;
}

.comand-card:hover {
  border: 2px solid #dee8ff91;
  background-color: #dee8ff91;
  transition: ease-in-out 0.3s;
}

.comand-card-info {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 15px;
  -webkit-gap: 15px;
  align-items: center;
}

.comand-avatar {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 15px;
}

.comand-name {
  font-size: calc(var(--font-size) + 4px);
  font-weight: 600;
  line-height: calc(var(--font-size) + 8px);
  cursor: pointer;
}

.comand-description {
  font-size: var(--font-size);
  line-height: var(--font-size);
  color: var(--blue-main);
  font-weight: 500;
}

.comand-info-text {
  display: flex;
  flex-direction: column;
  gap: 5px;
  -webkit-gap: 5px;
}

.del-coamnd {
  display: block;
  width: 100%;
  padding: var(--padding-btn);
  border: 0;
  border-radius: 5px;
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  color: white;
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  background-size: auto var(--font-size);
  background-position: left center;
  background-position-x: var(--icon-padding);
  background-repeat: no-repeat;
  background-color: #FF6666;
}

.kurs {
  font-size: calc(var(--font-size) + 4px);
  line-height: calc(var(--font-size) + 4px);
  font-weight: 400;
}

.kurs::after {
  content: 'курс';
  font-weight: 400;
}

.education-stage {
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 8px);
  font-weight: 600;
}

.education-stage::before {
  content: 'Ступень образования: ';
  font-weight: 400;
}

.role-wrapper {
  position: relative;
  width: 100%;
  height: fit-content;
}

.input-role {
  position: relative;
  display: inline-block;
  width: 100%;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid rgba(175, 180, 202, 0.5);
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
}

.input-role:hover {
  position: relative;
  display: inline-block;
  width: 100%;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid var(--blue-main);
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
}

.btn-ok {
  position: absolute;
  display: block;
  /* width: 40px; */
  height: calc(100% - 10px);
  aspect-ratio: 1;
  top: 5px;
  right: 5px;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_33___}) no-repeat center center;
  background-color: var(--blue-main);
  border-radius: 5px;
  border: 0;
  font-size: var(--text-size);
  line-height: var(--text-lineheight);
  font-weight: 700;
  color: white;
  cursor: pointer;
  transition: ease-in-out 0.3s;
}

.btn-ok:hover {
  background-color: #174bce;
  transition: ease-in-out 0.3s;
}

.btn-change {
  position: absolute;
  display: block;
  /* width: 40px; */
  height: calc(100% - 10px);
  aspect-ratio: 1;
  top: 5px;
  right: 5px;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_41___}) no-repeat center center;
  background-color: var(--blue-main);
  border-radius: 5px;
  border: 0;
  font-size: var(--text-size);
  line-height: var(--text-lineheight);
  font-weight: 700;
  color: white;
  cursor: pointer;
}


.btn-ne-ok {
  position: absolute;
  display: block;
  /* width: 40px; */
  height: calc(100% - 10px);
  aspect-ratio: 1;
  top: 5px;
  right: 5px;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_40___}) no-repeat center center;
  background-color: #FF6666;
  border-radius: 5px;
  border: 0;
  font-size: var(--text-size);
  line-height: var(--text-lineheight);
  font-weight: 700;
  color: white;
  cursor: pointer;
}

.green {
  background-color: #B9FFD9;
}

.welcome {
  display: block;
  font-size: var(--font-size);
  line-height: var(--font-size);
  padding: 0 0 0 calc(var(--font-size) + 5px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_42___}) no-repeat left center;
  background-size: var(--font-size) auto;
}

.stage-button {
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  padding: var(--padding-input);
  border-radius: 5px;
  background-color: rgba(54, 110, 255, 0.1);
  border: 2px solid rgba(54, 110, 255, 0.1);
  cursor: pointer;
}

.stage-card-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.stage-card-heading {
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 600;
}

.stage-card-done {
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 500;
  color: var(--blue-main);
  padding-left: calc(var(--font-size) + 6px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_43___}) no-repeat left center;
  background-size: var(--font-size) auto;
}

.stage-card-fale {
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 500;
  color: #FF3D00;
  padding-left: calc(var(--font-size) + 6px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_44___}) no-repeat left center;
  background-size: var(--font-size) auto;
}

.stage-card-active {
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 500;
  color: var(--blue-main);
  padding-left: calc(var(--font-size) + 6px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_45___}) no-repeat left center;
  background-size: var(--font-size) auto;
}

.stage-card-name {
  font-size: calc(var(--font-size) + 8px);
  line-height: calc(var(--font-size) + 16px);
  text-align: left;
  font-weight: 600;
}

.stage-card-info-date {
  display: flex;
  flex-direction: row;
  gap: 5px;
  -webkit-gap: 5px;
  width: 100%;
}

.stage-card-date {
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 600;
}

.stage-button-done {
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  padding: var(--padding-input);
  border-radius: 5px;
  background-color: #00de6f0e;
  border: 2px solid #00de6f0e;
  cursor: pointer;
}

.stage-button-done .stage-card-active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_46___}) no-repeat left center;
  background-size: var(--font-size) auto;
}

.stage-button-fale {
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  padding: var(--padding-input);
  border-radius: 5px;
  background-color: #de004a1a;
  border: 2px solid #de004a1a;
  cursor: pointer;
}

.stage-button-done .stage-card-active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_46___}) no-repeat left center;
  background-size: var(--font-size) auto;
}

.stage-button-soon {
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  padding: var(--padding-input);
  border-radius: 5px;
  background-color: white;
  border: 2px solid rgba(175, 180, 202, 0.5);
  opacity: 0.6;
  filter: saturate(0);
  cursor: pointer;
}

.stage-button-soon .stage-card-active {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat left center;
  background-size: var(--font-size) auto;
}

.result {
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 600;
  color: var(--blue-main);
}

.result::after {
  content: ' баллов';
}

.telega {
  padding: var(--padding-input);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) no-repeat left center;
  background-size: calc(var(--font-size) + 4px) auto;
  background-position-x: 20px;
  padding-left: 50px;
  font-size: var(--font-size);
  font-weight: 600;
  line-height: var(--font-size);
  color: #28A8E9;
  background-color: rgba(208, 208, 255, 0.3);
  border-radius: 5px;
}

.block-input-flex-column {
  display: flex;
  border: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
}

.criteria {
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  padding: 20px;
  background-color: #ebebeb;
  border-radius: 5px;
}

.criteria-input {
  display: block;
  max-width: 130px;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid rgba(175, 180, 202, 0.5);
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
}

.add-criteria {
  display: flex;
  width: 50px;
  height: 49px;
  background-color: var(--blue-main);
  border: 0;
}

.delete-criteria {
  display: block;
  padding: var(--padding-input);
  padding-left: 10px;
  padding-right: 10px;
  border: 0;
  outline: 0;
  background: none;
}

.criteria .btn-main {
  background: var(--blue-main);
}

.summa-criteria {
  font-size: var(--font-size);
  color: black;
  font-weight: 700;
  color: var(--blue-main);
}

.summa-criteria:before {
  content: 'Итоговая сумма: ';
  color: black;
}

.spravka {
  position: fixed;
  bottom: 10px;
  right: 0px;
  z-index: 999;
}

.spravka-text {
  display: block;
  padding: 15px 15px;
  background-color: #366EFF;
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
  box-shadow: 2px 5px 30px #42507079;
  color: white;
  font-size: var(--font-size);
  line-height: var(--font-size);
  cursor: pointer;
}

.spravka-text-block {
  display: flex;
  flex-direction: column;
  background-color: white;
  box-shadow: 2px 5px 30px #42507079;
  border-radius: 10px;
  overflow: hidden;
}

.spravka-link {
  display: block;
  color: black;
  font-size: var(--font-size);
  line-height: var(--font-size);
  padding: 20px 30px;
}

.spravka-link:not(:last-child) {
  border-bottom: 1px solid #d3d3d3;
}

.spravka-link:hover {
  background-color: var(--blue-main);
  color: white;
}

.sorry-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  -webkit-gap: 30px;
  width: 100%;
  height: 100%;
  background: linear-gradient(147.75deg, #E7A4FF 0%, #001AFF 100%);
  background-size: cover;
  color: white;
}

.sorry-heading {
  font-size: 400px;
  line-height: 300px;
  font-weight: 700;
}

.sorry-text {
  font-size: 21px;
  line-height: 32px;
  width: 40vw;
  text-align: center;
}

.sorry-link {
  font-weight: 700;
  border-bottom: 2px solid rgb(255, 187, 0);
  color: rgb(255, 187, 0);
}

@media (max-width: 1000px) {
  .sorry-heading {
    font-size: 200px;
    line-height: 180px;
    font-weight: 700;
  }

  .sorry-text {
    font-size: 21px;
    line-height: 32px;
    width: 60vw;
    text-align: center;
  }

  .sorry-link {
    font-weight: 700;
    border-bottom: 2px solid rgb(255, 187, 0);
    color: rgb(255, 187, 0);
  }

}

@media (max-width: 600px) {
  .sorry-heading {
    font-size: 100px;
    line-height: 80px;
    font-weight: 700;
  }

  .sorry-text {
    font-size: 21px;
    line-height: 32px;
    width: 80vw;
    text-align: center;
  }

  .sorry-link {
    font-weight: 700;
    border-bottom: 2px solid rgb(255, 187, 0);
    color: rgb(255, 187, 0);
  }

}


.load-file-input {
  display: block;
  width: 100%;
  padding: var(--padding-btn);
  border: 0;
  border-radius: 5px;
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  color: white;
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  background-size: auto var(--font-size);
  background-position: left center;
  background-position-x: var(--icon-padding);
  background-repeat: no-repeat;
  background-color: var(--blue-main);
  margin-top: 15px;
}

.load-file-input:hover {
  background-color: #174bce;
  transition: ease-in-out 0.3s;
}

.load-file-hidden {
  display: none;
}

.settihgs-link {
  font-size: 15px;
  line-height: 15px;
  color: var(--blue-main);
  margin-top: 5px;
  cursor: pointer;
}

.container-ads {
  display: block;
  border: 1px solid #d3d3d3;
  border-radius: 10px;
  overflow: hidden;
}

.ads-input {
  padding: var(--padding-input);
  cursor: pointer;
  transition: ease-in-out 0.3s;
}

.ads-input:not(:last-child) {
  border-bottom: 1px solid #d3d3d3;
}

.ads-input:hover {
  background-color: var(--blue-main);
  color: white;
  transition: ease-in-out 0.3s;
}

.preview-background {
  background-color: var(--blue-main);
  color: white;
}

.preview-background:hover {
  background-color: #174bce;
  border: 2px solid #174bce;
}

.preview-background .btn-description {
  color: white;
}

.hidden {
  display: none;
}

.flex-btn-stage {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.btn-stage {
  padding: var(--padding-input);
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  background: none;
  border: 2px solid #81869752;
  border-radius: 5px;
  width: 100%;
}

.stage-name-heading {
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 600;
  color: var(--blue-main);
  text-transform: uppercase;
}

.stage-name-headline {
  font-size: calc(var(--font-size) + 2px);
  line-height: calc(var(--font-size) + 6px);
  text-align: left;
  font-weight: 500;
}

.delete-stage {
  display: block;
  width: fit-content;
  color: #FF6666;
  border-bottom: 1px solid #FF6666;
  cursor: pointer;
}

.blue-button {
  background-color: var(--blue-main);
}

.rating-users {
  display: block;
  width: fit-content;
  color: var(--blue-main);
  border-bottom: 1px solid var(--blue-main);
}

.block-rating {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  background-color: white;
  border-radius: 5px;
}

.block-rating-flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.left-block-rating {
  width: 100vw;
  display: flex;
  flex-direction: column;
  background-color: white;
}

.content-rating {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}

.main-list-center-rating {
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  /* width: var(--block-center); */
  padding: var(--block-padding);
  padding-top: var(--main-center-head);
  padding-bottom: 55px;
  width: 100%;
}

.rating-info {
  display: flex;
  padding: 20px 2px 30px 2px;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
}

.header-rating {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  width: 100%;
  height: var(--main-center-head);
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  -webkit-gap: 12px;
  padding: var(--block-padding);
  padding-top: 20px;
  padding-bottom: 0;
  background: linear-gradient(147.75deg, #d153ff 0%, #001AFF 100%);
}

.header-rating p {
  color: white;
}

.rating-row-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #42507079;
}

.rating-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #42507079;
}

.rating-cell-header {
  padding: 10px 5px 15px 5px ;
  font-weight: 600;
}

.rating-cell {
  padding: 10px 5px 15px 5px ;
  font-weight: 400;
}

.position {
  width: 10%;
}

.fio-rating {
  width: 25%;
}

.university {
  width: 13%;
}

.country {
  width: 13%;
}

.city-rating {
  width: 18%;
}

.point {
  width: 10%;
}

.yes-no-header {
  width: 10%;
}

.yes-no {
  width: 10%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.yes-no-label {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.text-label {
  margin-left: 5px;
}

.user-info-rating {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.btn-flex-rating {
  display: flex;
  flex-direction: row;
  gap: 10px;
  -webkit-gap: 10px;
}

.rating-btn {
  width: fit-content;
  padding: 10px 15px;
  border: 2px solid white;
  color: white;
}

.rating-end {
  width: fit-content;
}

.non-active-students {
  color: var(--blue-main);
  font-weight: 600;
}

.student-stat {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: white;
  border-radius: 5px;
}

.student-stat-fale {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #FF6666;
  border-radius: 5px;
}

.student-stat-wins {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #19CB6B;
  border-radius: 5px;
}

.student-stat-gold {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: rgb(177, 165, 96);
  border-radius: 5px;
}

.student-stat-silver {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: rgb(122, 122, 122);
  border-radius: 5px;
}

.student-stat-bronze {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: rgb(126, 78, 46);
  border-radius: 5px;
}

.student-stat-point {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: white;
  border-radius: 20px;
  overflow: hidden;
}

.name-stat {
  position: relative;
  font-size: 14px;
  line-height: 14px;
  font-weight: 700;
  text-transform: uppercase;
}

.name-stat-white {
  position: relative;
  font-size: 14px;
  line-height: 14px;
  font-weight: 700;
  color: white;
  text-transform: uppercase;
}

.number-stat {
  position: relative;
  font-size: 14px;
  line-height: 14px;
  font-weight: 700;
  color: var(--blue-main);
}

.number-stat-white {
  position: relative;
  font-size: 14px;
  line-height: 14px;
  font-weight: 700;
  color: white;
}

.point-graph {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 40%;
  height: 100%;
  background: linear-gradient(90.01deg, #366fff6c 0.01%, #fb00ff6c 49.61%, #FF3D00 99.21%);
  border-radius: 20px;
}

.point-min {
  z-index: 999;
  color: black;
}

.point-max {
  z-index: 999;
  color: black;
}

.description-stat {
  font-size: 13px;
  line-height: 20px;
}

.point-system {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}

.point-system-fact {
  font-weight: 600;
  color: var(--blue-main);
}

.point-system-max {
  font-weight: 600;
  color: var(--blue-main);
}

.stat-students-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.stat-students-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
  padding: 15px;
  background-color: white;
  border-radius: 5px;
  width: 48%;
  margin-bottom: 10px;
}

.stat-students-heading {
  font-size: var(--font-size);
  line-height: var(--font-size);
  color: black;
  font-weight: 600;
}

.stat-students-number {
  font-size: 32px;
  line-height: 32px;
  color: var(--blue-main);
}

.stat-students-noview {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  -webkit-gap: 10px;
  align-items: center;
}

.stat-students-noview-num {
  font-size: calc((var(--font-size) + 4px) * 2);
  line-height: calc((var(--font-size) + 4px) * 2);
  color: #FF6666;
  font-weight: 600;
}

.stat-students-noview-text {
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 4px);
}

.student-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
}

.student-info-kurs {
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--blue-main);
}

.student-info-facult {
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
}

.stat-challenge-num {
  font-size: calc((var(--font-size) + 4px) * 2);
  line-height: calc((var(--font-size) + 4px) * 2);
}

.btn-preview {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--padding-input);
  border: 0;
  border-radius: 5px;
  border: 2px solid var(--blue-main);
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  background: none;
  cursor: pointer;
  background-color: var(--blue-main);
  color: white;
  transition: ease-in-out 0.3s;
}

.btn .preview-backgroung:hover {
  background-color: #174bce;
  transition: ease-in-out 0.3s;
}

.number-registration {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.number-registration-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: white;
  border-radius: 20px;
  color: #33353a;
  transition: ease-in-out 0.3s;
}

.number-registration-line {
  display: block;
  height: 1px;
  width: calc((100% - 140px) / 2);
  background-color: #366EFF;
}

.number-reg {
  font-size: 18px;
  line-height: 18px;
  color: inherit;
  cursor: default;
}

.number-registration-item-active {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: var(--blue-main);
  border-radius: 20px;
  color: white;
  transition: ease-in-out 0.3s;
}

.number-reg-active {
  font-size: 18px;
  line-height: 18px;
  color: inherit;
  cursor: default;
}

.number-registration-item:hover {
  background-color: #174bce;
  color: white;
  transition: ease-in-out 0.3s;
}

.number-registration-item-active:hover {
  background-color: #174bce;
  color: white;
  transition: ease-in-out 0.3s;
}

.role-btn {
  background-color: white;
  border: 2px solid white;
  text-align: center;
  transition: ease-in-out 0.3s;
}

.role-btn:hover {
  background-color: var(--blue-main);
  color: white;
  border: 2px solid var(--blue-main);
}

.modal-message {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #23335cd7;
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
}

.modal-block-message {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  background-color: white;
  max-width: 320px;
  border-radius: 10px;
}

.modal-header {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #33353a28;
}

.modal-heading {
  font-size: 18px;
  line-height: 22px;
  font-weight: 600;
}

.modal-close {
  display: block;
  width: 22px;
  height: 22px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_47___}) no-repeat center center;
  background-size: 18px auto;
  cursor: pointer;
}

.modal-message-text {
  padding: 0 20px 20px;
  font-size: 18px;
}

.modal-link {
  color: var(--blue-main);
}

.reg-heading {
  font-size: 18px;
  color: black;
  font-weight: 600;
}

.legal-text {
  font-size: 14px;
  line-height: 18px;
}

.reg-anketa-block {
  max-width: var(--block-size);
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  position: fixed;
  top: 0;
  left: calc((100vw - var(--block-size)) / 2);
  bottom: 0;
  z-index: 2;
  overflow: hidden;
}

.menu-anketa {
  padding: var(--block-padding);
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  overflow: auto;
}

strong {
  font-weight: 700;
}

.text-editor-style a {
  color: var(--blue-main);
  text-decoration: underline;
  font-weight: 400;
}

.cert-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  padding: 20px;
  background-color: rgba(208, 208, 255, 0.3);
  border-radius: 5px;
}

@media (max-width: 800px) {
  .cert-card {
    display: flex;
    flex-direction: column;
    gap: 15px;
    -webkit-gap: 15px;
    padding: 15px;
    background-color: rgba(208, 208, 255, 0.3);
    border-radius: 5px;
  }
}

.cert-card-main {
  display: flex;
  flex-direction: row;
  gap: 15px;
  -webkit-gap: 15px;
  align-items: center;
  padding-bottom: 15px;
}

.del-cert {
  position: absolute;
  width: 18px;
  height: 18px;
  object-fit: contain;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.cert-preview {
  color: var(--blue-main);
  font-size: 14px;
  padding-left: calc(var(--font-size) + 15px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  background-repeat: no-repeat;
  background-size: auto 14px;
  background-position: left center;
  cursor: pointer;
}

.cert-info {
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 6px);
}

.cert-symbol {
  color: #001AFF;
}

.cert-image {
  display: none;
}

.cert-img-label {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 248px;
  height: 350px;
  padding: 30px;
  background-color: #78819750;
  border-radius: 10px;
  overflow: hidden;
}

.cert-img-info {
  position: relative;
  text-align: center;
  margin-bottom: 15px;
  color: white;
  z-index: 6;
}

.cert-link {
  position: relative;
  font-size: 14px;
  line-height: 14px;
  text-transform: uppercase;
  display: block;
  width: fit-content;
  padding: 10px 20px;
  color: white;
  background-color: var(--blue-main);
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
  z-index: 6;
}

.background-cert {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  object-fit: cover;
  z-index: 4;
}

.cert-transparent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #07163b7c;
  z-index: 5;
}

.cert-name-input {
  position: relative;
  display: flex;
  align-items: center;
  padding: var(--padding-input);
  width: 100%;
  background-color: rgb(226, 242, 255);
  color: black;
  transition: ease-in-out 0.2s;
  cursor: pointer;
}

.cert-name-input:hover {
  color: white;
  background-color: var(--blue-main);
}

.template {
  background-color: #2d56bd;
  padding: 30px;
  border-radius: 10px;
  color: white;
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
}

.template-heading {
  font-size: calc(var(--font-size) + 12px);
  line-height: calc(var(--font-size) + 12px);
  font-weight: 600;
}

.tamplate-name {
  background: #7a9eff5b;
  border: 2px solid #7a9eff5b;
  color: white;
}

.tamplate-name::placeholder {
  color: rgba(255, 255, 255, 0.521);
}

.template-logo {
  display: none;
}

.load-logo {
  padding: var(--padding-input);
  border: 2px solid rgba(255, 255, 255, 0.274);
  border-radius: 5px;
  cursor: pointer;
}

.template-text {
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 8px);
}

.flex-btn-template {
  display: flex;
  flex-direction: row;
  gap: 5px;
  -webkit-gap: 5px;
  align-items: center;
}

.template-dowload {
  padding: var(--padding-input);
  border: 2px solid var(--blue-main);
  border-radius: 5px;
  background-color: var(--blue-main);
}

.template-draft {
  display: block;
  width: fit-content;
  padding: 0 0 5px 0;
  background: none;
  border: 0;
  font-size: var(--font-size);
  line-height: var(--font-size);
  color: var(--text-grey);
  font-weight: 600;
  border-bottom: 1px dashed var(--text-grey);
}

.template-list {
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 8px);
  color: white;
}

ol {
  list-style-position: inside;
}

.width-btn {
  width: fit-content;
}

.date-time-block {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid rgb(255, 255, 255);
  background: white;
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
}

.start::before {
  width: 80px;
  content: 'Начало';
  color: var(--blue-main);
}

.end::before {
  width: 80px;
  content: 'Конец';
  color: var(--blue-main);
}

.date-stage {
  margin-right: auto;
}

.date-time-card {
  padding: 70px 30px 30px 30px;
  background-color: #e2ebff;
  position: relative;
  display: flex;
  border: 0;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
  max-width: 100%;
  border-radius: 10px;
}

.legend-date-time {
  position: absolute;
  top: 30px;
  display: block;
  max-width: 100%;
  font-size: var(--legend-size);
  line-height: var(--legend-size);
  padding-bottom: 10px;
  font-weight: 700;
}

.load-block {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #2d56bd;
  animation: anim 1s alternate ease-in-out infinite;
}

.load-sheet {
  text-align: center;
  font-size: 21px;
  color: white;
  font-weight: 600;
}

.load-text {
  text-align: center;
  font-size: var(--font-size);
  color: white;
  margin-top: 15px;
  font-weight: 300;
  margin-bottom: 20px;
  max-width: 380px;
  padding: 0 30px;
}

@keyframes anim {
  0% {
    background: #3766df;
  }

  100% {
    background: #582dbd;
  }
}

.circle-block {
  width: 90px;
  height: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
}

.circle-load {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background-color: white;
  animation: anima 1s alternate ease-in-out infinite;
}

.one-load {
  animation-delay: 0ms;
}

.two-load {
  animation-delay: 200ms;
}

.three-load {
  animation-delay: 400ms;
}

@keyframes anima {
  0% {
    background-color: rgba(255, 255, 255, 0.199);
  }

  100% {
    background-color: rgb(255, 255, 255);
  }
}

.cert-body {
  position: relative;
  background-color: #353535b7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  backdrop-filter: blur(60px);
  z-index: 888;
}

.close-window {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 35px;
  height: 35px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_40___}) no-repeat center center;
  background-size: contain;
  cursor: pointer;
}

.cert-top-block {
  position: relative;
  width: 100%;
  height: 71%;
  background-color: #000747;
  padding: calc(((var(--cert-height) / 2.83) * 2) / 12);
  padding-bottom: calc(((var(--cert-height) / 2.83) * 2) / 24);
  display: flex;
  flex-direction: column;
}

.cert-image-main {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.container-cert {
  position: relative;
  display: flex;
  flex-direction: column;
  height: var(--cert-height);
  width: calc((var(--cert-height) / 2.83) * 2);
  overflow: hidden;
  background-size: contain;
  margin: 0 auto;
}

.qr-cert-info {
  position: absolute;
  z-index: 2;
  top: 0;
  right: calc(((var(--cert-height) / 2.83) * 2) / 12);
  width: calc(((var(--cert-height) / 2.83) * 2) / 8);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1vh;
  -webkit-gap: 1vh;
}

.qr-cert {
  width: calc(((var(--cert-height) / 2.83) * 2) / 8);
  height: calc(((var(--cert-height) / 2.83) * 2) / 8);
  object-fit: contain;
}

.cert-number {
  font-size: calc(var(--cert-height) / 75);
  line-height: calc(var(--cert-height) / 75);
  font-weight: 400;
  color: white;
}

.cert-sheet-heading {
  position: relative;
  font-size: calc(var(--cert-height) / 28);
  line-height: calc(var(--cert-height) / 28);
  color: white;
  margin-bottom: calc(var(--cert-height) / 25);
  z-index: 2;
}

.cert-challenge-name {
  position: relative;
  z-index: 2;
  font-size: calc(var(--cert-height) / 31);
  font-weight: 700;
  color: white;
}

.cert-top-block-info {
  position: relative;
  z-index: 2;
  margin-top: auto;
  display: flex;
  flex-direction: column;
}

.cert-text-info {
  color: white;
  font-size: calc(var(--cert-height) / 40);
  line-height: calc(var(--cert-height) / 40);
}

.cert-top-block-name {
  font-size: calc(var(--cert-height) / 24.5);
  line-height: calc(var(--cert-height) / 24.5);
  font-weight: 700;
  color: white;
  margin-top: calc(var(--cert-height) / 80);
}

.cert-text-bottom {
  font-size: calc(var(--cert-height) / 57);
  line-height: calc(var(--cert-height) / 40);
  font-weight: 400;
  color: white;
  margin-top: calc(var(--cert-height) / 40);
}

.cert-bottom-block {
  position: relative;
  width: 100%;
  height: 30%;
  background-color: rgb(255, 255, 255);
  padding: calc(((var(--cert-height) / 2.83) * 2) / 12);
  padding-top: calc(((var(--cert-height) / 2.83) * 2) / 20);
  display: flex;
  flex-direction: column;
}

.cert-text-signatory {
  color: rgba(47, 39, 163, 0.822);
  font-size: calc(var(--cert-height) / 50);
  line-height: calc(var(--cert-height) / 50);
}

.cert-text-jobtitle {
  font-size: calc(var(--cert-height) / 60);
  line-height: calc(var(--cert-height) / 42);
  font-weight: 400;
  color: rgb(78, 78, 78);
  margin-top: calc(var(--cert-height) / 70);
  width: 60%;
}

.podpis {
  position: absolute;
  top: calc(((var(--cert-height) / 2.83) * 2) / 30);
  right: calc(((var(--cert-height) / 2.83) * 2) / 6);
  width: calc(((var(--cert-height) / 2.83) * 2) / 6);
  height: calc(((var(--cert-height) / 2.83) * 2) / 6);
  object-fit: contain;
  z-index: 3;
  mix-blend-mode: multiply;
}

.pechat {
  position: absolute;
  top: calc(((var(--cert-height) / 2.83) * 2) / 30);
  right: calc(((var(--cert-height) / 2.83) * 2) / 20);
  width: calc(((var(--cert-height) / 2.83) * 2) / 6);
  height: calc(((var(--cert-height) / 2.83) * 2) / 6);
  object-fit: contain;
  mix-blend-mode: multiply;
}

.podpisant-info {
  display: flex;
  flex-direction: column;
  padding-bottom: calc(((var(--cert-height) / 2.83) * 2) / 30);
  border-bottom: 0.2vh solid rgb(221, 221, 221);
}

.about-braim {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: calc(((var(--cert-height) / 2.83) * 2) / 30);
  align-items: center;
}

.about-braim-text {
  font-size: calc(((var(--cert-height) / 2.83) * 2) / 60);
}

.logo-cert {
  width: calc(((var(--cert-height-full) / 2.83) * 2) / 6);
  height: calc(((var(--cert-height-full) / 2.83) * 2) / 8);
  object-fit: contain;
}

.cert-body-full {
  position: relative;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  backdrop-filter: blur(60px);
  z-index: 888;
}

.container-cert-full {
  position: relative;
  display: flex;
  flex-direction: column;
  height: var(--cert-height-full);
  width: calc((var(--cert-height-full) / 2.83) * 2);
  overflow: hidden;
  background-size: contain;
  margin: 0 auto;
}

.cert-top-block-full {
  position: relative;
  width: 100%;
  height: 72%;
  background-color: #000747;
  padding: calc(((var(--cert-height-full) / 2.83) * 2) / 12);
  padding-bottom: calc(((var(--cert-height-full) / 2.83) * 2) / 24);
  display: flex;
  flex-direction: column;
}

.cert-image-main-full {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.container-cert-full {
  position: relative;
  display: flex;
  flex-direction: column;
  height: var(--cert-height-full);
  width: calc((var(--cert-height-full) / 2.83) * 2);
  overflow: hidden;
  background-size: contain;
  margin: 0 auto;
}

.qr-cert-info-full {
  position: absolute;
  z-index: 2;
  top: 0;
  right: calc(((var(--cert-height-full) / 2.83) * 2) / 12);
  width: calc(((var(--cert-height-full) / 2.83) * 2) / 8);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1vh;
  -webkit-gap: 1vh;
}

.qr-cert-full {
  width: calc(((var(--cert-height-full) / 2.83) * 2) / 8);
  height: calc(((var(--cert-height-full) / 2.83) * 2) / 8);
  object-fit: contain;
}

.cert-number-full {
  font-size: calc(var(--cert-height-full) / 75);
  line-height: calc(var(--cert-height-full) / 75);
  font-weight: 400;
  color: white;
}

.cert-sheet-heading-full {
  position: relative;
  font-size: calc(var(--cert-height-full) / 28);
  line-height: calc(var(--cert-height-full) / 28);
  color: white;
  margin-bottom: calc(var(--cert-height-full) / 25);
  z-index: 2;
}

.cert-challenge-name-full {
  position: relative;
  z-index: 2;
  font-size: calc(var(--cert-height-full) / 31);
  font-weight: 700;
  color: white;
}

.cert-top-block-info-full {
  position: relative;
  z-index: 2;
  margin-top: auto;
  display: flex;
  flex-direction: column;
}

.cert-text-info-full {
  color: white;
  font-size: calc(var(--cert-height-full) / 40);
  line-height: calc(var(--cert-height-full) / 40);
}

.cert-top-block-name-full {
  font-size: calc(var(--cert-height-full) / 24.5);
  line-height: calc(var(--cert-height-full) / 24.5);
  font-weight: 700;
  color: white;
  margin-top: calc(var(--cert-height-full) / 80);
}

.cert-text-bottom-full {
  font-size: calc(var(--cert-height-full) / 57);
  line-height: calc(var(--cert-height-full) / 40);
  font-weight: 400;
  color: white;
  margin-top: calc(var(--cert-height-full) / 40);
}

.cert-bottom-block-full {
  position: relative;
  width: 100%;
  height: 30%;
  background-color: rgb(255, 255, 255);
  padding: calc(((var(--cert-height-full) / 2.83) * 2) / 12);
  padding-top: calc(((var(--cert-height-full) / 2.83) * 2) / 20);
  display: flex;
  flex-direction: column;
}

.cert-text-signatory-full {
  color: rgba(47, 39, 163, 0.822);
  font-size: calc(var(--cert-height-full) / 50);
  line-height: calc(var(--cert-height-full) / 50);
}

.cert-text-jobtitle-full {
  font-size: calc(var(--cert-height-full) / 58);
  line-height: calc(var(--cert-height-full) / 42);
  font-weight: 400;
  color: rgb(78, 78, 78);
  margin-top: calc(var(--cert-height-full) / 70);
  width: 60%;
}

.podpis-full {
  position: absolute;
  top: calc(((var(--cert-height-full) / 2.83) * 2) / 30);
  right: calc(((var(--cert-height-full) / 2.83) * 2) / 6);
  width: calc(((var(--cert-height-full) / 2.83) * 2) / 6);
  height: calc(((var(--cert-height-full) / 2.83) * 2) / 6);
  object-fit: contain;
  z-index: 3;
  mix-blend-mode: multiply;
}

.pechat-full {
  position: absolute;
  top: calc(((var(--cert-height-full) / 2.83) * 2) / 30);
  right: calc(((var(--cert-height-full) / 2.83) * 2) / 20);
  width: calc(((var(--cert-height-full) / 2.83) * 2) / 6);
  height: calc(((var(--cert-height-full) / 2.83) * 2) / 6);
  object-fit: contain;
  mix-blend-mode: multiply;
}

.podpisant-info-full {
  display: flex;
  flex-direction: column;
  padding-bottom: calc(((var(--cert-height-full) / 2.83) * 2) / 30);
  border-bottom: 0.2vh solid rgb(221, 221, 221);
}

.about-braim-full {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 2vh;
  padding-top: calc(((var(--cert-height-full) / 2.83) * 2) / 30);
  align-items: center;
}

.about-braim-text-full {
  font-size: calc(((var(--cert-height-full) / 2.83) * 2) / 60);
}

.logo-cert-full {
  display: block;
  width: calc(((var(--cert-height-full) / 2.83) * 2) / 6);
  height: calc(((var(--cert-height-full) / 2.83) * 2) / 8);
  object-fit: contain;
}

.cert-stat {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: white;
  border-radius: 5px;
  cursor: pointer;
}

.cert-stat:hover {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: rgb(179, 205, 255);
  border-radius: 5px;
}

.year-search {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 15px;
  -webkit-gap: 15px;
  padding-bottom: 10px;
}

.year-cert-active {
  color: var(--blue-main);
  font-weight: 600;
  padding: 10px 0;
  font-size: 18px;
  line-height: 18px;
  border-bottom: 2px solid var(--blue-main);
}

.year-cert {
  color: var(--blue-main);
  font-weight: 600;
  padding: 10px 0;
  font-size: 18px;
  line-height: 18px;
  opacity: 50%;
}

.logo-braim-cert {
  display: flex;
  flex-direction: column;
  gap: 1vh;
  width: calc(var(--cert-height) / 9);
}

.logo-braim-cert img {
  display: block;
  width: calc(var(--cert-height) / 9);
  height: auto;
}

.logo-braim-cert-full {
  display: flex;
  flex-direction: column;
  gap: 1vh;
  width: calc(var(--cert-height-full) / 9);
}

.logo-braim-cert-full img {
  display: block;
  width: calc(var(--cert-height-full) / 9);
  height: auto;
}

.how-print {
  position: absolute;
  bottom: 20px;
  z-index: 940;
  padding: 15px 25px;
  color: white;
  background-color: var(--blue-main);
  border-radius: 5px;
}

.how-print-popup {
  position: absolute;
  width: 100vw;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #353535b7;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  backdrop-filter: blur(60px);
  z-index: 955;
}

.how-print-block-popup {
  position: relative;
  height: 80%;
  bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.how-print-info-text {
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 4px);
  color: white;
  margin-bottom: 15px;
  max-width: 600px;
  text-align: center;
  padding: 0 30px;
}

.how-print-info {
  display: block;
  height: 90%;
}

@media print
{
  .no-print, .no-print *
  {
    display: none !important;
  }
}

.without_ampm::-webkit-datetime-edit-ampm-field {
  display: none;
}
input[type=time]::-webkit-clear-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -ms-appearance:none;
  appearance: none;
  margin: -10px;
}

.settings-test {
  display: block;
  position: absolute;
  z-index: 8;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px 10px 45px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  background-position-x: 18px;
  background-position-y: center;
  background-repeat: no-repeat;
  background-color: #001AFF;
  background-size: 16px 16px;
  box-shadow: 2px 5px 30px #B9CDFF;
  border: 0;
  border-radius: 20px;
  color: white;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
}

.interest-item-theme {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  padding: 10px 15px;
  font-size: 14px;
  line-height: 14px;
  color: white;
  background-color: var(--blue-main);
  cursor: pointer;
  border-radius: 5px;
  transition: ease-in-out 0.3s;
}

.interest-item-theme:hover {
  background-color: #174bce;
  transition: ease-in-out 0.3s;
}

@media (max-width: 800px) {
  .interest-item-theme {
    display: inline-block;
    width: fit-content;
    padding: 10px 10px 10px 15px;
    font-size: 12px;
    line-height: 12px;
    color: white;
    background-color: var(--blue-main);
    border-radius: 5px;
  }
}

.close-white {
  display: inline-block;
  width: 14px;
  height: 14px;
  object-fit: contain;
  margin-left: 12px;

}

.plus-theme {
  background-color: #001AFF;
  color: white;
}

.theme-number::before {
  content: '/ ';
  margin-left: 8px;
}

.test-block-quiestion {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #d3dcf598;
  padding: 20px;
  border: 0;
  border-radius: 5px;
}

.test-legend {
  position: absolute;
  top: 15px;
}

.test-question {
  margin-top: 20px;
  background: none;
  font-size: calc(var(--font-size) + 6px);
  line-height: calc(var(--font-size) + 12px);
  outline: 0;
  border: 0;
}

.test-question:hover,
.test-question:focus,
.test-question:active {
  border: 0;
  outline: 0;
}

.load-image-test {
  display: none;
}

.load-image-test-block {
  padding-top: 15px;
  border-top: 2px solid #33353a33;
}

.load-image-test-btn {
  padding: 10px 0 10px 20px;
  font-size: var(--font-size);
  line-height: 18px;
  font-weight: 600;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_50___}) no-repeat left center;
  background-size: auto 18px;
}

.wrap-answer {
  display: flex;
  flex-direction: row;
  gap: 15px;
  -webkit-gap: 15px;
  align-items: center;
}

.ok-answer {
  width: 20px;
  height: 18px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_51___}) no-repeat center center;
  background-size: contain;
  cursor: pointer;
}

.del-answer {
  width: 20px;
  height: 18px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_52___}) no-repeat center center;
  background-size: contain;
  cursor: pointer;
}

.ok-answer:hover {
  width: 20px;
  height: 18px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_53___}) no-repeat center center;
  background-size: contain;
}

.ok-answer-checked {
  width: 20px;
  height: 18px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_53___}) no-repeat center center;
  background-size: contain;
}

.delete-answer {
  display: inline;
  width: fit-content;
  height: fit-content;
  color: #FF6666;
  border-bottom: 1px solid #FF6666;
}

.row-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  -webkit-gap: 15px;
}

@media (max-width: 900px) {
  .row-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    -webkit-gap: 15px;
  }
}

.btn-info {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  padding: var(--padding-input);
  background-color: #d3dcf598;
  border-radius: 5px;
}

.btn-info-heading {
  font-size: calc(var(--font-size) + 2px);
  line-height: calc(var(--font-size) + 2px);
  text-align: left;
  font-weight: 600;
  padding-left: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_54___}) no-repeat left center;
  background-size: auto calc(var(--font-size) + 2px);
}

.btn-info-heading-plus {
  font-size: calc(var(--font-size) + 2px);
  line-height: calc(var(--font-size) + 2px);
  font-weight: 600;
  padding-left: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_55___}) no-repeat left center;
  background-size: auto calc(var(--font-size) + 2px);
  cursor: pointer;
}

.btn-info-text {
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  text-align: left;
  white-space: pre-wrap;
}

.btn-info-link {
  color: var(--blue-main);
  border-bottom: 2px solid var(--blue-main);
}

.btn-info-settings {
  font-size: calc(var(--font-size) + 2px);
  line-height: calc(var(--font-size) + 2px);
  font-weight: 600;
  padding-left: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_56___}) no-repeat left center;
  background-size: auto calc(var(--font-size) + 2px);
}

.btn-info-edit {
  font-size: calc(var(--font-size) + 2px);
  line-height: calc(var(--font-size) + 2px);
  font-weight: 600;
  padding-left: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_57___}) no-repeat left center;
  background-size: auto calc(var(--font-size) + 2px);
  color: black;
}

.block-input-row {
  position: relative;
  display: flex;
  border: 0;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
  width: 100%;
}

.test-btn-change {
  display: block;
}

.row-wrapper-fieldset {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  -webkit-gap: 15px;
  border: 0;
  outline: 0;
}

@media (max-width: 900px) {
  .row-wrapper-fieldset {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    -webkit-gap: 15px;
  }
}

.test-theme-block {
  position: relative;
  background-color: white;
  padding: 30px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
}

@media (max-width: 1280px) {
  .test-theme-block {
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    -webkit-gap: 15px;
  }
}

@media (max-width: 800px) {
  .test-theme-block {
    background-color: white;
    padding: 15px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    -webkit-gap: 15px;
  }
}

.test-theme-form {
  position: relative;
  background-color: #d3dcf598;
  padding: 30px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
}

@media (max-width: 1280px) {
  .test-theme-form {
    background-color: #d3dcf598;
    padding: 20px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    -webkit-gap: 15px;
  }
}

@media (max-width: 800px) {
  .test-theme-form {
    background-color: #d3dcf598;
    padding: 15px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    -webkit-gap: 15px;
  }
}

.test-btn-change {
  background-color: #ffffff;
  border: 2px solid white;
  font-weight: 600;
  border: 2px solid #c2c2c2
}

.test-btn-change-active {
  padding-left: 50px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_53___}) no-repeat 20px center;
  background-size: auto 11px;
  background-color: #ffffff;
  border: 2px solid var(--blue-main);
  font-weight: 600;
  color: var(--blue-main);
}

.number-question {
  font-size: calc(var(--font-size) + 2px);
  line-height: calc(var(--font-size) + 2px);
  color: var(--blue-main);
  font-weight: 600;
  display: flex;
  flex-direction: row;
  gap: 5px;
  -webkit-gap: 5px;
  margin-bottom: 15px;
}

.number-question-text {
  font-size: calc(var(--font-size) + 2px);
  line-height: calc(var(--font-size) + 2px);
  color: var(--blue-main);
  font-weight: 600;
}

.test-point {
  color: var(--blue-main);
  font-weight: 600;
}

.test-point::before {
  content: ':';
  color: var(--blue-main);
}

.test-time {
  color: var(--blue-main);
  font-weight: 600;
}

.test-time::before {
  content: ':';
  color: var(--blue-main);
}

.btn-grey {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  background: #33353a77;
  border: 0;
  border-radius: 5px;
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 700;
  color: white;
  cursor: pointer;
  transition: ease-in-out 0.3s;
}

.container-img-test {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
}

.img-test-question-background {
  position: absolute;
  top: -10%;
  left: -10%;
  right: 0;
  bottom: 0;
  width: 120%;
  height: 120%;
  object-fit: cover;
  filter: blur(50px);
  z-index: 1;
  opacity: 50%;
}

.img-test-question {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.answer-button {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid rgba(175, 180, 202, 0.5);
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  cursor: pointer;
}

.answer-button:hover {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid var(--blue-main);
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  cursor: pointer;
}

.answer-button-active {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid var(--blue-main);
  background: var(--blue-main);
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
  color: white;
  cursor: pointer;
}

.img-load-block {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  -webkit-gap: 10px;
}

.img-load {
  display: block;
  width: 35px;
  height: 35px;
  object-fit: cover;
  border-radius: 5px;
}

.img-load-text {
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 4px);
  font-weight: 600;
}

.img-load-del {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.flex-button-pay {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 30px;
  -webkit-gap: 30px;
  width: 100%;
}

.btn-pay-invoice {
  display: block;
  font-size: var(--font-size);
  text-align: left;
  color: var(--blue-main);
  border-bottom: 1px solid var(--blue-main);
}

.requisites {
  background: rgba(27, 255, 57, 0.13);
}

.headline-balance {
  font-size: 60px;
  line-height: 60px;
  margin-top: 15px;
  font-weight: 600;
}

.headline-balance::after {
  content: '₽';
  font-size: 36px;
}

.btn-info-red {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  padding: var(--padding-input);
  background-color: #ff000021;
  border-radius: 5px;
}

.balance-red {
  background-color: #ff00001c;
}

.balance-green {
  background-color: #00ff9d1c;
}

.btn-info-heading-green {
  font-size: calc(var(--font-size) + 2px);
  line-height: calc(var(--font-size) + 2px);
  text-align: left;
  font-weight: 600;
  padding-left: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_58___}) no-repeat left center;
  background-size: auto calc(var(--font-size) + 2px);
}

.headline-tarif {
  font-size: calc(var(--font-size) + 6px);
  line-height: calc(var(--font-size) + 6px);
  font-weight: 600;
}

.btn-tarif-edit {
  display: block;
  font-size: var(--font-size);
  text-align: left;
  color: var(--blue-main);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_57___}) no-repeat left center;
  background-size: auto var(--font-size);
  padding-left: calc(var(--font-size) + 8px);
}

.tarif-about {
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  padding-top: 20px;
}

.tarif-about-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.tarif-about-item:not(:last-child) {
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.123);
}

.tarif-about-item:not(:first-child) {
  padding-top: 15px;
}

.tarif-about-text {
  font-size: 14px;
  line-height: 20px;
  max-width: 70%;
}

.tarif-about-num {
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
}

.headline-additional-service {
  padding-top: 20px;
  font-size: 21px;
  line-height: 28px;
  font-weight: 600;
}

.btn-info-heading-money {
  font-size: calc(var(--font-size) + 2px);
  line-height: calc(var(--font-size) + 2px);
  text-align: left;
  font-weight: 600;
  padding-left: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat left center;
  background-size: auto calc(var(--font-size) + 2px);
}

.btn-info-heading-money:after {
  content: '₽';
}

.flex-button-additional-service {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.pay-service-info {
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  font-weight: 600;
  padding-left: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_54___}) no-repeat left center;
  background-size: auto var(--font-size);
}

.pay-service-info-ok {
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  font-weight: 600;
  padding-left: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_58___}) no-repeat left center;
  background-size: auto var(--font-size);
}

.day-write-off-on {
  display: block;
  width: fit-content;
  padding: 10px 25px;
  background: #00074723;
  border-radius: 5px;
}

.date-month-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
  -webkit-gap: 30px;
  padding-top: 30px;
  margin-bottom: 30px;
}

.day-write-month {
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
}

.day-month-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
  -webkit-gap: 5px;
}

.day-write-off-summ {
  font-size: 36px;
  line-height: 36px;
  color: #FF6666;
}

.day-write-off-summ::before {
  content: '—';
}

.day-write-off-summ::after {
  content: '₽';
}

.day-failed-summ {
  font-size: 36px;
  line-height: 36px;
  color: #FF6666;
}

.day-failed-summ::after {
  content: '₽';
}

.day-write-on-summ {
  font-size: 36px;
  line-height: 36px;
  color: #00a35f;
}

.day-write-on-summ::before {
  content: '+';
}

.day-write-on-summ::after {
  content: '₽';
}

.day-write-off-desc {
  font-size: var(--font-size);
  line-height: var(--text-lineheight);
}

.pay-date-update {
  font-size: var(--font-size);
  line-height: var(--font-size);
  text-align: left;
  font-weight: 600;
  padding-left: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_45___}) no-repeat left center;
  background-size: auto var(--font-size);
}

.tarif-flex-status {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.container-schet {
  width: 1000px;
  margin: 0 auto;
}

.header-schet {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 20px 0;
  margin-bottom: 30px;
}

.logo-schet {
  display: block;
  width: 100px;
}

.schet-heading {
  font-size: 36px;
  line-height: 36px;
  font-weight: 600;
  margin-bottom: 30px;
}

.schet-text {
  font-size: 16px;
  line-height: 22px;
  color: #33353a;
  margin-bottom: 30px;
}

.button-print {
  padding: 10px 20px;
  color: white;
  background-color: var(--blue-main);
  border-radius: 5px;
  width: fit-content;
  margin-bottom: 30px;
}

.schet-text-red {
  font-size: 16px;
  line-height: 22px;
  color: rgb(250, 42, 52);
  margin-bottom: 30px;
}

.schet-block {
  padding: 30px 30px;
}

.schet-block-header {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.schet-rekvizity {
  width: 700px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
}

.schet-rekvizity-text {
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
}

.schet-qr {
  display: block;
  width: 180px;
  height: 180px;
  object-fit: contain;
}

.schet-heading-second {
  font-size: 21px;
  line-height: 21px;
  text-align: center;
  font-weight: 600;
}

.full-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  margin-bottom: 40px;
}

.table {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 10px;
  vertical-align: bottom;
}

.first-td-two {
  width: 10%
}

.first-td-three {
  width: 40%;
}

.schet-big-heading {
  font-size: 24px;
  line-height: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 30px;
}

.shet-number {
  font-weight: 600;
}

.sсhet-date {
  font-weight: 600;
}

.poluchatel::before {
  display: inline-block;
  content: 'Получатель: ';
  font-weight: 600;
}

.payer::before {
  display: inline-block;
  content: 'Плательщик: ';
  font-weight: 600;
}

.inn::before {
  display: inline-block;
  content: 'ИНН: ';
  font-weight: 600;
}

.small-col {
  width: 8%;
}

.big-col {
  width: 40%;
}

.schet-quant::before {
  display: inline-block;
  content: 'Всего наименований: ';
  font-weight: 600;
}

.schet-summ::before {
  display: inline-block;
  content: 'на сумму: ';
  font-weight: 600;
}

.rukovoditel {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 80px;
  padding-bottom: 150px;
}

.shalashniy {
  display: inline-block;
  font-size: 16px;
  line-height: 20px;
  width: fit-content;
}

.line {
  width: 50%;
  height: 1px;
  background-color: black;
}

.schet-podpis {
  position: absolute;
  top: -70px;
  left: 35%;
  display: block;
  width: 20%;
  mix-blend-mode: multiply;
}

.schet-pechat {
  position: absolute;
  top: -100px;
  left: 50%;
  display: block;
  width: 18%;
  mix-blend-mode: multiply;
}

@media print {
  .no-print {
    display: none;
  }
}

.wait-status {
  font-size: 36px;
  line-height: 36px;
  color: #696d77;
}

.wait-status::after {
  content: '₽';
}

.incorrect-tin {
  background-color: rgba(255, 0, 0, 0.151);
}

.checkbox-radio-center {
  position: relative;
  top: 0;
}

.label-checkbox-radio-center {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  -webkit-gap: 10px;
}

.rating-cell {
  padding: 10px 5px 15px 5px ;
  font-weight: 400;
}

.position {
  width: 5%;
}

.fio-rating {
  width: 20%;
}

.university {
  width: 10%;
}

.country {
  width: 10%;
}

.city-rating {
  width: 13%;
}

.point {
  width: 5%;
}

.percent {
  width: 5%;
}

.yes-no-header {
  width: 10%;
}

.max-bal-rating::before {
  content: 'Максимальное количество баллов: ';
  color: black;
}

.rating-print-settings {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #00074798;
  z-index: 999;
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  display: flex;
}

.rating-print-export {
  width: fit-content;
  padding: 40px;
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
}

.rating-print-fieldset {
  width: fit-content;
  display: flex;
  flex-direction: row;
  gap: 20px;
  -webkit-gap: 20px;
  align-items: center;
  padding: 10px 20px 20px 20px;
  border-radius: 5px;
}

.rating-print-label {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  -webkit-gap: 10px;
}

.btn-grey {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  background: #b7b9ca;
  border: 0;
  border-radius: 5px;
  font-size: var(--text-size);
  line-height: var(--text-lineheight);
  font-weight: 700;
  color: white;
  cursor: pointer;
}

.rating-export-btn {
  padding: 10px 20px;
  width: fit-content;
}

.rating-export-wrapper {
  display: flex;
  flex-direction: row;
  gap: 10px;
  -webkit-gap: 10px;
}

.block-print-export {
  padding: 50px;
}

.text-block-print-export {
  display: flex;
  flex-direction: column;
  gap: 30px;
  -webkit-gap: 30px;
  margin-bottom: 30px;
}

.heading-print-export {
  font-size: 28px;
  font-weight: 600;
  text-align: center;
}

.date-location-print-export {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.info-text-print-export {
  padding: 40px;
  border: 2px solid black;
  font-size: 18px;
  line-height: 28px;
  border-radius: 5px;
}

.jury-print-export {
  display: flex;
  flex-direction: column;
  gap: 30px;
  -webkit-gap: 30px;
  margin-bottom: 50px;
  padding: 40px;
  border: 2px solid black;
  border-radius: 5px;
}

.heading-jury-print-export {
  font-size: 28px;
  line-height: 28px;
  font-weight: 600;
}

.jury-print-export-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
}

.jury-print-export-item {
  width: 23%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
}

.jury-print-export-item:last-child {
  margin-right: auto;
}

.name-jury-print-expor {
  font-size: 21px;
  line-height: 21px;
  font-weight: 600;
}

.block-print-export-stam-official {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.print-export-first-last-name {
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
}

.print-export-dolzhnost {
  font-size: 18px;
  margin-top: 5px;
  font-weight: 400;
}

.stam-official {
  position: absolute;
  right: 0;
  display: block;
  height: 200px;
  width: auto;
  mix-blend-mode: multiply;
}

.stam-official-podpis {
  display: block;
  position: absolute;
  left: 0;
  height: 150px;
  width: auto;
  margin-right: auto;
}

.block-print-export-stam {
  position: relative;
  width: 350px;
  height: 280px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.button-add-print {
  display: block;
  position: absolute;
  z-index: 8;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px 10px 45px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
  background-position-x: 18px;
  background-position-y: center;
  background-repeat: no-repeat;
  background-color: #001AFF;
  box-shadow: 2px 5px 30px #B9CDFF;
  border: 0;
  border-radius: 20px;
  color: white;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
}

.fixed-position {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.stage-card-new {
  display: flex;
  flex-direction: column;
  gap: 30px;
  -webkit-gap: 30px;
  padding: var(--padding-input);
  border-radius: 5px;
  background-color: rgb(224, 233, 255);
}

.stage-card-new-info {
  cursor: pointer;
}

.stage-card-new-false {
  display: flex;
  flex-direction: column;
  gap: 30px;
  -webkit-gap: 30px;
  padding: var(--padding-input);
  border-radius: 5px;
  background-color: white;
  border: 2px solid red;
}

.stage-card-new-work {
  display: flex;
  flex-direction: column;
  gap: 30px;
  -webkit-gap: 30px;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid rgba(175, 180, 202, 0.5);
}

.stage-card-new-future {
  display: flex;
  flex-direction: column;
  gap: 30px;
  -webkit-gap: 30px;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid rgba(175, 180, 202, 0.5);
  opacity: 0.5;
}

.stage-card-new-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.status-stage {
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  color: var(--text-grey);
}

.status-stage-admin {
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  color: var(--text-grey);
}

.status-stage-admin::before {
  content: 'Статус: ';
  font-weight: 500;
}

.status-stage-result {
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  color: var(--blue-main);
}

.graph {
  position: relative;
  display: block;
  width: 100%;
  margin-top: 20px;
}

.graph-line-container {
  position: relative;
  display: block;
  width: 100%;
  height: 10px;
  background-color: #c7c7c7;
  border-radius: 5px;
  overflow: hidden;
}

.graph-line-line {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: linear-gradient(90.01deg, #366fff6c 0.01%, #fb00ff6c 49.61%, #FF3D00 99.21%);
  width: 80%;
  border-radius: 5px;
}

.graph-line-false {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  background: red;
  width: 30%;
  border-radius: 5px;
}

.graph-line-result {
  margin-top: 10px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}

.graph-line-result::before {
  content: 'Итоговый результат: ';
  font-weight: 400;
}

.graph-line-result-jury {
  margin-top: 10px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}

.graph-line-result-jury::before {
  content: 'Ваша оценка: ';
  font-weight: 400;
}

.graph-line-projects-jury {
  margin-top: 10px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 20px;
}

.graph-line-projects-jury::before {
  content: 'Вы оцениили: ';
  font-weight: 400;
}

.stage-card-new-heading {
  width: fit-content;
  font-size: 21px;
  line-height: 28px;
  font-weight: 600;
  margin-bottom: 10px;
  cursor: pointer;
}

.stage-card-new-text {
  font-size: 14px;
  line-height: 20px;
  margin-top: 20px;
}

.stage-card-new-wrapper-link {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  -webkit-gap: 20px;
}

.card-standart-link {
  display: block;
  width: fit-content;
  font-size: 12px;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--blue-main);
  font-weight: 600;
  padding-bottom: 5px;
  cursor: pointer;
  border-bottom: 1px solid var(--blue-main);
}

.card-standart-link-false {
  display: block;
  width: fit-content;
  font-size: 12px;
  line-height: 12px;
  text-transform: uppercase;
  color: red;
  font-weight: 600;
  padding-bottom: 5px;
  border-bottom: 1px solid red;
  cursor: pointer;
}


.stage-card-new-gap {
  width: fit-content;
  display: flex;
  flex-direction: row;
  padding: 10px 20px;
  background-color: white;
  gap: 5px;
  -webkit-gap: 5px;
  border-radius: 20px;
  cursor: pointer;
}

.stage-card-new-gap-red {
  width: fit-content;
  display: flex;
  flex-direction: row;
  padding: 10px 20px;
  background-color: red;
  color: white;
  gap: 5px;
  -webkit-gap: 5px;
  border-radius: 20px;
  cursor: pointer;
}

.stage-card-new-gap-work {
  width: fit-content;
  display: flex;
  flex-direction: row;
  padding: 10px 20px;
  background-color: #d3d7ff;
  gap: 5px;
  -webkit-gap: 5px;
  border-radius: 20px;
  cursor: pointer;
}

.stage-card-new-date {
  font-weight: 600;
}

.stage-card-new-comand {
  font-weight: 600;
}

.rating-challenge-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
  -webkit-gap: 30px;
}

.rating-challenge-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.rating-num {
  font-size: calc(var(--font-size) + 4px);
  font-weight: 600;
  line-height: calc(var(--font-size) + 8px);
}

.rating-num::after {
  content: ' баллов';
}

.rating-criterion {
  font-size: var(--font-size);
  line-height: var(--font-size);
}

.rating-challenge-avatar {
  display: block;
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 50px;
}

.rating-challenge-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  -webkit-gap: 15px;
}

.rating-challenge-user {
  display: flex;
  flex-direction: column;
  gap: 5px;
  -webkit-gap: 5px;
}

.rating-challenge-name {
  font-size: 16px;
  line-height: 16px;
  text-transform: uppercase;
  font-weight: 700;
}

.rating-challenge-place {
  display: block;
  width: fit-content;
  font-size: 16px;
  line-height: 16px;
  padding: 5px 10px;
  background-color: #dde4f5;
  border-radius: 5px;
}

.rating-chellenge-num {
  display: block;
  width: fit-content;
  padding: 5px 10px;
  background-color: var(--blue-main);
  font-size: 18px;
  line-height: 18px;
  font-weight: 600;
  color: white;
  border-radius: 20px;
}

.myresults-total {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.myresults-total-heading {
  font-size: 21px;
  line-height: 21px;
  font-weight: 600;
}

.myresults-total-heading-num {
  font-size: 21px;
  line-height: 21px;
  font-weight: 600;
  color: var(--blue-main);
}

.myresults-stage {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
}

.my-results-stage-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  -webkit-gap: 10px;
}

.myresults-stage-heading {
  font-size: 21px;
  line-height: 21px;
  font-weight: 600;
  height: fit-content;
}

.content-new {
  display: inline-block;
  width: fit-content;
  height: fit-content;
  color: var(--blue-main);
  font-weight: 600;
}

.content-new:hover {
  display: inline-block;
  width: fit-content;
  height: fit-content;
  color: var(--blue-main);
  font-weight: 600;
}

.red-color {
  color: red;
}

.link-landing {
  position: absolute;
  top: 20px;
  right: 20px;
  display: block;
  width: 25px;
  height: 25px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_60___}) center center no-repeat;
  background-size: contain;
}

.button-add-question {
  display: block;
  position: absolute;
  z-index: 8;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px 10px 45px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  background-position-x: 18px;
  background-position-y: center;
  background-repeat: no-repeat;
  background-color: #001AFF;
  box-shadow: 2px 5px 30px #B9CDFF;
  border: 0;
  border-radius: 20px;
  color: white;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
}

.rating-profile {
  /* border-radius: 15px; */
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  padding: var(--user-profile-padding);
  border-radius: 30px;
  /* border: 2px solid #d1d1d3; */
  background-color: rgba(175, 197, 247, 0.171);
}

.block-nav-list {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 15px;
}

.block-nav-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
  background-color: rgba(175, 197, 247, 0.171);
  border-radius: 15px;
  width: 48%;
  cursor: pointer;
}

.block-nav-img {
  width: 30px;
  height: 30px;
  object-fit: contain;
  margin-right: 15px;
}

.block-nav-item .block-nav-img {
  filter: saturate(50%);
  opacity: 70%;
  transition: ease-in-out 0.3s;
}

.block-nav-item:hover .block-nav-img {
  filter: saturate(100%);
  opacity: 100%;
  transition: ease-in-out 0.3s;
}

.block-nav-heading {
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.block-nav-text {
  font-size: 13px;
  line-height: 16px;
  font-weight: 500;
  color: #33353a;
}

.user-profile-main-block {
  display: flex;
  flex-direction: row;
  gap: 20px;
  -webkit-gap: 20px;
  align-items: center;
}

.user-profile-rating {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  -webkit-gap: 5px;
}

.user-profile-rating-info {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.user-profile-rating-status-block {
  display: flex;
  flex-direction: row;
  gap: 10px;
  -webkit-gap: 10px;
}

.raring-graph {
  position: relative;
  width: 100%;
  height: 10px;
  background-color: #e2e2e2;
  border-radius: 5px;
  overflow: hidden;
}

.rating-graph-line {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 68%;
  background: linear-gradient(117deg, #366EFF 0%, #FA00FF 50%, #FF3D00 100%);
  border-radius: 5px;
}

.user-profile-rating-num {
  font-size: 16px;
  line-height: 22px;
  padding-left: 27px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_62___}) left center no-repeat;
  background-size: 22px 22px;
}

.grade-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  -webkit-gap: 8px;
}

.fieldset-hidden {
  outline: none;
  border: 0;
}

.label-jury {
  display: flex;
  flex-direction: row;
  gap: 10px;
  -webkit-gap: 10px;
  align-items: center;
}

.label-jury-text {
  font-size: var(--font-size);
  line-height: var(--font-size);
}

.button-add-rate {
  display: block;
  position: absolute;
  z-index: 8;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px 10px 20px;
  background-color: #001AFF;
  box-shadow: 2px 5px 30px #B9CDFF;
  border: 0;
  border-radius: 20px;
  color: white;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  cursor: pointer;
}

.btn-non-check {
  position: absolute;
  display: block;
  /* width: 40px; */
  height: calc(100% - 10px);
  aspect-ratio: 1;
  top: 5px;
  right: 5px;
  bottom: 0;
  background: none;
  border-radius: 5px;
  border: 0;
  font-size: var(--text-size);
  line-height: var(--text-lineheight);
  font-weight: 700;
  color: white;
  cursor: pointer;
}

.active-link-red {
  border-bottom: 2px solid var(--blue-main);
  color: rgb(139, 0, 0);
}

.btn-blue-width {
  display: block;
  width: fit-content;
  padding: var(--padding-input);
  background: var(--blue-main);
  border: 0;
  border-radius: 5px;
  font-size: var(--text-size);
  line-height: var(--text-lineheight);
  font-weight: 700;
  color: white;
  cursor: pointer;
}

.green-challenge-landing {
  display: inline-block;
  padding: 10px 20px 10px 40px;
  color: white;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_63___}) no-repeat left center;
  background-size: var(--font-size) auto;
  background-position-x: 15px;
  background-color: rgb(6, 158, 112);
  width: fit-content;
  border-radius: 5px;
  border: none;
  transition: ease-in-out 0.3s;
}

.green-challenge-card {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  padding: 20px;
  background-color: rgba(6, 158, 112, 0.116);
  border-radius: 5px;
}

.btn-main-green {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  background-color: rgb(6, 158, 112);
  border: 0;
  border-radius: 5px;
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 700;
  color: white;
  cursor: pointer;
  transition: ease-in-out 0.3s;
}

.btn-landing {
  display: block;
  width: 100%;
  padding: var(--padding-input);
  background-color: var(--blue-main);
  border: 0;
  border-radius: 5px;
  font-size: var(--font-size);
  line-height: var(--font-size);
  font-weight: 700;
  color: white;
  cursor: pointer;
  transition: ease-in-out 0.3s;
}

.load-image-design-block {
  padding-top: 15px;
}

.load-image-design {
  display: none;
}

.img-load-design {
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 4px);
  font-weight: 600;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.play-video-test {
  display: block;
  height: 20px;
  width: auto;
}

.video-popup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #00074798;
  z-index: 999;
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
}

.container-video-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 80%;
}

.video-popup-youtube {
  display: block;
  width: 100%;
  height: 100%;
}

.modul-list{
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
}

.modul-item {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  padding: 20px;
  border: 2px solid rgba(175, 180, 202, 0.5);
  border-radius: 5px;
}

@media (max-width: 800px) {
  .modul-item {
    display: flex;
    flex-direction: column;
    gap: 15px;
    -webkit-gap: 15px;
    padding: 15px;
    border: 2px solid rgba(175, 180, 202, 0.5);
    border-radius: 5px;
  }
}

.modul-item-check {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  padding: 20px;
  border: 2px solid #366fff33;
  border-radius: 5px;
  background-color: #366fff33;
}

.link-materials {
  position: relative;
  z-index: 50;
  display: block;
  width: fit-content;
  font-size: var(--font-size);
  line-height: var(--font-size);
  padding-bottom: 5px;
  color: var(--blue-main);
  border-bottom: 1px solid var(--blue-main);
}

.link-materials:hover {
  color: blue;
  border-bottom: 1px solid blue;
}

.course-settings {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  padding: var(--padding-input);
  background-color: #d3dcf598;
  border-radius: 5px;
  cursor: pointer;
}

.loopa {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  width: 30px;
  height: 30px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_64___}) center center no-repeat;
  background-size: 30px 30px;
  background-color: rgba(0, 0, 0, 0.356);
}

.flag-path {
  fill: red;
}

.flag-time:nth-child(2n) .flag-form .flag-path {
  fill: var(--blue-main);
}

.flag-time:nth-child(3n) .flag-form .flag-path {
  fill: blue;
}

.flag-time:nth-child(4n) .flag-form .flag-path {
  fill: green;
}

.flag-time:nth-child(5n) .flag-form .flag-path {
  fill: orange;
}

.flag-time:nth-child(6n) .flag-form .flag-path {
  fill: rgb(212, 0, 255);
}

.container-ctf {
  width: 100vw;
  margin: 0 auto;
  padding: 60px 2vw;
  background-color: #edf1f3;
}

.ctf-list {
  display: flex;
  flex-direction: column;
}

.ctf-item {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ctf-item:nth-child(2n) {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: black;
}

.ctf-user {
  display: flex;
  flex-direction: row;
  gap: 10px;
  -webkit-gap: 10px;
  width: 150px;
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
}

.flag-time {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}

.flag-form {
  position: relative;
}

.header-dashboard {
  width: 100vw;
  padding: 20px 2.5vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-bottom: 1px solid rgb(222, 222, 222);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}

.dashboard {
  background-color: rgb(221, 225, 235);
}

.container-dashboard {
  width: 95vw;
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
  margin: 0 auto;
  padding-top: 80px;
}

.logo-braim-dash {
  display: block;
  height: 20px;
}

.dashboard-item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 50px 30px 20px 30px;
  background-color: white;
  border-radius: 10px;
}

/* .dashboard-item:nth-child(2n) {
  background-color: rgb(221, 225, 235);
} */

.ctf-name-comand {
  position: absolute;
  top: 10px;
  left: 10px;
  display: block;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 14px;
  line-height: 14px;
  text-transform: uppercase;
  color: white;
  background-color: var(--blue-main);
}

.ctf-rating {
  position: absolute;
  top: 10px;
  right: 10px;
  display: block;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 14px;
  line-height: 14px;
  text-transform: uppercase;
  color: white;
  background-color: red;
}

.block-points-ctf {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 30px;
  cursor: pointer;
}

ctf-line-time {
  position: absolute;
  z-index: 1;
  top: 14px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #b5b8cf;
}

.point-ctf {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 3;
  height: 30px;
  width: 30px;
  background-color: #FF3D00;
  border-radius: 15px;
}

.ctf-rating-point {
  display: block;
  position: absolute;
  top: 10px;
  left: 10px;
  width: 10px;
  height: 10px;
  background-color: #ff9b7d;
  border-radius: 10px;
}

.ctf-rating-top::after {
  content: ' / ';
}


.flag::before {
  width: 80px;
  content: 'Флаг';
  color: var(--blue-main);
}

.end::before {
  width: 80px;
  content: 'Конец';
  color: var(--blue-main);
}

.link-flag {
  display: block;
  padding: 15px 20px 15px 43px;
  width: fit-content;
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 6px);
  font-weight: 800;
  color: white;
  text-transform: uppercase;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_60___}) no-repeat left center;
  background-size: auto calc(var(--font-size) + 6px);
  background-position-x: 15px;
  background-color: var(--blue-main);
  border-radius: 5px;
}

.stage-button-new {
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid rgba(63, 63, 63, 0.1);
  cursor: pointer;
}

.ctf-main-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  background-color: white;
  border: 2px solid rgba(63, 63, 63, 0.1);
  padding: var(--padding-input);
  border-radius: 10px;
  -webkit-border-radius: 10px;
}

.ctf-heading {
  font-size: 28px;
  line-height: 33px;
  font-weight: 800;
  color: var(--blue-main);
}

.ctf-main-info-rating {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  -webkit-gap: 20px;
}

.ctf-main-info-rating-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
  padding: var(--padding-input);
  background-color: rgb(232, 235, 241);
  border-radius: 10px;
  -webkit-border-radius: 10px;
  border: 2px solid rgba(63, 63, 63, 0.1);
  color: black;
  width: calc((100% - 20px) / 2);
}

@media (max-width: 950px) {
  .ctf-main-info-rating {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    -webkit-gap: 20px;
  }

  .ctf-main-info-rating-info {
    width: 100%;
  }
}

.ctf-rating-num {
  font-size: 28px;
  line-height: 28px;
  font-weight: 800;
  color: var(--blue-main);
}

.ctf-main-text {
  font-size: var(--font-size);
  line-height: var(--text-lineheight);
}

.flag-path {
  fill: red;
}

.flag-time:nth-child(2n) .flag-form .flag-path {
  fill: var(--blue-main);
}

.flag-time:nth-child(3n) .flag-form .flag-path {
  fill: blue;
}

.flag-time:nth-child(4n) .flag-form .flag-path {
  fill: green;
}

.flag-time:nth-child(5n) .flag-form .flag-path {
  fill: orange;
}

.flag-time:nth-child(6n) .flag-form .flag-path {
  fill: rgb(212, 0, 255);
}

.container-ctf {
  width: 100vw;
  margin: 0 auto;
  padding: 60px 2vw;
  background-color: #edf1f3;
}

.ctf-list {
  display: flex;
  flex-direction: column;
}

.ctf-item {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ctf-item:nth-child(2n) {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: black;
}

.ctf-user {
  display: flex;
  flex-direction: row;
  gap: 10px;
  -webkit-gap: 10px;
  width: 150px;
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
}

.flag-time {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}

.flag-form {
  position: relative;
}

.header-dashboard {
  width: 100vw;
  padding: 20px 2.5vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-bottom: 1px solid rgb(222, 222, 222);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

.dashboard {
  background-color: rgb(221, 225, 235);
}

.container-dashboard {
  position: relative;
  width: 95vw;
  display: flex;
  flex-direction: column;
  gap: 30px;
  -webkit-gap: 30px;
  margin: 0 auto;
  padding-top: 80px;
  padding-bottom: 80px;
}

.wrap-dash {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 30px;
  -webkit-gap: 30px;
  width: 100%;
}

.logo-braim-dash {
  display: block;
  height: 20px;
}

/* .dashboard-item:nth-child(2n) {
  background-color: rgb(221, 225, 235);
} */

.ctf-name-comand {
  position: absolute;
  top: 10px;
  left: 10px;
  display: block;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 14px;
  line-height: 14px;
  text-transform: uppercase;
  color: white;
  background-color: var(--blue-main);
}

.ctf-rating {
  position: absolute;
  top: 10px;
  right: 10px;
  display: block;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 14px;
  line-height: 14px;
  text-transform: uppercase;
  color: white;
  background-color: red;
}

.block-points-ctf {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 30px;
  cursor: pointer;
}

ctf-line-time {
  position: absolute;
  z-index: 1;
  top: 14px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #b5b8cf;
}

.point-ctf {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 3;
  height: 30px;
  width: 30px;
  background-color: #FF3D00;
  border-radius: 15px;
}

.ctf-rating-point {
  display: block;
  position: absolute;
  top: 10px;
  left: 10px;
  width: 10px;
  height: 10px;
  background-color: #ff9b7d;
  border-radius: 10px;
}

.ctf-rating-top::after {
  content: ' / ';
}


.flag::before {
  width: 80px;
  content: 'Флаг';
  color: var(--blue-main);
}

.end::before {
  width: 80px;
  content: 'Конец';
  color: var(--blue-main);
}

.link-flag {
  display: block;
  padding: 15px 20px 15px 43px;
  width: fit-content;
  font-size: var(--font-size);
  line-height: calc(var(--font-size) + 6px);
  font-weight: 800;
  color: white;
  text-transform: uppercase;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_60___}) no-repeat left center;
  background-size: auto calc(var(--font-size) + 6px);
  background-position-x: 15px;
  background-color: var(--blue-main);
  border-radius: 5px;
}

.stage-button-new {
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  padding: var(--padding-input);
  border-radius: 5px;
  border: 2px solid rgba(63, 63, 63, 0.1);
  cursor: pointer;
}

.ctf-main-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  background-color: white;
  border: 2px solid rgba(63, 63, 63, 0.1);
  padding: var(--padding-input);
  border-radius: 10px;
  -webkit-border-radius: 10px;
}

.ctf-heading {
  font-size: 28px;
  line-height: 33px;
  font-weight: 800;
  color: var(--blue-main);
}

.ctf-main-info-rating {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  -webkit-gap: 20px;
}

.ctf-main-info-rating-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
  padding: var(--padding-input);
  background-color: rgb(232, 235, 241);
  border-radius: 10px;
  -webkit-border-radius: 10px;
  border: 2px solid rgba(63, 63, 63, 0.1);
  color: black;
  width: calc((100% - 20px) / 2);
}

@media (max-width: 950px) {
  .ctf-main-info-rating {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    -webkit-gap: 20px;
  }

  .ctf-main-info-rating-info {
    width: 100%;
  }
}

.ctf-rating-num {
  font-size: 28px;
  line-height: 28px;
  font-weight: 800;
  color: var(--blue-main);
}

.ctf-main-text {
  font-size: var(--font-size);
  line-height: var(--text-lineheight);
}

.moadl-dashboard {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background-color: #00074798;
  backdrop-filter: blur(20px);
}

.modal-container-dashboard {
  width: 400px;
  background-color: white;
  padding: var(--padding-input);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
}

.graph-container {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 30px;
  -webkit-gap: 30px;
  /* background-color: #000747; */
}

.graph-vert-line {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 0;
  bottom: 30px;
  height: calc(100% - 40px);
  width: 40px;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  justify-content: space-between;
  border-right: 1px solid #696d7765;
}

.graph-vert-item {
  text-align: right;
  display: block;
  width: 100%;
  height: fit-content;
  padding-right: 5px;
  font-size: 10px;
  line-height: 10px;
}

.graph-vert-item:first-child {
  height: fit-content;
}


.graph-gor-line {
  position: absolute;
  left: 50px;
  bottom: 0;
  right: 0;
  height: 40px;
  width: calc(100% - 70px);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  border-top: 1px solid #696d7765;
}

.graph-gor-item {
  position: relative;
  display: block;
  width: 100%;
  height: 40px;
}

.dash-line-time {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 1px;
  height: 15px;
  background-color: #696d7765;
}

.graph-gor-item:last-child {
  width: fit-content;
}

.dott-graph {
  display: block;
  width: 30px;
  height: 30px;
  position: absolute;
  left: 20%;
  top: 50%;
  font-size: 60px;
  background-color: red;
  z-index: 999;
}

canvas {
  background: none;
}

.grapth-dot-list {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
}

.graph-dot {
  display: block;
  position: absolute;
  z-index: 15;
  width: 10px;
  height: 10px;
  transform: translate(-5px, -5px);
  border-radius: 5px;
  cursor: pointer;
}

.graph-dot-1 {
  z-index: 11;
}

.graph-dot-2 {
  z-index: 10;
}

.graph-dot-3 {
  z-index: 9;
}

.graph-dot-4 {
  z-index: 8;
}

.graph-dot-5 {
  z-index: 7;
}

.graph-dot-6 {
  z-index: 6;
}

.graph-dot-7 {
  z-index: 5;
}

.graph-dot-8 {
  z-index: 4;
}

.graph-dot-9 {
  z-index: 3;
}

.graph-dot-10 {
  z-index: 2;
}

.graph-position {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  transform: scale(1, -1);
}

#graph1 {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: auto;
  object-fit: contain;
  background-color: none;
  background: none;
}

#graph2 {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: auto;
  object-fit: contain;
}

#graph3 {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: auto;
  object-fit: contain;
}

#graph4 {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: auto;
  object-fit: contain;
}

#graph5 {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: auto;
  object-fit: contain;
}

#graph6 {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: auto;
  object-fit: contain;
}

#graph7 {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: auto;
  object-fit: contain;
}

#graph8 {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: auto;
  object-fit: contain;
}

#graph9 {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: auto;
  object-fit: contain;
}

#graph10 {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: auto;
  object-fit: contain;
}


.left-dashboard {
  display: flex;
  flex-direction: column;
  width: 400px;
  position: sticky;
  top: 80px;
}

:root {
  --dashboard-width: calc(95vw - (400px + 30px));
  --dashboard-height: calc(((95vw - (400px + 30px)) / 2) + 25px);
}

.right-block-dash {
  display: flex;
  flex-direction: column;
  gap: 40px;
  -webkit-gap: 40px;
  width: var(--dashboard-width);
}

.dahsboard-right {
  position: relative;
  padding: 20px 20px 40px 50px;
  display: flex;
  width: var(--dashboard-width);
  height: var(--dashboard-height);
  flex-direction: column;
  background-color: white;
  border-radius: 20px;
}

.dashboard-list {
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 20px;
  padding: 20px 0;
  width: 100%;
}

.dashboard-item {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 15px;
  -webkit-gap: 15px;
  align-items: center;
  background-color: white;
  cursor: pointer;
  padding: 0 20px 0 0;
  transition: filter, transform 0.2s ease-in-out;
}

.dash-rating-item {
  position: relative;
  width: calc((100% - 60px) / 3);
  display: flex;
  flex-direction: row;
  gap: 15px;
  -webkit-gap: 15px;
  align-items: center;
  background-color: white;
  cursor: pointer;
  padding: 0 20px 0 0;
  transition: filter, transform 0.2s ease-in-out;
}

.dash-rating {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 30px;
  -webkit-gap: 30px;
  row-gap: 0;
}

/* .dash-rating-item {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 15px;
  -webkit-gap: 15px;
  align-items: center;
  background-color: white;
  cursor: pointer;
  padding: 0 20px 0 0;
  transition: filter, transform 0.2s ease-in-out;
} */

.dash-rating-position {
  position: relative;
  font-size: 18px;
  line-height: 22px;
  font-weight: 800;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 65px;
  height: 45px;
  border-right: 1px solid #696d7765;
}

.color-dash {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 5%;
  height: 100%;
  transition: width 0.3s ease-in-out;
}

.top-1 {
  background: red;
}

.top-2 {
  background: rgb(255, 123, 0);
}

.top-3 {
  background: rgb(255, 187, 0);
}

.top-4 {
  background: rgb(74, 202, 0);
}

.top-5 {
  background: rgb(0, 202, 175);
}

.top-6 {
  background: rgb(1, 153, 255);
}

.top-7 {
  background: rgb(1, 48, 255);
}

.top-8 {
  background: rgb(132, 1, 255);
}

.top-9 {
  background: rgb(255, 1, 242);
}

.top-10 {
  background: rgb(177, 0, 103);
}

.all-people {
  background: var(--blue-main);
}

.dashboard-item:hover {
  filter: drop-shadow(2px 2px 20px rgba(33, 94, 173, 0.2));
  z-index: 900;
  /* transform: scale(1.03); */
}

.dashboard-item:hover .color-dash {
  width: 100%;
  z-index: -1;
}

.dashboard-item:hover .dash-rating-position {
  color: white;
}

.dash-rating-item:hover {
  filter: drop-shadow(2px 2px 20px rgba(33, 94, 173, 0.2));
  z-index: 900;
  /* transform: scale(1.03); */
}

.dash-rating-item:hover .color-dash {
  width: 100%;
  z-index: -1;
}

.dash-rating-item:hover .dash-rating-position {
  color: white;
}

.dash-comand-name {
  display: block;
  font-size: 16px;
  line-height: 16px;
  width: calc(100% - (65px + 95px));
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.dash-rating-num {
  font-size: 16px;
  line-height: 16px;
  font-weight: 800;
  color: var(--blue-main);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 100%;
  position: absolute;
  text-align: center;
  top: 0;
  right: 15px;
}

.header-dash-top {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 20px 20px;
  border-bottom: 1px solid #696d7765;
}

.heading-dash {
  font-size: 21px;
  line-height: 21px;
  font-weight: 800;
}

.btn-wrap-dash {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  -webkit-gap: 5px;
}

.dash-select {
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  color: white;
  background-color: var(--blue-main);
  padding: 5px 10px;
  border-radius: 15px;
  cursor: pointer;
  transition: background-color ease-in-out 0.3s;
}

.dash-select:hover {
  background-color: #0013be;
}

.dash-footer {
  padding: 20px 20px 5px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  -webkit-gap: 10px;
  font-size: 12px;
  line-height: 18px;
  border-top: 1px solid #696d7765;
}

.dot-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #00074798;
}

.dot-info-block {
  display: flex;
  flex-direction: column;
  gap: 20px;
  -webkit-gap: 20px;
  background-color: white;
  max-width: 400px;
  padding: 20px;
  border-radius: 20px;
}

@media (max-width: 1440px) {
  .dash-rating-item {
    width: calc((100% - 30px) / 2);
  }
}

@media (max-width: 1100px) {
  .dash-rating-item {
    width: 100%;
  }
}

@media (max-width: 900px) {
  .wrap-dash {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
    -webkit-gap: 30px;
    width: 100%;
  }

  .left-dashboard {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    top: 0;
  }

  .right-block-dash {
    display: flex;
    flex-direction: column;
    gap: 40px;
    -webkit-gap: 40px;
    width: 100%;
  }

  :root {
    --dashboard-width: 95vw;
    --dashboard-height: calc((95vw / 2) + 25px);
  }

  .dahsboard-right {
    position: relative;
    padding: 20px 20px 40px 50px;
    display: flex;
    width: var(--dashboard-width);
    height: var(--dashboard-height);
    flex-direction: column;
    background-color: white;
    border-radius: 20px;
  }

  .dash-comand-name {
    font-size: 13px;
    line-height: 13px;
  }

  .dash-rating-position {
    font-size: 13px;
    line-height: 13px;
  }

  .dash-rating-num {
    font-size: 13px;
    line-height: 13px;
  }
}

.date-item-left {
  padding: 0;
  margin: 0;
  position: absolute;
  left: 0;
  top: 15px;
  width: fit-content;
}

.date-item-right {
  padding: 0;
  margin: 0;
  position: absolute;
  right: 0;
  top: 15px;
  width: fit-content;
}

.stage-mbti-flex {
  display: flex;
  flex-direction: column;
  gap: 15px;
  -webkit-gap: 15px;
}

.stage-mbti .stage-card-new-gap-work {
  background-color: #0013be;
}

.block-input-percent {
  border: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  -webkit-gap: 10px;
}

.recomend-block {
  width: fit-content;
  padding: 10px 20px 10px 10px;
  border-radius: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  -webkit-gap: 10px;
  background: linear-gradient(90deg, rgba(57,255,80,1) 0%, rgba(0,255,218,1) 100%);
}

.recomend-percent {
  display: block;
  padding: 5px 10px;
  background-color: white;
  color: black;
  border-radius: 15px;
  font-weight: 700;
}

.recomend-text {
  color: black;
  font-weight: 700;
}

.recomend-all {
  display: flex;
  flex-direction: column;
  gap: 5px;
  -webkit-gap: 5px;
  padding: 20px 25px;
  /*background: url('../assets/images/backrecom.jpg') no-repeat center center;*/
  background-size: 100% 100%;
  border-radius: 15px;
  cursor: pointer;
}

.recomend-all p {
  color: white;
}

.my-challenge-plan {
  position: absolute;
  top: 0;
  left: 20px;
  right: 20px;
  width: calc(100% - 40px);
  height: var(--main-center-head);
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  -webkit-gap: 12px;
  padding: 30px;
  padding-top: 20px;
  padding-bottom: 0;
  border-radius: 15px;
  /*background: url('../assets/images/backrecom.jpg') no-repeat center center;*/
  background-size: 100% 100%;
}

.my-challenge-plan .fio-or-name {
  color: white;
}

.date-item-left {
  padding: 0;
  margin: 0;
  position: absolute;
  left: 0;
  top: 15px;
  width: fit-content;
}

.date-item-right {
  padding: 0;
  margin: 0;
  position: absolute;
  right: 0;
  top: 15px;
  width: fit-content;
}

.result-rating-form {
  display: block;
  padding: 15px 0;
  font-size: 24px;
  line-height: 24px;
  color: var(--blue-main);
  font-weight: 800;
}

.result-rating-form::before {
  content: 'Итого баллов: ';
  font-weight: 400;
}

.results-profile-rating {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  -webkit-gap: 5px;
  padding: var(--padding-input);
  border-radius: 15px;
  border: 2px solid #b5b8cf;
}

.filter-list {
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  z-index: 20;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  -webkit-gap: 10px;
  padding: 15px 20px;
  border-radius: 20px;
  font-size: 16px;
  line-height: 16px;
  color: white;
  border: 0;
  outline: 0;
  background-color: #001AFF;
}

.admin-profile {
  padding: 0;
  color: white;
}

.admin-profile-btn {
  background-color: darkblue;
  outline: 0;
  border: 0;
}

.admin-profile-btn:hover {
  background-color: #000752;
  outline: 0;
  border: 0;
}

.admin-profile-decline-btn {
  background-color: red;
  outline: 0;
  border: 0;
}

.admin-profile-decline-btn:hover {
  background-color: darkred;
  outline: 0;
  border: 0;
}

.filter_download-info {
  display: flex;
  flex-direction: column;
  gap: 30px;
  -webkit-gap: 30px;
  padding: var(--padding-input);
  background-color: rgba(54, 110, 255, 0.1);
  border: 2px solid rgba(54, 110, 255, 0.1);
  border-radius: 5px;
  -webkit-border-radius: 5px;
}

.filter_dowload-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  -webkit-gap: 5px;
}

.filter_dowload-item {
  display: flex;
  flex-direction: row;
  gap: 5px;
  -webkit-gap: 5px;
  padding: 10px 10px 10px 10px;
  background-color: var(--blue-main);
  font-size: 12px;
  line-height: 12px;
  color: white;
  border-radius: 10px;
  -webkit-border-radius: 10px;
}

.filter_dowload-btn {
  display: block;
  width: 12px;
  height: 12px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_65___}) no-repeat center center;
  background-size: 12px 12px;
  cursor: pointer;
}

.filter_radio-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  -webkit-gap: 20px;
  padding: 20px 0;
}

.radio_filter-dowload {
  display: flex;
  align-self: center;
  gap: 2px;
  -webkit-gap: 2px;
  width: fit-content;
  font-weight: 500;
  font-size: var(--font-size);
  line-height: var(--font-size);
}

.filter_date {
  display: flex;
  border: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  -webkit-gap: 10px;
}

@media (max-width: 650px) {
  .main-list-center {
    display: flex;
    position: relative;
    flex-direction: column;
    gap: 15px;
    -webkit-gap: 15px;
    /* width: var(--block-center); */
    padding: var(--block-padding);
    padding-top: var(--main-center-head);
    padding-bottom: 0;
    height: 100%;
    width: 100%;
  }
}

@media (max-width: 650px) {
  .left-block {
    width: var(--block-size);
    display: flex;
    flex-direction: column;
    height: auto;
    background-color: white;
    z-index: 2;
    overflow: hidden;
  }
}

@media (max-width: 650px) {
  .header {
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: var(--header-padding);
    height: var(--header-height);
    /* border-bottom: 1px solid #DCDDE0; */
    background-color: white;
  }
}

@media (max-width: 650px) {
  .right-block {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 4;
    width: var(--block-size);
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    max-width: 100%;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(50px);
    -webkit-backdrop-filter: blur(50px);
    transition: ease-in-out 0.5s;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,kCAAkC;EAClC,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,wBAAwB;IACxB,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;IACvB,0BAA0B;IAC1B,kCAAkC;IAClC,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,4BAA4B;IAC5B,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,wBAAwB;IACxB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,yBAAyB;EAC3B;AACF;;AAEA,UAAU;;AAEV;EACE,mDAA6C;EAC7C,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,mDAA+C;EAC/C,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,mDAAiD;EACjD,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,mDAAsD;EACtD,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,mDAA8C;EAC9C,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,mDAA6C;EAC7C,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,mDAA6C;EAC7C,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,mDAA6C;EAC7C,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,mDAA6C;EAC7C,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,mDAA4C;EAC5C,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,oDAA6C;EAC7C,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,oDAA6C;EAC7C,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,oDAA+C;EAC/C,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,oDAA4C;EAC5C,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,oDAA4C;EAC5C,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,oDAAgD;EAChD,4BAA4B;EAC5B,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,oDAA6C;EAC7C,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,mDAA+C;EAC/C,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,oDAA6C;EAC7C,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,oDAAoD;EACpD,4BAA4B;EAC5B,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,oDAAoD;EACpD,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,oDAAiD;EACjD,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,oDAAmD;EACnD,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,oDAAiD;EACjD,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,oDAAqD;EACrD,4BAA4B;EAC5B,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;;;EAGE,aAAa;AACf;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,+CAA+C;EAC/C,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oDAAgD;EAChD,sCAAsC;EACtC,gCAAgC;EAChC,0CAA0C;EAC1C,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oDAA6C;EAC7C,sCAAsC;EACtC,gCAAgC;EAChC,0CAA0C;EAC1C,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,gCAAgC;EAChC,0CAA0C;EAC1C,4BAA4B;EAC5B,yBAAyB;AAC3B;;;AAGA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oDAAiD;EACjD,sCAAsC;EACtC,gCAAgC;EAChC,0CAA0C;EAC1C,4BAA4B;EAC5B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,oFAAoF;EACpF,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;EAClC,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA,mBAAmB;;AAEnB,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;EAC5B,aAAa;AACf;;AAEA;;;EAGE,4BAA4B;EAC5B,aAAa;AACf;;AAEA;;EAEE,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,0CAA0C;EAC1C,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;EAGE,wCAAwC;EACxC,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,4EAA0E;EAC1E,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,4EAAsE;EACtE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,yCAAyC;EAC3C;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB;EACE,gEAAgE;EAChE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,gEAAgE;IAChE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,QAAQ;EACR,SAAS;EACT,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;;AAGA,iBAAiB;;AAEjB;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;;AAGA;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,0BAA0B;EAC1B,6BAA6B;EAC7B,iDAAiD;EACjD,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,6BAA6B;EAC7B,oCAAoC;EACpC,iBAAiB;EACjB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,6BAA6B;EAC7B,oCAAoC;EACpC,oBAAoB;EACpB,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,UAAU;IACV,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,6BAA6B;IAC7B,iDAAiD;IACjD,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,cAAc;EACd,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,OAAO;EACP,cAAc;EACd,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,OAAO;EACP,cAAc;EACd,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oDAA4C;EAC5C,yBAAyB;EACzB,4BAA4B;EAC5B,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,0CAA0C;AAC5C;;;AAGA,SAAS;;AAET;EACE,aAAa;EACb,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb;EACF;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,oCAAoC;EACpC,uBAAuB;EACvB,iDAAiD;EACjD,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,oCAAoC;EACpC,uBAAuB;EACvB,iDAAiD;EACjD,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0EAAwE;EACxE,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;IACd,0EAAwE;IACxE,mBAAmB;IACnB,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;IACd,0EAAwE;IACxE,mBAAmB;IACnB,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;EACpB;AACF;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,4CAA4C;EAC5C,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;EAChC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,4CAA4C;IAC5C,yBAAyB;IACzB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,oCAAoC;IACpC,gBAAgB;IAChB,sCAAsC;IACtC,+BAA+B;IAC/B,0CAA0C;EAC5C;AACF;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE;IACE,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,8BAA8B;EAC9B,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;EAChB,0CAA0C;EAC1C,uEAAqE;EACrE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,oDAA4C;EAC5C,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,MAAM;EACN,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,SAAS;EACT,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,iBAAiB;EACnB;AACF;;;AAGA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,6BAA6B;EAC7B,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,0EAA4E;EAC5E,sCAAsC;EACtC,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,SAAS;AACX;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,4EAAsE;EACtE,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,4EAAsE;EACtE,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,kCAAkC;EAClC,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,gEAAgE;AAClE;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,0CAA0C;EAC1C,oDAA4C;EAC5C,4BAA4B;EAC5B,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE;IACE,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0CAA0C;EAC1C,oDAA4C;EAC5C,4BAA4B;EAC5B,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,+CAA+C;AACjD;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;EACzC,SAAS;EACT,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,yCAAyC;EACzC,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8DAAsD;EACtD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8DAAuD;EACvD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,8DAAsD;EACtD,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oDAA6C;EAC7C,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,sDAAsD;EACtD,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oDAAkD;EAClD,sCAAsC;EACtC,gCAAgC;EAChC,0CAA0C;EAC1C,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,SAAS;EACT,4EAAsE;EACtE,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,SAAS;EACT,4EAAmE;EACnE,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,SAAS;EACT,4EAA0E;EAC1E,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,6BAA6B;EAC7B,2CAA2C;EAC3C,0EAAqE;EACrE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;EACzC,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,0CAA0C;EAC1C,0EAA0E;EAC1E,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,0CAA0C;EAC1C,0EAAkE;EAClE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,0CAA0C;EAC1C,0EAAmE;EACnE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,0EAAkE;EAClE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,0EAAkE;EAClE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0EAAkE;EAClE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,0EAAkE;EAClE,kDAAkD;EAClD,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;EAC5B,kCAAkC;EAClC,YAAY;EACZ,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,2BAA2B;EAC3B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gEAAgE;EAChE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,yCAAyC;IACzC,uBAAuB;EACzB;;AAEF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,yCAAyC;IACzC,uBAAuB;EACzB;;AAEF;;;AAGA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oDAAiD;EACjD,sCAAsC;EACtC,gCAAgC;EAChC,0CAA0C;EAC1C,4BAA4B;EAC5B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,6BAA6B;EAC7B,oCAAoC;EACpC,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,gEAAgE;AAClE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,wFAAwF;EACxF,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4EAAqE;EACrE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,MAAM;EACN,2CAA2C;EAC3C,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,2CAA2C;EAC3C,oDAAoD;EACpD,4BAA4B;EAC5B,0BAA0B;EAC1B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,4CAA4C;EAC9C;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,4EAA0E;EAC1E,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,qDAAqD;EACrD,4DAA4D;EAC5D,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,4CAA4C;EAC5C,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,mDAAmD;EACnD,kDAAkD;EAClD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,0CAA0C;EAC1C,YAAY;EACZ,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wCAAwC;EACxC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,qDAAqD;EACrD,yDAAyD;EACzD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,kDAAkD;EAClD,kDAAkD;EAClD,mDAAmD;EACnD,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,mDAAmD;EACnD,kDAAkD;EAClD,mDAAmD;EACnD,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4DAA4D;EAC5D,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,uDAAuD;EACvD,wDAAwD;EACxD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,iDAAiD;EACjD,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,0DAA0D;EAC1D,iEAAiE;EACjE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,iDAAiD;EACjD,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,wDAAwD;EACxD,uDAAuD;EACvD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;EACvD,wDAAwD;EACxD,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,+CAA+C;EAC/C,YAAY;EACZ,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,6CAA6C;EAC7C,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;EAC/C,iDAAiD;EACjD,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,0DAA0D;EAC1D,8DAA8D;EAC9D,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,gBAAgB;EAChB,sBAAsB;EACtB,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,uDAAuD;EACvD,uDAAuD;EACvD,wDAAwD;EACxD,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,wDAAwD;EACxD,uDAAuD;EACvD,wDAAwD;EACxD,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iEAAiE;EACjE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,8DAA8D;EAC9D,mBAAmB;AACrB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,cAAc;EACd,uDAAuD;EACvD,wDAAwD;EACxD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,oDAA0D;EAC1D,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE;IACE,qBAAqB;IACrB,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;;AAEnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,0CAA0C;EAC1C,UAAU;EACV,SAAS;AACX;;AAEA;;;EAGE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,0EAAsE;EACtE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4EAAyE;EACzE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4EAA0E;EAC1E,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4EAA8E;EAC9E,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4EAA8E;EAC9E,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0EAAkE;EAClE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,0EAAuE;EACvE,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,0EAA2E;EAC3E,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,0EAAuE;EACvE,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;IACE,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,0EAA4E;EAC5E,0BAA0B;EAC1B,yBAAyB;EACzB,kCAAkC;EAClC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0EAAwE;EACxE,kDAAkD;AACpD;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,0EAAuE;EACvE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0EAAmE;EACnE,kDAAkD;AACpD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0EAAkE;EAClE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0EAAwE;EACxE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0EAAmE;EACnE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;EACd,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,aAAa;EACb,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,oDAAiD;EACjD,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,wFAAwF;EACxF,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4EAA4E;EAC5E,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,oDAAgD;EAChD,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,4CAA4C;EAC5C,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,UAAU;EACV,0EAA0E;EAC1E,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0EAAoE;EACpE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,YAAY;EACZ,0EAAyE;EACzE,sCAAsC;EACtC,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;EAClC,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;EAClC,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4EAAqE;EACrE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,2CAA2C;EAC3C,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,0EAA0E;EAC1E,kDAAkD;EAClD,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,uCAAuC;EACvC,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,uCAAuC;EACvC,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,2CAA2C;EAC3C,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,0EAA0E;EAC1E,kDAAkD;EAClD,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,uCAAuC;EACvC,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,uCAAuC;EACvC,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,UAAU;EACV,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,8CAA8C;EAC9C,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,6BAA6B;EAC7B,+BAA+B;EAC/B,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;;;;;;;;;;GAWG;;AAEH;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,SAAS;EACT,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wDAAwD;EACxD,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wDAAwD;EACxD,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,MAAM;EACR;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,2CAA2C;EAC7C;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,6BAA6B;IAC7B,+BAA+B;IAC/B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gFAAgF;AAClF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,6EAA6E;EAC7E,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,6EAA6E;EAC7E,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,yCAAyC;EACzC,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4EAA2E;EAC3E,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,gCAAgC;IAChC,6BAA6B;IAC7B,oCAAoC;IACpC,iBAAiB;IACjB,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;IAC9B,4BAA4B;IAC5B,sCAAsC;IACtC,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;IACR,MAAM;IACN,SAAS;IACT,UAAU;IACV,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,oCAAoC;IACpC,2BAA2B;IAC3B,mCAAmC;IACnC,4BAA4B;EAC9B;AACF","sourcesContent":[":root {\n  --menu-padding: 30%;\n  --header-padding: 50px;\n  --block-padding: 50px;\n  --header-height: 100px;\n  --font-size: 16px;\n  --logo-width: 100px;\n  --fio-name: 21px;\n  --user-avatar-size: 100px;\n  --legend-size: 18px;\n  --user-profile-padding: 20px;\n  --block-size: 50%;\n  --block-center: 70%;\n  --padding-btn: 20px 30px 20px 50px;\n  --btn-description: 15px;\n  --menu-link: 16px;\n  --menu-width: 250px;\n  --menu-link-height: 19px;\n  --padding-btn: 20px 25px 20px 50px;\n  --icon-padding: 25px;\n  --main-center-head: 160px;\n  --text-size: 16px;\n  --text-lineheight: 22px;\n  --padding-input: 20px 25px;\n  --blue-main: rgba(54, 110, 255, 1);\n  --text-grey: #33353a;\n  --cert-height: 90vh;\n  --cert-height-full: 100vh;\n}\n\n@media (max-width: 1600px) {\n  :root {\n    --menu-padding: 30%;\n    --header-padding: 30px;\n    --block-padding: 30px;\n    --header-height: 80px;\n    --font-size: 16px;\n    --logo-width: 80px;\n    --fio-name: 21px;\n    --user-avatar-size: 80px;\n    --legend-size: 16px;\n    --user-profile-padding: 20px;\n    --block-size: 50%;\n    --block-center: 70%;\n    --btn-description: 14px;\n    --menu-link: 16px;\n    --menu-link-height: 19px;\n    --main-center-head: 140px;\n    --text-size: 16px;\n    --text-lineheight: 22px;\n    --padding-input: 20px 25px;\n    --blue-main: rgba(54, 110, 255, 1);\n    --text-grey: #33353a;\n  }\n}\n\n@media (max-width: 1280px) {\n  :root {\n    --menu-padding: 30%;\n    --header-padding: 30px;\n    --block-padding: 30px;\n    --header-height: 70px;\n    --font-size: 14px;\n    --logo-width: 70px;\n    --fio-name: 18px;\n    --user-avatar-size: 70px;\n    --legend-size: 14px;\n    --user-profile-padding: 20px;\n    --block-size: 50%;\n    --block-center: 70%;\n    --btn-description: 12px;\n    --menu-link: 14px;\n    --menu-link-height: 19px;\n    --main-center-head: 140px;\n  }\n}\n\n@media (max-width: 800px) {\n  :root {\n    --menu-padding: 30%;\n    --header-padding: 30px;\n    --block-padding: 20px;\n    --header-height: 70px;\n    --font-size: 13px;\n    --logo-width: 70px;\n    --fio-name: 16px;\n    --user-avatar-size: 70px;\n    --legend-size: 14px;\n    --user-profile-padding: 20px;\n    --block-size: 100vw;\n    --block-center: 70%;\n    --btn-description: 12px;\n    --menu-link: 14px;\n    --menu-link-height: 19px;\n    --main-center-head: 140px;\n    --cert-height: 65vh;\n  }\n}\n\n@media (max-width: 600px) {\n  :root {\n    --menu-padding: 30%;\n    --header-padding: 30px;\n    --block-padding: 15px;\n    --header-height: 60px;\n    --font-size: 13px;\n    --logo-width: 70px;\n    --fio-name: 18px;\n    --user-avatar-size: 70px;\n    --legend-size: 14px;\n    --user-profile-padding: 20px;\n    --block-size: 100vw;\n    --block-center: 100%;\n    --menu-link: 24px;\n    --menu-link-height: 24px;\n    --main-center-head: 120px;\n  }\n}\n\n/* icons */\n\n.vuz-menu {\n  background: url('../assets/images/vuzes.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.profile-menu {\n  background: url('../assets/images/profile.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.challenge-menu {\n  background: url('../assets/images/challenge.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.challenge-challenge-menu {\n  background: url('../assets/images/challenge_menu.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.school-menu {\n  background: url('../assets/images/school.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.certification-menu {\n  background: url('../assets/images/serts.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.loot-menu {\n  background: url('../assets/images/prize.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.unloads-menu {\n  background: url('../assets/images/excel.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.users-menu {\n  background: url('../assets/images/users.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.tests-menu {\n  background: url('../assets/images/test.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.bills-menu {\n  background: url('../assets/images/money.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.plans-menu {\n  background: url('../assets/images/tarif.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.preview {\n  background: url('../assets/images/preview.svg');\n  background-repeat: no-repeat;\n  background-size: var(--font-size) auto;\n}\n\n.work {\n  background: url('../assets/images/work.svg');\n  background-repeat: no-repeat;\n  background-size: var(--font-size) auto;\n}\n\n.lock {\n  background: url('../assets/images/lock.svg');\n  background-repeat: no-repeat;\n  background-size: var(--font-size) auto;\n}\n\n.complete {\n  background: url('../assets/images/complete.svg');\n  background-repeat: no-repeat;\n  background-size: var(--font-size) auto;\n  color: var(--blue-main);\n}\n\n.kubok {\n  background: url('../assets/images/kubok.svg');\n  background-repeat: no-repeat;\n  background-size: var(--font-size) auto;\n}\n\n.kabinet {\n  background: url('../assets/images/profile.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n}\n\n.sorev {\n  background: url('../assets/images/kubok.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n}\n\n.profile {\n  background: url('../assets/images/profile_menu.svg');\n  background-repeat: no-repeat;\n  background-size: auto var(--font-size);\n  background-position: left center;\n}\n\n.results-menu {\n  background: url('../assets/images/results_menu.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.jury-menu {\n  background: url('../assets/images/jury_menu.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.ocenka-menu {\n  background: url('../assets/images/ocenka_menu.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.exit-menu {\n  background: url('../assets/images/exit_menu.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\n.students-menu {\n  background: url('../assets/images/students_menu.svg');\n  background-repeat: no-repeat;\n  background-size: var(--menu-link-height) auto;\n  background-position: left center;\n}\n\nbutton:hover,\nbutton:focus,\nbutton:active {\n  outline: none;\n}\n\n/* КНОПКИ */\n\n.btn {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n  width: 100%;\n  padding: var(--padding-input);\n  border: 0;\n  border-radius: 5px;\n  border: 2px solid #abaeb852;\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  background: none;\n  color: var(--text-grey);\n  cursor: pointer;\n  transition: ease-in-out 0.3s;\n}\n\n.btn:hover {\n  border: 2px solid #dee8ff91;\n  background-color: #dee8ff91;\n  transition: ease-in-out 0.3s;\n}\n\n.btn-deactive {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: var(--padding-input);\n  border: 0;\n  border-radius: 5px;\n  border: 2px solid #81869752;\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  background: none;\n  color: var(--text-grey);\n  cursor: pointer;\n  opacity: 0.5;\n  gap: 10px;\n}\n\n.btn-complete {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: var(--padding-input);\n  border: 0;\n  border-radius: 5px;\n  border: 2px solid var(--blue-main);\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  background: none;\n  color: var(--text-grey);\n  cursor: pointer;\n  gap: 10px;\n  -webkit-gap: 10px;\n  transition: ease-in-out 0.3s;\n}\n\n.btn-complete:hover {\n  border: 2px solid #dee8ff91;\n  background-color: #dee8ff91;\n  transition: ease-in-out 0.3s;\n}\n\n.btn-heading {\n  font-weight: 600;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  padding-left: calc(var(--font-size) + 5px);\n}\n\n.btn-description {\n  font-size: var(--btn-description);\n  line-height: calc(var(--btn-description) + 8px);\n  letter-spacing: 0.02em;\n  color: var(--text-grey);\n}\n\n.lock + .btn-description {\n  color: var(--blue-main);\n}\n\n.btn-no {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  border: 0;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: center;\n  background: #FF6666;\n  color: white;\n  cursor: pointer;\n}\n\n.btn-exit {\n  display: block;\n  width: 100%;\n  padding: var(--padding-btn);\n  border: 0;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  color: white;\n  cursor: pointer;\n  background: url('../assets/images/exit_btn.svg');\n  background-size: auto var(--font-size);\n  background-position: left center;\n  background-position-x: var(--icon-padding);\n  background-repeat: no-repeat;\n  background-color: #FF6666;\n}\n\n.btn-exit:hover {\n  background-color: red;\n  transition: ease-in-out 0.3s;\n}\n\n.error-message {\n  display: block;\n  width: 100%;\n  padding: var(--padding-btn);\n  border: 0;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  color: white;\n  cursor: pointer;\n  background: url('../assets/images/alarm.svg');\n  background-size: auto var(--font-size);\n  background-position: left center;\n  background-position-x: var(--icon-padding);\n  background-repeat: no-repeat;\n  background-color: #FF6666;\n}\n\n.success-message {\n  display: block;\n  width: 100%;\n  padding: var(--padding-btn);\n  border: 0;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  color: white;\n  cursor: default;\n  opacity: 0.6;\n  background-size: auto var(--font-size);\n  background-position: left center;\n  background-position-x: var(--icon-padding);\n  background-repeat: no-repeat;\n  background-color: #19CB6B;\n}\n\n\n.message-for-sure {\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 8px);\n}\n\n.btn-arrow {\n  display: block;\n  width: 100%;\n  padding: var(--padding-btn);\n  border: 0;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  color: white;\n  cursor: pointer;\n  background: url('../assets/images/arrow-btn.svg');\n  background-size: auto var(--font-size);\n  background-position: left center;\n  background-position-x: var(--icon-padding);\n  background-repeat: no-repeat;\n  background-color: var(--blue-main);\n  transition: ease-in-out 0.3s;\n}\n\n.btn-arrow:hover {\n  background-color: #174bce;\n  transition: ease-in-out 0.3s;\n}\n\n.btn-wrapper {\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n.btn-main {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  background: linear-gradient(90.01deg, #366EFF 0.01%, #FA00FF 49.61%, #FF3D00 99.21%);\n  border: 0;\n  border-radius: 5px;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 700;\n  color: white;\n  cursor: pointer;\n  transition: ease-in-out 0.3s;\n}\n\n.btn-blue {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  background: var(--blue-main);\n  border: 0;\n  border-radius: 5px;\n  font-size: var(--text-size);\n  line-height: var(--text-lineheight);\n  font-weight: 700;\n  color: white;\n  cursor: pointer;\n}\n\n.btn-landing {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  background-color: var(--blue-main);\n  border: 0;\n  border-radius: 5px;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 700;\n  color: white;\n  cursor: pointer;\n  transition: ease-in-out 0.3s;\n}\n\n/* INPUT AND FORM */\n\n/* MAIN FORM RIGHT BLOCK */\n.menu-challenge {\n  position: relative;\n  background-color: white;\n  padding: 30px;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n@media (max-width: 1280px) {\n  .menu-challenge {\n    background-color: white;\n    padding: 20px;\n    border-radius: 5px;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    -webkit-gap: 15px;\n  }\n}\n\n@media (max-width: 800px) {\n  .menu-challenge {\n    background-color: white;\n    padding: 15px;\n    border-radius: 5px;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    -webkit-gap: 15px;\n  }\n}\n\n.legend-about {\n  display: block;\n  font-size: var(--legend-size);\n  line-height: var(--legend-size);\n  font-weight: 700;\n}\n\ninput {\n  font-size: var(--text-size);\n  line-height: var(--text-lineheight);\n  transition: ease-in-out 0.2s;\n  outline: none;\n}\n\ninput:focus,\ninput:active {\n\n  transition: ease-in-out 0.2s;\n  outline: none;\n}\n\ninput:hover {\n\n  transition: ease-in-out 0.2s;\n  outline: none;\n}\n\ninput::placeholder {\n  color: #847E95;\n}\n\ninput[type='checkbox']:before {\n  outline: none;\n  border: 0;\n}\n\ninput[type='checkbox']:checked:before {\n  outline: none;\n  border: 0;\n}\n\ninput[type='checkbox']:checked:after {\n  outline: none;\n  border: 0;\n}\n\ninput[type='submit']:hover,\ninput[type='submit']:active,\ninput[type='submit']:focus {\n  outline: none;\n}\n\n.white-input {\n  background-color: white;\n}\n\n.input-standart {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  background-color: rgba(255, 255, 255, 0.5);\n  border: 0;\n  border-radius: 5px;\n}\n\n.input-standart:focus,\n.input-standart:active,\n.input-standart:hover {\n  background-color: rgba(255, 255, 255, 1);\n  outline: none;\n  border: 0;\n}\n\n.label-checkbox-radio {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.checkbox-radio {\n  display: block;\n  position: relative;\n  top: 5px;\n}\n\n.btn-select {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  background: rgba(255, 255, 255, 0.5);\n  border: 0;\n  border-radius: 5px;\n  font-size: var(--text-size);\n  line-height: var(--text-lineheight);\n  font-weight: 700;\n  color: black;\n  cursor: pointer;\n}\n\n.input-challenges {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid rgba(175, 180, 202, 0.5);\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n}\n\n.input-challenges:hover {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid var(--blue-main);\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n}\n\n.input-challenges-select {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  background: url('../assets/images/arrow-down.svg') no-repeat right center ;\n  background-position-x: 97%;\n  background-color: white;\n  border-radius: 5px;\n  border: 2px solid rgba(175, 180, 202, 0.5);\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n}\n\nselect {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\nselect::-ms-expand {\n  display: none;\n}\n\n.input-challenges-flex {\n  display: flex;\n  align-self: center;\n  gap: 5px;\n  -webkit-gap: 5px;\n  width: 100%;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid rgba(175, 180, 202, 0.5);\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  background-color: white;\n}\n\n.block-input {\n  position: relative;\n  display: flex;\n  border: 0;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n  max-width: 100%;\n}\n\n.answer {\n  position: absolute;\n  bottom: 15px;\n  right: 15px;\n  width: 35px;\n  height: 35px;\n  background: url('../assets/images/answer.svg') center center no-repeat;\n  background-size: contain;\n  border-radius: 5px;\n}\n\n.answer-text {\n  position: absolute;\n  bottom: 15px;\n  right: 55px;\n  max-width: 80%;\n  border-radius: 5px;\n  padding: var(--padding-input);\n  background-color: white;\n  border: 1px solid #001AFF;\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 6px);\n}\n\n@media (max-width: 1600px) {\n  .answer {\n    position: absolute;\n    bottom: 7px;\n    right: 10px;\n    width: 35px;\n    height: 35px;\n    background-color: blue;\n    border-radius: 8px;\n  }\n\n  .answer-text {\n    position: absolute;\n    bottom: 7px;\n    right: 55px;\n    max-width: 80%;\n    border-radius: 5px;\n    padding: var(--padding-input);\n    background-color: white;\n    border: 1px solid #001AFF;\n    font-size: var(--font-size);\n    line-height: calc(var(--font-size) + 6px);\n  }\n}\n\n.profile-flex {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.link-all-challenges {\n  font-size: var(--btn-description);\n  color: var(--blue-main);\n}\n\n.link-all-challenges:hover {\n  color: #174bce;\n  transition: ease-in-out 0.3s;\n}\n\n.challenges-profile-heading {\n  font-weight: 600;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n}\n\n.block-input-flex {\n  display: flex;\n  border: 0;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.radio-btn {\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.span-radio {\n  display: block;\n}\n\n.legend {\n  display: block;\n  max-width: 100%;\n  font-size: var(--legend-size);\n  line-height: var(--legend-size);\n  padding-bottom: 10px;\n  font-weight: 700;\n}\n\n/* BACKGROUNDS */\n\n.platform-background {\n  background: linear-gradient(147.75deg, #E7A4FF 0%, #001AFF 100%);\n  height: 100vh;\n  width: 100vw;\n  position: relative;\n  overflow: hidden;\n}\n\n@media (max-width: 600px) {\n  .platform-background {\n    background: linear-gradient(147.75deg, #E7A4FF 0%, #001AFF 100%);\n    max-height: 100vh;\n    width: 100vw;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    overflow: hidden;\n  }\n}\n\n.image-back {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 50%;\n  right: 0;\n  bottom: 0;\n  display: block;\n  width: 50vw;\n  height: 100vh;\n  object-fit: cover;\n}\n\n.image-back-video {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  display: block;\n  width: 50vw;\n  height: 100vh;\n  object-fit: cover;\n}\n\n.flex-platform {\n  display: flex;\n  flex-direction: row;\n  background-color: white;\n  margin: 0 auto;\n}\n\n\n/* BLOCK SYSTEM */\n\n.left-block {\n  width: var(--block-size);\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background-color: white;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 2;\n  overflow: hidden;\n}\n\n\n.right-block {\n  position: fixed;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 4;\n  width: var(--block-size);\n  display: flex;\n  flex-direction: column;\n  max-height: 100vh;\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(50px);\n  -webkit-backdrop-filter: blur(50px);\n  transition: ease-in-out 0.5s;\n}\n\n.block-center {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  width: var(--block-center);\n  padding: var(--block-padding);\n  padding-top: calc(var(--user-avatar-size) + 40px);\n  padding-bottom: 0;\n  height: calc(100vh - var(--header-height));\n}\n\n.main-list-center {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  /* width: var(--block-center); */\n  padding: var(--block-padding);\n  padding-top: var(--main-center-head);\n  padding-bottom: 0;\n  height: calc(100vh - var(--header-height));\n  width: 100%;\n}\n\n.main-list-center-comand {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  /* width: var(--block-center); */\n  padding: var(--block-padding);\n  padding-top: var(--main-center-head);\n  padding-bottom: 55px;\n  height: calc(100vh - var(--header-height));\n  width: 100%;\n}\n\n.notifications-search {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 3;\n  background-color: #001AFF;\n}\n\n.notifications-search-mobile {\n  display: none;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 3;\n  background-color: #001AFF;\n}\n\n@media (max-width: 700px) {\n  .notifications-search {\n    display: none;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 3;\n    background-color: #001AFF;\n  }\n\n  .notifications-search-mobile {\n    display: block;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 3;\n    background-color: #001AFF;\n  }\n}\n\n.nav-notification-list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 30px;\n  -webkit-gap: 30px;\n  padding: 0 30px;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  color: white;\n  align-items: center;\n}\n\n.nav-notification-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 7px;\n  -webkit-gap: 7px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.notification-notification {\n  display: block;\n  padding: 8px 9px;\n  background-color: #FF3D00;\n  color: white;\n  border-radius: 5px;\n}\n\n.notification-notification::before {\n  content: '+';\n}\n\n.notification-link {\n  padding: 20px 0;\n  cursor: pointer;\n}\n\n.nav-notification-item-active {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 7px;\n  -webkit-gap: 7px;\n  color: rgba(255, 255, 255, 1);\n}\n\n@media (max-width: 1200px) and (min-width: 800px) {\n  .block-center {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    -webkit-gap: 20px;\n    width: 100%;\n    padding: var(--block-padding);\n    padding-top: calc(var(--user-avatar-size) + 40px);\n    padding-bottom: 0;\n  }\n}\n\n.block-center-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding-top: calc(69px + 20px);\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-bottom: var(--block-padding);\n  overflow: auto;\n}\n\n/* HEADER BURGER MENU */\n\n.burger {\n  display: none;\n  position: relative;\n  width: 30px;\n  height: 21px;\n  cursor: pointer;\n}\n\n@media (max-width: 1200px) and (min-width: 800px) {\n  .burger {\n    display: block;\n    position: relative;\n    width: 30px;\n    height: 21px;\n  }\n}\n\n@media (max-width: 600px) {\n  .burger {\n    display: block;\n    position: relative;\n    width: 30px;\n    height: 21px;\n  }\n}\n\n.first-line {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 3px;\n  background-color: black;\n}\n\n.two-line {\n  position: absolute;\n  top: 9px;\n  right: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 3px;\n  background-color: black;\n}\n\n.three-line {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 3px;\n  background-color: black;\n}\n\n.header-avatar {\n  display: block;\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n  border-radius: 20px;\n}\n\n.header-logo {\n  width: var(--logo-width);\n  margin-right: auto;\n  margin-left: 15px;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--header-padding);\n  height: var(--header-height);\n  /* border-bottom: 1px solid #DCDDE0; */\n  background-color: white;\n}\n\n.username {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  -webkit-gap: 15px;\n  cursor: pointer;\n}\n\n.header-username {\n  font-size: 21px;\n  line-height: 21px;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.header-back {\n  font-size: var(--fio-name);\n  line-height: var(--fio-name);\n  font-weight: 700;\n  letter-spacing: 0;\n  padding-left: 18px;\n  background: url('../assets/images/back.svg');\n  background-size: 8px auto;\n  background-repeat: no-repeat;\n  background-position: left center;\n  color: #847E95;\n  cursor: pointer;\n}\n\n.name-menu {\n  font-size: var(--fio-name);\n  line-height: var(--fio-name);\n  font-weight: 700;\n  color: var(--blue-main);\n}\n\n.content {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n  height: calc(100vh - var(--header-height));\n}\n\n\n/* MENU */\n\n.menu {\n  display: flex;\n  padding: var(--header-padding);\n  width: var(--menu-padding);\n  height: 100vh;\n  flex-direction: column;\n  z-index: 999\n}\n\n@media (max-width: 1200px) and (min-width: 800px) {\n  .menu {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: none;\n    padding: var(--header-padding);\n    width: 50%;\n    height: 100vh;\n    background-color: white;\n    z-index: 999;\n  }\n}\n\n@media (max-width: 800px) {\n  .menu {\n    display: flex;\n    padding: var(--header-padding);\n    width: 50%;\n    background-color: white;\n    height: 100vh;\n    z-index: 999\n  }\n}\n\n@media (max-width: 600px) {\n  .menu {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: none;\n    padding: var(--header-padding);\n    width: 100vw;\n    height: 100vh;\n    background-color: white;\n    z-index: 999;\n  }\n}\n\n.menu-list {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 25px;\n  -webkit-gap: 25px;\n}\n\n@media (max-width: 600px) {\n  .menu-list {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 35px;\n    -webkit-gap: 35px;\n  }\n}\n\n.menu-link {\n  font-weight: 600;\n  font-size: var(--menu-link);\n  line-height: var(--menu-link-height);\n  color: var(--text-grey);\n  padding-left: calc(var(--menu-link-height) + 6px);\n  filter: saturate(0);\n  opacity: 0.6;\n}\n\n.menu-link:hover {\n  font-weight: 600;\n  font-size: var(--menu-link);\n  line-height: var(--menu-link-height);\n  color: var(--blue-main);\n  padding-left: calc(var(--menu-link-height) + 6px);\n  filter: saturate(1);\n  opacity: 0.6;\n}\n\n.acvtive-menu {\n  filter: saturate(1);\n  opacity: 1;\n  color: var(--blue-main);\n}\n\n.burger-back {\n  display: none;\n  background: url('../assets/images/arrow_back.svg') left center no-repeat;\n  margin-bottom: 20px;\n  padding: 20px 20px 20px 40px;\n  font-size: var(--menu-link);\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n@media (max-width: 1200px) and (min-width: 800px) {\n  .burger-back {\n    display: block;\n    background: url('../assets/images/arrow_back.svg') left center no-repeat;\n    margin-bottom: 20px;\n    padding: 20px 20px 20px 40px;\n    font-size: var(--menu-link);\n    border-radius: 5px;\n  }\n}\n\n@media (max-width: 600px) {\n  .burger-back {\n    display: block;\n    background: url('../assets/images/arrow_back.svg') left center no-repeat;\n    margin-bottom: 20px;\n    padding: 20px 20px 20px 40px;\n    font-size: var(--menu-link);\n    border-radius: 5px;\n  }\n}\n\n.arrow-back {\n  color: var(--blue-main);\n  font-weight: 600;\n  font-size: var(--menu-link);\n  line-height: var(--menu-link);\n}\n\n/* CONTENT STYLES */\n\n.first-message {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n  padding: var(--padding-input);\n  background-color: #ebebeb;\n  border-radius: 5px;\n}\n\n.first-message-error {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n  padding: var(--padding-input);\n  background-color: rgba(255, 61, 0, 0.1);\n  border-radius: 5px;\n}\n\n.user-profile {\n  position: absolute;\n  top: 0;\n  left: 20px;\n  right: 20px;\n  height: calc(var(--user-avatar-size) + 40px);\n  /* border-radius: 15px; */\n  background-color: white;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 20px;\n  -webkit-gap: 20px;\n  padding: var(--user-profile-padding);\n  border-radius: 30px;\n  box-shadow: 2px 5px 30px #B9CDFF;\n  /* border: 2px solid #d1d1d3; */\n  background-color: white;\n}\n\n@media (max-width: 600px) {\n  .user-profile {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: calc(var(--user-avatar-size) + 40px);\n    /* border-radius: 15px; */\n    background-color: white;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 20px;\n    -webkit-gap: 20px;\n    padding: var(--user-profile-padding);\n    border-radius: 0;\n    /* box-shadow: 2px 5px 30px #B9CDFF; */\n    /* border: 2px solid #d1d1d3; */\n    /* background-color: rgb(240, 240, 240); */\n  }\n}\n\n.user-profile-info {\n  display: flex;\n  padding: 20px 2px 30px 2px;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  overflow-y: auto;\n}\n\n.challenge-info {\n  display: flex;\n  padding: 20px 2px 30px 2px;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  overflow-y: auto;\n}\n\n\n.avater-user {\n  width: var(--user-avatar-size);\n  height: var(--user-avatar-size);\n  display: block;\n  object-fit: cover;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  -webkit-gap: 5px;\n}\n\n.fio-or-name {\n  font-size: var(--fio-name);\n  font-weight: 800;\n}\n\n.city {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n}\n\n.city-student {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  margin-left: auto;\n}\n\n.interests {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 5px;\n  -webkit-gap: 5px;\n}\n\n.interest-item {\n  display: inline-block;\n  width: fit-content;\n  padding: 10px 15px;\n  font-size: 14px;\n  line-height: 14px;\n  color: white;\n  background-color: var(--blue-main);\n  cursor: pointer;\n  border-radius: 5px;\n  transition: ease-in-out 0.3s;\n}\n\n.interest-item:hover {\n  background-color: #174bce;\n  transition: ease-in-out 0.3s;\n}\n\n@media (max-width: 800px) {\n  .interest-item {\n    display: inline-block;\n    width: fit-content;\n    padding: 10px 15px;\n    font-size: 12px;\n    line-height: 12px;\n    color: white;\n    background-color: var(--blue-main);\n    border-radius: 5px;\n  }\n}\n\n.interest-item-comand {\n  display: inline-block;\n  width: fit-content;\n  padding: 10px 15px;\n  font-size: 14px;\n  line-height: 14px;\n  background-color: white;\n  border-radius: 5px;\n}\n\n\n.career-list {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  -webkit-gap: 5px;\n}\n\n.career-item {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding: 20px;\n  background-color: rgba(208, 208, 255, 0.3);\n  border-radius: 5px;\n}\n\n.career-heading {\n  font-size: calc(var(--font-size) + 4px);\n  font-weight: 600;\n  line-height: calc(var(--font-size) + 8px);\n}\n\n.career-description {\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 8px);\n  white-space: pre-wrap;\n}\n\n.link-no {\n  color: #FF6666;\n  text-decoration: underline;\n}\n\n.right-menu {\n  padding: var(--block-padding);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  overflow: auto;\n}\n\n.right-menu-anketa {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  overflow: auto;\n}\n\n.ur-profile-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n}\n\n\n.nav-block-center {\n  display: flex;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  flex-direction: row;\n  gap: 25px;\n  -webkit-gap: 25px;\n  padding: 30px;\n  padding-top: 15px;\n  padding-bottom: 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  overflow-y: scroll;\n}\n\n.link-nav-center-item {\n  display: block;\n  padding-bottom: 15px;\n  border-bottom: 2px solid white;\n  color: white;\n  font-size: var(--font-size);\n  font-weight: 600;\n}\n\n.lock-link {\n  display: block;\n  padding-bottom: 15px;\n  color: white;\n  font-size: var(--font-size);\n  border: 0;\n  font-weight: 600;\n  padding-left: calc(var(--font-size) + 6px);\n  background: url('../assets/images/lock_white.svg') no-repeat left 2px;\n  background-size: var(--font-size) auto;\n  opacity: 0.6;\n}\n\n.non-active-nav {\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 500;\n  font-size: var(--font-size);\n  border-bottom: 2px solid rgba(175, 180, 202, 0);\n}\n\n.button-add {\n  display: block;\n  position: absolute;\n  z-index: 8;\n  bottom: 20px;\n  right: 20px;\n  padding: 10px 20px 10px 45px;\n  background: url('../assets/images/plus.svg');\n  background-position-x: 18px;\n  background-position-y: center;\n  background-repeat: no-repeat;\n  background-color: #001AFF;\n  box-shadow: 2px 5px 30px #B9CDFF;\n  border: 0;\n  border-radius: 20px;\n  color: white;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.button-add-popup {\n  flex-direction: column;\n  gap: 0;\n  -webkit-gap: 0;\n  position: absolute;\n  z-index: 9;\n  bottom: 20px;\n  right: 20px;\n  background-color: white;\n  box-shadow: 2px 5px 30px #B9CDFF;\n  border: 0;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.add-stage {\n  width: 200px;\n  padding: var(--padding-input);\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  background-color: white;\n  border: 0;\n  transition: ease-in-out 0.3s;\n  cursor: pointer;\n}\n\n.add-stage:not(:last-child) {\n  border-bottom: 1px solid rgba(54, 110, 255, 0.3);\n}\n\n.add-stage:hover {\n  background-color: var(--blue-main);\n  color: white;\n  transition: ease-in-out 0.3s;\n}\n\n.container-right-block {\n  display: flex;\n  flex-direction: column;\n  padding: var(--block-padding);\n  border-radius: 5px;\n  overflow: auto;\n  gap: 20px;\n  -webkit-gap: 20px;\n}\n\n@media (max-width: 1000px) {\n  .container-right-block {\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    border-radius: 5px;\n    overflow: auto;\n    gap: 20px;\n    -webkit-gap: 20px;\n  }\n}\n\n@media (max-width: 800px) {\n  .container-right-block {\n    display: flex;\n    flex-direction: column;\n    padding: 15px;\n    border-radius: 5px;\n    overflow: auto;\n    gap: 20px;\n    -webkit-gap: 20px;\n  }\n}\n\n\n.text-about p {\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 8px);\n}\n\n.challenge-btn {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid var(--blue-main);\n  font-weight: 600;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  background: none;\n  color: var(--blue-main);\n  cursor: pointer;\n}\n\n.headline-right-block {\n  font-size: 28px;\n  line-height: 33px;\n  font-weight: 800;\n  white-space:pre-wrap;\n}\n\n.block-settings-challenge {\n  display: flex;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n.settings-challenge {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  border: none;\n  border-radius: 5px;\n  font-weight: 600;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  background: #8D9CC3;\n  color: white;\n  cursor: pointer;\n}\n\n.settings-challenge-button {\n  display: inline-block;\n  width: 100%;\n  padding: var(--padding-input);\n  padding-left: calc(var(--font-size) + 30px);\n  border: none;\n  border-radius: 5px;\n  font-weight: 600;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  background: url('../assets/images/settings_white.svg') no-repeat left center;\n  background-size: var(--font-size) auto;\n  background-position-x: 20px;\n  background-color: #8D9CC3;\n  color: white;\n  cursor: pointer;\n}\n\n.settings-jury {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  border: none;\n  border-radius: 5px;\n  font-weight: 600;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  background: #8D9CC3;\n  color: white;\n  cursor: pointer;\n}\n\n.avatar-right-block {\n  width: 100%;\n  border-radius: 30px;\n  background-color: white;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 20px;\n  -webkit-gap: 20px;\n  padding: var(--user-profile-padding);\n  /* box-shadow: 2px 5px 30px #B9CDFF; */\n}\n\n.img-place {\n  width: 50%;\n  height: auto;\n  aspect-ratio: 1;\n  background-color: var(--text-grey);\n}\n\n.city-search {\n  position: relative;\n}\n\n.container-city {\n  position: relative;\n  width: 100%;\n  max-height: 400px;\n  z-index: 9;\n  overflow: auto;\n  border-radius: 5px;\n}\n\n.city-input {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: var(--padding-input);\n  width: 100%;\n  background-color: white;\n  color: black;\n  transition: ease-in-out 0.2s;\n  cursor: pointer;\n}\n\n.city-input:not(:last-child) {\n  border-bottom: 1px solid #cecece;\n}\n\n.city-input:hover {\n  background-color: var(--blue-main);\n  color: white;\n  transition: ease-in-out 0.2s;\n}\n\n.add-image {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.disable {\n  display: block;\n  width: 0;\n  height: 0;\n  background: none;\n  border: 0;\n}\n\n.disable,\n.disable:hover,\n.disable:active,\n.disable:focus {\n  outline: none;\n}\n\n.nav-search-right {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  -webkit-gap: 20px;\n}\n\n.search-right-block {\n  display: block;\n  padding-bottom: 15px;\n  color: var(--text-grey);\n  border-bottom: 2px solid rgba(175, 180, 202, 0);\n  font-weight: 600;\n}\n\n.active-link {\n  border-bottom: 2px solid var(--blue-main);\n  color: var(--blue-main);\n  cursor: pointer;\n}\n\n.people-list {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  -webkit-gap: 30px;\n}\n\n.admin-people-list {\n  margin-top: 100px;\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  -webkit-gap: 30px;\n}\n\n.people-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.people-avatar {\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.people-description {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  -webkit-gap: 5px;\n  margin-left: 10px;\n  margin-right: auto;\n}\n\n.people-username {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 800;\n}\n\n.people-city-comp {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 400;\n}\n\n.people-ok {\n  display: block;\n  width: fit-content;\n  border: 0;\n  padding: 18px;\n  background: url('../assets/images/btn_ok.svg') no-repeat center center;\n  background-color: #D1D1D1;\n  border-radius: 5px;\n  transition: ease-in-out 0.2s;\n  cursor: pointer;\n}\n\n.people-ok:hover {\n  background-color: #001AFF;\n  transition: ease-in-out 0.2s;\n}\n\n.people-delete {\n  display: block;\n  width: fit-content;\n  border: 0;\n  padding: 18px;\n  background: url('../assets/images/delete.svg') no-repeat center center;\n  background-color: #D1D1D1;\n  border-radius: 5px;\n  transition: ease-in-out 0.2s;\n  cursor: pointer;\n}\n\n.people-delete:hover {\n  background-color: #FF6666;\n  transition: ease-in-out 0.2s;\n}\n\n.btn-people {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.rules {\n  position: relative;\n  display: block;\n  max-width: 100%;\n  padding: var(--padding-input);\n  background-color: var(--blue-main);\n  border: 0;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  color: white;\n  transition: ease-in-out 0.2s;\n  text-overflow: ellipsis;\n}\n\n.rules:hover {\n  background-color: #001AFF;\n  transition: ease-in-out 0.2s;\n}\n\n.challenge-list {\n  list-style-type: none;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n.challenge-card {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding: 20px;\n  background-color: rgba(208, 208, 255, 0.3);\n  border-radius: 5px;\n}\n\n@media (max-width: 800px) {\n  .challenge-card {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    -webkit-gap: 15px;\n    padding: 15px;\n    background-color: rgba(208, 208, 255, 0.3);\n    border-radius: 5px;\n  }\n}\n\n.challenge-card-mini {\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n  -webkit-gap: 15px;\n  align-items: center;\n}\n\n.challenge-card-main {\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n  -webkit-gap: 15px;\n  align-items: center;\n  padding-bottom: 15px;\n  transition: ease-in-out 0.3s;\n}\n\n.challenge-card-main:hover {\n  padding: 15px;\n  background-color: white;\n  border-radius: 5px;\n  transition: ease-in-out 0.3s;\n}\n\n.challenge-header {\n  font-size: calc(var(--font-size) + 4px);\n  font-weight: 600;\n  line-height: calc(var(--font-size) + 8px);\n  cursor: pointer;\n}\n\n.challenge-company {\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.challenge-landing {\n  display: inline-block;\n  padding: 10px 20px;\n  color: white;\n  background-color: var(--blue-main);\n  width: fit-content;\n  border-radius: 5px;\n  border: none;\n  transition: ease-in-out 0.3s;\n  cursor: pointer;\n}\n\n.challenge-landing:hover {\n  background-color: #174bce;\n  transition: ease-in-out 0.3s;\n}\n\n.challenge-avatar {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 15px;\n}\n\n.my-challenge {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: var(--main-center-head);\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  -webkit-gap: 12px;\n  padding: var(--block-padding);\n  padding-top: 20px;\n  padding-bottom: 0;\n  background: linear-gradient(147.75deg, #d153ff 0%, #001AFF 100%);\n}\n\n.my-challenge p {\n  color: white;\n  font-size: calc(var(--font-size) + 2px);\n  font-weight: 500;\n}\n\n.challenge-information {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 10px;\n  -webkit-gap: 10px;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.challenge-date {\n  color: var(--blue-main);\n  font-size: 14px;\n  padding-left: calc(var(--font-size) + 5px);\n  background: url('../assets/images/time.svg');\n  background-repeat: no-repeat;\n  background-size: var(--font-size);\n  background-position: left center;\n}\n\n.challenge-description {\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 6px);\n}\n\n.challenge-activity {\n  display: inline-block;\n  padding: 10px 20px;\n  font-size: 16px;\n  line-height: 16px;\n  color: white;\n  background-color: var(--blue-main);\n  width: fit-content;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: ease-in-out 0.3s;\n}\n\n.challenge-activity:hover {\n  background-color: #174bce;\n  transition: ease-in-out 0.3s;\n}\n\n.challenge-activity-no {\n  display: inline-block;\n  padding: 10px 20px;\n  font-size: 16px;\n  line-height: 16px;\n  color: white;\n  background-color: #FF6666;\n  width: fit-content;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: ease-in-out 0.3s;\n}\n\n.challenge-activity-no:hover {\n  background-color: red;\n  transition: ease-in-out 0.3s;\n}\n\n.challenge-activity-yes {\n  display: inline-block;\n  padding: 10px 20px;\n  font-size: 16px;\n  line-height: 16px;\n  color: white;\n  background-color: var(--blue-main);\n  width: fit-content;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: ease-in-out 0.3s;\n}\n\n.challenge-activity-yes:hover {\n  background-color: darkblue;\n  transition: ease-in-out 0.3s;\n}\n\n@media (max-width: 1000px) {\n  .challenge-activity {\n    display: inline-block;\n    padding: 10px 20px;\n    font-size: 14px;\n    line-height: 14px;\n    color: white;\n    background-color: var(--blue-main);\n    width: fit-content;\n    border-radius: 5px;\n  }\n\n  .challenge-activity-no {\n    display: inline-block;\n    padding: 10px 20px;\n    font-size: 14px;\n    line-height: 14px;\n    color: white;\n    background-color: #FF6666;\n    width: fit-content;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n}\n\n.message-user {\n  color: #28A8E9;\n  font-size: 14px;\n  padding-left: calc(var(--font-size) + 5px);\n  background: url('../assets/images/Logo.svg');\n  background-repeat: no-repeat;\n  background-size: var(--font-size);\n  background-position: left center;\n}\n\n.challenge-money {\n  font-size: calc(var(--font-size) + 10px);\n}\n\n.input-work {\n  display: block;\n  font-size: calc(var(--font-size) + 10px);\n  line-height: calc(var(--font-size) + 15px);\n  font-weight: 600;\n  padding: 15px 0;\n  margin-bottom: 20px;\n  outline: none;\n  border: 0;\n  border-bottom: 2px solid rgba(200, 200, 200, 1);\n}\n\n.input-work:hover,\n.input-work:active,\n.input-work:focus {\n  outline: none;\n}\n\n.responses-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n.respose-item {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding: 20px;\n  border: 2px solid rgba(175, 180, 202, 0.5);\n  border-radius: 5px;\n}\n\n@media (max-width: 800px) {\n  .respose-item {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    -webkit-gap: 15px;\n    padding: 15px;\n    border: 2px solid rgba(175, 180, 202, 0.5);\n    border-radius: 5px;\n  }\n}\n\n.or-or {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 15px;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.accept {\n  font-size: var(--font-size);\n  color: #19CB6B;\n  font-weight: 500;\n}\n\n.no-accept {\n  font-size: var(--font-size);\n  color: #FF6666;\n  font-weight: 500;\n}\n\n.right-block-nav {\n  display: flex;\n  flex-direction: row;\n  gap: 25px;\n  -webkit-gap: 25px;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.right-block-nav-item {\n  display: block;\n  padding-bottom: 15px;\n  border-bottom: 2px solid white;\n  color: var(--blue-main);\n  font-size: var(--font-size);\n  font-weight: 600;\n}\n\n.right-block-link-no {\n  color: var(--text-grey);\n  font-weight: 500;\n  font-size: var(--font-size);\n  border-bottom: 2px solid rgba(175, 180, 202, 0);\n}\n\n.block-info-card {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 8px);\n  gap: 20px;\n  -webkit-gap: 20px;\n  justify-content: space-between;\n  padding: 15px 0 0 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.block-info-card-column {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 8px);\n  padding: 15px 0 0 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.link-site {\n  color: var(--blue-main);\n  font-size: 16px;\n  line-height: 18px;\n  padding-left: 23px;\n  background: url('../assets/images/site.svg') no-repeat;\n  background-size: 18px auto;\n  background-position: left center;\n}\n\n.link-mail {\n  color: var(--blue-main);\n  font-size: 16px;\n  line-height: 18px;\n  padding-left: 23px;\n  background: url('../assets/images/email.svg') no-repeat;\n  background-size: 18px auto;\n  background-position: left center;\n}\n\n.link-call {\n  color: var(--blue-main);\n  font-size: 16px;\n  line-height: 18px;\n  padding-left: 23px;\n  background: url('../assets/images/call.svg') no-repeat;\n  background-size: 18px auto;\n  background-position: left center;\n}\n\n.healine-info-block {\n  color: var(--blue-main);\n  font-size: 16px;\n  line-height: 18px;\n}\n\n.first-message .city {\n  font-size: 14px;\n  line-height: calc(var(--font-size) + 4px);\n}\n\n.important-message {\n  display: block;\n  width: 100%;\n  padding: var(--padding-btn);\n  border: 0;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n  color: white;\n  cursor: pointer;\n  background: url('../assets/images/alarm.svg');\n  background-size: 24px 24px;\n  background-position: left top;\n  background-position-y: 20px;\n  background-position-x: calc(var(--icon-padding) - 8px);\n  background-repeat: no-repeat;\n  background-color: #FF6666;\n}\n\n.comand-card {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding: 20px;\n  background-color: white;\n  border: 2px solid #81869752;\n  border-radius: 5px;\n  transition: ease-in-out 0.3s;\n}\n\n.comand-card:hover {\n  border: 2px solid #dee8ff91;\n  background-color: #dee8ff91;\n  transition: ease-in-out 0.3s;\n}\n\n.comand-card-info {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 15px;\n  -webkit-gap: 15px;\n  align-items: center;\n}\n\n.comand-avatar {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 15px;\n}\n\n.comand-name {\n  font-size: calc(var(--font-size) + 4px);\n  font-weight: 600;\n  line-height: calc(var(--font-size) + 8px);\n  cursor: pointer;\n}\n\n.comand-description {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  color: var(--blue-main);\n  font-weight: 500;\n}\n\n.comand-info-text {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  -webkit-gap: 5px;\n}\n\n.del-coamnd {\n  display: block;\n  width: 100%;\n  padding: var(--padding-btn);\n  border: 0;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  color: white;\n  cursor: pointer;\n  background: url('../assets/images/del_comand.svg');\n  background-size: auto var(--font-size);\n  background-position: left center;\n  background-position-x: var(--icon-padding);\n  background-repeat: no-repeat;\n  background-color: #FF6666;\n}\n\n.kurs {\n  font-size: calc(var(--font-size) + 4px);\n  line-height: calc(var(--font-size) + 4px);\n  font-weight: 400;\n}\n\n.kurs::after {\n  content: 'курс';\n  font-weight: 400;\n}\n\n.education-stage {\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 8px);\n  font-weight: 600;\n}\n\n.education-stage::before {\n  content: 'Ступень образования: ';\n  font-weight: 400;\n}\n\n.role-wrapper {\n  position: relative;\n  width: 100%;\n  height: fit-content;\n}\n\n.input-role {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid rgba(175, 180, 202, 0.5);\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n}\n\n.input-role:hover {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid var(--blue-main);\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n}\n\n.btn-ok {\n  position: absolute;\n  display: block;\n  /* width: 40px; */\n  height: calc(100% - 10px);\n  aspect-ratio: 1;\n  top: 5px;\n  right: 5px;\n  bottom: 0;\n  background: url('../assets/images/btn_ok.svg') no-repeat center center;\n  background-color: var(--blue-main);\n  border-radius: 5px;\n  border: 0;\n  font-size: var(--text-size);\n  line-height: var(--text-lineheight);\n  font-weight: 700;\n  color: white;\n  cursor: pointer;\n  transition: ease-in-out 0.3s;\n}\n\n.btn-ok:hover {\n  background-color: #174bce;\n  transition: ease-in-out 0.3s;\n}\n\n.btn-change {\n  position: absolute;\n  display: block;\n  /* width: 40px; */\n  height: calc(100% - 10px);\n  aspect-ratio: 1;\n  top: 5px;\n  right: 5px;\n  bottom: 0;\n  background: url('../assets/images/huy.svg') no-repeat center center;\n  background-color: var(--blue-main);\n  border-radius: 5px;\n  border: 0;\n  font-size: var(--text-size);\n  line-height: var(--text-lineheight);\n  font-weight: 700;\n  color: white;\n  cursor: pointer;\n}\n\n\n.btn-ne-ok {\n  position: absolute;\n  display: block;\n  /* width: 40px; */\n  height: calc(100% - 10px);\n  aspect-ratio: 1;\n  top: 5px;\n  right: 5px;\n  bottom: 0;\n  background: url('../assets/images/del_comand.svg') no-repeat center center;\n  background-color: #FF6666;\n  border-radius: 5px;\n  border: 0;\n  font-size: var(--text-size);\n  line-height: var(--text-lineheight);\n  font-weight: 700;\n  color: white;\n  cursor: pointer;\n}\n\n.green {\n  background-color: #B9FFD9;\n}\n\n.welcome {\n  display: block;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  padding: 0 0 0 calc(var(--font-size) + 5px);\n  background: url('../assets/images/welcome.svg') no-repeat left center;\n  background-size: var(--font-size) auto;\n}\n\n.stage-button {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  background-color: rgba(54, 110, 255, 0.1);\n  border: 2px solid rgba(54, 110, 255, 0.1);\n  cursor: pointer;\n}\n\n.stage-card-info {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.stage-card-heading {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 600;\n}\n\n.stage-card-done {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 500;\n  color: var(--blue-main);\n  padding-left: calc(var(--font-size) + 6px);\n  background: url('../assets/images/btn_ok_green.svg') no-repeat left center;\n  background-size: var(--font-size) auto;\n}\n\n.stage-card-fale {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 500;\n  color: #FF3D00;\n  padding-left: calc(var(--font-size) + 6px);\n  background: url('../assets/images/fale.svg') no-repeat left center;\n  background-size: var(--font-size) auto;\n}\n\n.stage-card-active {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 500;\n  color: var(--blue-main);\n  padding-left: calc(var(--font-size) + 6px);\n  background: url('../assets/images/clock.svg') no-repeat left center;\n  background-size: var(--font-size) auto;\n}\n\n.stage-card-name {\n  font-size: calc(var(--font-size) + 8px);\n  line-height: calc(var(--font-size) + 16px);\n  text-align: left;\n  font-weight: 600;\n}\n\n.stage-card-info-date {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  -webkit-gap: 5px;\n  width: 100%;\n}\n\n.stage-card-date {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 600;\n}\n\n.stage-button-done {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  background-color: #00de6f0e;\n  border: 2px solid #00de6f0e;\n  cursor: pointer;\n}\n\n.stage-button-done .stage-card-active {\n  background: url('../assets/images/done.svg') no-repeat left center;\n  background-size: var(--font-size) auto;\n}\n\n.stage-button-fale {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  background-color: #de004a1a;\n  border: 2px solid #de004a1a;\n  cursor: pointer;\n}\n\n.stage-button-done .stage-card-active {\n  background: url('../assets/images/done.svg') no-repeat left center;\n  background-size: var(--font-size) auto;\n}\n\n.stage-button-soon {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  background-color: white;\n  border: 2px solid rgba(175, 180, 202, 0.5);\n  opacity: 0.6;\n  filter: saturate(0);\n  cursor: pointer;\n}\n\n.stage-button-soon .stage-card-active {\n  background: url('../assets/images/lock.svg') no-repeat left center;\n  background-size: var(--font-size) auto;\n}\n\n.result {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 600;\n  color: var(--blue-main);\n}\n\n.result::after {\n  content: ' баллов';\n}\n\n.telega {\n  padding: var(--padding-input);\n  background: url('../assets/images/Logo.svg') no-repeat left center;\n  background-size: calc(var(--font-size) + 4px) auto;\n  background-position-x: 20px;\n  padding-left: 50px;\n  font-size: var(--font-size);\n  font-weight: 600;\n  line-height: var(--font-size);\n  color: #28A8E9;\n  background-color: rgba(208, 208, 255, 0.3);\n  border-radius: 5px;\n}\n\n.block-input-flex-column {\n  display: flex;\n  border: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.criteria {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  padding: 20px;\n  background-color: #ebebeb;\n  border-radius: 5px;\n}\n\n.criteria-input {\n  display: block;\n  max-width: 130px;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid rgba(175, 180, 202, 0.5);\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n}\n\n.add-criteria {\n  display: flex;\n  width: 50px;\n  height: 49px;\n  background-color: var(--blue-main);\n  border: 0;\n}\n\n.delete-criteria {\n  display: block;\n  padding: var(--padding-input);\n  padding-left: 10px;\n  padding-right: 10px;\n  border: 0;\n  outline: 0;\n  background: none;\n}\n\n.criteria .btn-main {\n  background: var(--blue-main);\n}\n\n.summa-criteria {\n  font-size: var(--font-size);\n  color: black;\n  font-weight: 700;\n  color: var(--blue-main);\n}\n\n.summa-criteria:before {\n  content: 'Итоговая сумма: ';\n  color: black;\n}\n\n.spravka {\n  position: fixed;\n  bottom: 10px;\n  right: 0px;\n  z-index: 999;\n}\n\n.spravka-text {\n  display: block;\n  padding: 15px 15px;\n  background-color: #366EFF;\n  border-bottom-left-radius: 15px;\n  border-top-left-radius: 15px;\n  box-shadow: 2px 5px 30px #42507079;\n  color: white;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  cursor: pointer;\n}\n\n.spravka-text-block {\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  box-shadow: 2px 5px 30px #42507079;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.spravka-link {\n  display: block;\n  color: black;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  padding: 20px 30px;\n}\n\n.spravka-link:not(:last-child) {\n  border-bottom: 1px solid #d3d3d3;\n}\n\n.spravka-link:hover {\n  background-color: var(--blue-main);\n  color: white;\n}\n\n.sorry-block {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 30px;\n  -webkit-gap: 30px;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(147.75deg, #E7A4FF 0%, #001AFF 100%);\n  background-size: cover;\n  color: white;\n}\n\n.sorry-heading {\n  font-size: 400px;\n  line-height: 300px;\n  font-weight: 700;\n}\n\n.sorry-text {\n  font-size: 21px;\n  line-height: 32px;\n  width: 40vw;\n  text-align: center;\n}\n\n.sorry-link {\n  font-weight: 700;\n  border-bottom: 2px solid rgb(255, 187, 0);\n  color: rgb(255, 187, 0);\n}\n\n@media (max-width: 1000px) {\n  .sorry-heading {\n    font-size: 200px;\n    line-height: 180px;\n    font-weight: 700;\n  }\n\n  .sorry-text {\n    font-size: 21px;\n    line-height: 32px;\n    width: 60vw;\n    text-align: center;\n  }\n\n  .sorry-link {\n    font-weight: 700;\n    border-bottom: 2px solid rgb(255, 187, 0);\n    color: rgb(255, 187, 0);\n  }\n\n}\n\n@media (max-width: 600px) {\n  .sorry-heading {\n    font-size: 100px;\n    line-height: 80px;\n    font-weight: 700;\n  }\n\n  .sorry-text {\n    font-size: 21px;\n    line-height: 32px;\n    width: 80vw;\n    text-align: center;\n  }\n\n  .sorry-link {\n    font-weight: 700;\n    border-bottom: 2px solid rgb(255, 187, 0);\n    color: rgb(255, 187, 0);\n  }\n\n}\n\n\n.load-file-input {\n  display: block;\n  width: 100%;\n  padding: var(--padding-btn);\n  border: 0;\n  border-radius: 5px;\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  color: white;\n  cursor: pointer;\n  background: url('../assets/images/arrow-btn.svg');\n  background-size: auto var(--font-size);\n  background-position: left center;\n  background-position-x: var(--icon-padding);\n  background-repeat: no-repeat;\n  background-color: var(--blue-main);\n  margin-top: 15px;\n}\n\n.load-file-input:hover {\n  background-color: #174bce;\n  transition: ease-in-out 0.3s;\n}\n\n.load-file-hidden {\n  display: none;\n}\n\n.settihgs-link {\n  font-size: 15px;\n  line-height: 15px;\n  color: var(--blue-main);\n  margin-top: 5px;\n  cursor: pointer;\n}\n\n.container-ads {\n  display: block;\n  border: 1px solid #d3d3d3;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.ads-input {\n  padding: var(--padding-input);\n  cursor: pointer;\n  transition: ease-in-out 0.3s;\n}\n\n.ads-input:not(:last-child) {\n  border-bottom: 1px solid #d3d3d3;\n}\n\n.ads-input:hover {\n  background-color: var(--blue-main);\n  color: white;\n  transition: ease-in-out 0.3s;\n}\n\n.preview-background {\n  background-color: var(--blue-main);\n  color: white;\n}\n\n.preview-background:hover {\n  background-color: #174bce;\n  border: 2px solid #174bce;\n}\n\n.preview-background .btn-description {\n  color: white;\n}\n\n.hidden {\n  display: none;\n}\n\n.flex-btn-stage {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.btn-stage {\n  padding: var(--padding-input);\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  background: none;\n  border: 2px solid #81869752;\n  border-radius: 5px;\n  width: 100%;\n}\n\n.stage-name-heading {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 600;\n  color: var(--blue-main);\n  text-transform: uppercase;\n}\n\n.stage-name-headline {\n  font-size: calc(var(--font-size) + 2px);\n  line-height: calc(var(--font-size) + 6px);\n  text-align: left;\n  font-weight: 500;\n}\n\n.delete-stage {\n  display: block;\n  width: fit-content;\n  color: #FF6666;\n  border-bottom: 1px solid #FF6666;\n  cursor: pointer;\n}\n\n.blue-button {\n  background-color: var(--blue-main);\n}\n\n.rating-users {\n  display: block;\n  width: fit-content;\n  color: var(--blue-main);\n  border-bottom: 1px solid var(--blue-main);\n}\n\n.block-rating {\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  background-color: white;\n  border-radius: 5px;\n}\n\n.block-rating-flex {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.left-block-rating {\n  width: 100vw;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n}\n\n.content-rating {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.main-list-center-rating {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  /* width: var(--block-center); */\n  padding: var(--block-padding);\n  padding-top: var(--main-center-head);\n  padding-bottom: 55px;\n  width: 100%;\n}\n\n.rating-info {\n  display: flex;\n  padding: 20px 2px 30px 2px;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n.header-rating {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  width: 100%;\n  height: var(--main-center-head);\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  -webkit-gap: 12px;\n  padding: var(--block-padding);\n  padding-top: 20px;\n  padding-bottom: 0;\n  background: linear-gradient(147.75deg, #d153ff 0%, #001AFF 100%);\n}\n\n.header-rating p {\n  color: white;\n}\n\n.rating-row-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  border-bottom: 1px solid #42507079;\n}\n\n.rating-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  border-bottom: 1px solid #42507079;\n}\n\n.rating-cell-header {\n  padding: 10px 5px 15px 5px ;\n  font-weight: 600;\n}\n\n.rating-cell {\n  padding: 10px 5px 15px 5px ;\n  font-weight: 400;\n}\n\n.position {\n  width: 10%;\n}\n\n.fio-rating {\n  width: 25%;\n}\n\n.university {\n  width: 13%;\n}\n\n.country {\n  width: 13%;\n}\n\n.city-rating {\n  width: 18%;\n}\n\n.point {\n  width: 10%;\n}\n\n.yes-no-header {\n  width: 10%;\n}\n\n.yes-no {\n  width: 10%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.yes-no-label {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.text-label {\n  margin-left: 5px;\n}\n\n.user-info-rating {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.btn-flex-rating {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.rating-btn {\n  width: fit-content;\n  padding: 10px 15px;\n  border: 2px solid white;\n  color: white;\n}\n\n.rating-end {\n  width: fit-content;\n}\n\n.non-active-students {\n  color: var(--blue-main);\n  font-weight: 600;\n}\n\n.student-stat {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: white;\n  border-radius: 5px;\n}\n\n.student-stat-fale {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: #FF6666;\n  border-radius: 5px;\n}\n\n.student-stat-wins {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: #19CB6B;\n  border-radius: 5px;\n}\n\n.student-stat-gold {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: rgb(177, 165, 96);\n  border-radius: 5px;\n}\n\n.student-stat-silver {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: rgb(122, 122, 122);\n  border-radius: 5px;\n}\n\n.student-stat-bronze {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: rgb(126, 78, 46);\n  border-radius: 5px;\n}\n\n.student-stat-point {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: white;\n  border-radius: 20px;\n  overflow: hidden;\n}\n\n.name-stat {\n  position: relative;\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.name-stat-white {\n  position: relative;\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 700;\n  color: white;\n  text-transform: uppercase;\n}\n\n.number-stat {\n  position: relative;\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 700;\n  color: var(--blue-main);\n}\n\n.number-stat-white {\n  position: relative;\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 700;\n  color: white;\n}\n\n.point-graph {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 40%;\n  height: 100%;\n  background: linear-gradient(90.01deg, #366fff6c 0.01%, #fb00ff6c 49.61%, #FF3D00 99.21%);\n  border-radius: 20px;\n}\n\n.point-min {\n  z-index: 999;\n  color: black;\n}\n\n.point-max {\n  z-index: 999;\n  color: black;\n}\n\n.description-stat {\n  font-size: 13px;\n  line-height: 20px;\n}\n\n.point-system {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 22px;\n}\n\n.point-system-fact {\n  font-weight: 600;\n  color: var(--blue-main);\n}\n\n.point-system-max {\n  font-weight: 600;\n  color: var(--blue-main);\n}\n\n.stat-students-wrap {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.stat-students-info {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n  padding: 15px;\n  background-color: white;\n  border-radius: 5px;\n  width: 48%;\n  margin-bottom: 10px;\n}\n\n.stat-students-heading {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  color: black;\n  font-weight: 600;\n}\n\n.stat-students-number {\n  font-size: 32px;\n  line-height: 32px;\n  color: var(--blue-main);\n}\n\n.stat-students-noview {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 10px;\n  -webkit-gap: 10px;\n  align-items: center;\n}\n\n.stat-students-noview-num {\n  font-size: calc((var(--font-size) + 4px) * 2);\n  line-height: calc((var(--font-size) + 4px) * 2);\n  color: #FF6666;\n  font-weight: 600;\n}\n\n.stat-students-noview-text {\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 4px);\n}\n\n.student-info {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.student-info-kurs {\n  font-size: 16px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: var(--blue-main);\n}\n\n.student-info-facult {\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 600;\n}\n\n.stat-challenge-num {\n  font-size: calc((var(--font-size) + 4px) * 2);\n  line-height: calc((var(--font-size) + 4px) * 2);\n}\n\n.btn-preview {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: var(--padding-input);\n  border: 0;\n  border-radius: 5px;\n  border: 2px solid var(--blue-main);\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  background: none;\n  cursor: pointer;\n  background-color: var(--blue-main);\n  color: white;\n  transition: ease-in-out 0.3s;\n}\n\n.btn .preview-backgroung:hover {\n  background-color: #174bce;\n  transition: ease-in-out 0.3s;\n}\n\n.number-registration {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.number-registration-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background-color: white;\n  border-radius: 20px;\n  color: #33353a;\n  transition: ease-in-out 0.3s;\n}\n\n.number-registration-line {\n  display: block;\n  height: 1px;\n  width: calc((100% - 140px) / 2);\n  background-color: #366EFF;\n}\n\n.number-reg {\n  font-size: 18px;\n  line-height: 18px;\n  color: inherit;\n  cursor: default;\n}\n\n.number-registration-item-active {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background-color: var(--blue-main);\n  border-radius: 20px;\n  color: white;\n  transition: ease-in-out 0.3s;\n}\n\n.number-reg-active {\n  font-size: 18px;\n  line-height: 18px;\n  color: inherit;\n  cursor: default;\n}\n\n.number-registration-item:hover {\n  background-color: #174bce;\n  color: white;\n  transition: ease-in-out 0.3s;\n}\n\n.number-registration-item-active:hover {\n  background-color: #174bce;\n  color: white;\n  transition: ease-in-out 0.3s;\n}\n\n.role-btn {\n  background-color: white;\n  border: 2px solid white;\n  text-align: center;\n  transition: ease-in-out 0.3s;\n}\n\n.role-btn:hover {\n  background-color: var(--blue-main);\n  color: white;\n  border: 2px solid var(--blue-main);\n}\n\n.modal-message {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #23335cd7;\n  backdrop-filter: blur(50px);\n  -webkit-backdrop-filter: blur(50px);\n}\n\n.modal-block-message {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  background-color: white;\n  max-width: 320px;\n  border-radius: 10px;\n}\n\n.modal-header {\n  padding: 20px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 2px solid #33353a28;\n}\n\n.modal-heading {\n  font-size: 18px;\n  line-height: 22px;\n  font-weight: 600;\n}\n\n.modal-close {\n  display: block;\n  width: 22px;\n  height: 22px;\n  background: url('../assets/images/close.svg') no-repeat center center;\n  background-size: 18px auto;\n  cursor: pointer;\n}\n\n.modal-message-text {\n  padding: 0 20px 20px;\n  font-size: 18px;\n}\n\n.modal-link {\n  color: var(--blue-main);\n}\n\n.reg-heading {\n  font-size: 18px;\n  color: black;\n  font-weight: 600;\n}\n\n.legal-text {\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.reg-anketa-block {\n  max-width: var(--block-size);\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background-color: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(50px);\n  -webkit-backdrop-filter: blur(50px);\n  position: fixed;\n  top: 0;\n  left: calc((100vw - var(--block-size)) / 2);\n  bottom: 0;\n  z-index: 2;\n  overflow: hidden;\n}\n\n.menu-anketa {\n  padding: var(--block-padding);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  overflow: auto;\n}\n\nstrong {\n  font-weight: 700;\n}\n\n.text-editor-style a {\n  color: var(--blue-main);\n  text-decoration: underline;\n  font-weight: 400;\n}\n\n.cert-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding: 20px;\n  background-color: rgba(208, 208, 255, 0.3);\n  border-radius: 5px;\n}\n\n@media (max-width: 800px) {\n  .cert-card {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    -webkit-gap: 15px;\n    padding: 15px;\n    background-color: rgba(208, 208, 255, 0.3);\n    border-radius: 5px;\n  }\n}\n\n.cert-card-main {\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n  -webkit-gap: 15px;\n  align-items: center;\n  padding-bottom: 15px;\n}\n\n.del-cert {\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n  top: 20px;\n  right: 20px;\n  cursor: pointer;\n}\n\n.cert-preview {\n  color: var(--blue-main);\n  font-size: 14px;\n  padding-left: calc(var(--font-size) + 15px);\n  background: url('../assets/images/preview_blue.svg');\n  background-repeat: no-repeat;\n  background-size: auto 14px;\n  background-position: left center;\n  cursor: pointer;\n}\n\n.cert-info {\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 6px);\n}\n\n.cert-symbol {\n  color: #001AFF;\n}\n\n.cert-image {\n  display: none;\n}\n\n.cert-img-label {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 248px;\n  height: 350px;\n  padding: 30px;\n  background-color: #78819750;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.cert-img-info {\n  position: relative;\n  text-align: center;\n  margin-bottom: 15px;\n  color: white;\n  z-index: 6;\n}\n\n.cert-link {\n  position: relative;\n  font-size: 14px;\n  line-height: 14px;\n  text-transform: uppercase;\n  display: block;\n  width: fit-content;\n  padding: 10px 20px;\n  color: white;\n  background-color: var(--blue-main);\n  text-align: center;\n  border-radius: 5px;\n  cursor: pointer;\n  z-index: 6;\n}\n\n.background-cert {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  object-fit: cover;\n  z-index: 4;\n}\n\n.cert-transparent {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #07163b7c;\n  z-index: 5;\n}\n\n.cert-name-input {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: var(--padding-input);\n  width: 100%;\n  background-color: rgb(226, 242, 255);\n  color: black;\n  transition: ease-in-out 0.2s;\n  cursor: pointer;\n}\n\n.cert-name-input:hover {\n  color: white;\n  background-color: var(--blue-main);\n}\n\n.template {\n  background-color: #2d56bd;\n  padding: 30px;\n  border-radius: 10px;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n}\n\n.template-heading {\n  font-size: calc(var(--font-size) + 12px);\n  line-height: calc(var(--font-size) + 12px);\n  font-weight: 600;\n}\n\n.tamplate-name {\n  background: #7a9eff5b;\n  border: 2px solid #7a9eff5b;\n  color: white;\n}\n\n.tamplate-name::placeholder {\n  color: rgba(255, 255, 255, 0.521);\n}\n\n.template-logo {\n  display: none;\n}\n\n.load-logo {\n  padding: var(--padding-input);\n  border: 2px solid rgba(255, 255, 255, 0.274);\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.template-text {\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 8px);\n}\n\n.flex-btn-template {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  -webkit-gap: 5px;\n  align-items: center;\n}\n\n.template-dowload {\n  padding: var(--padding-input);\n  border: 2px solid var(--blue-main);\n  border-radius: 5px;\n  background-color: var(--blue-main);\n}\n\n.template-draft {\n  display: block;\n  width: fit-content;\n  padding: 0 0 5px 0;\n  background: none;\n  border: 0;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  color: var(--text-grey);\n  font-weight: 600;\n  border-bottom: 1px dashed var(--text-grey);\n}\n\n.template-list {\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 8px);\n  color: white;\n}\n\nol {\n  list-style-position: inside;\n}\n\n.width-btn {\n  width: fit-content;\n}\n\n.date-time-block {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid rgb(255, 255, 255);\n  background: white;\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n}\n\n.start::before {\n  width: 80px;\n  content: 'Начало';\n  color: var(--blue-main);\n}\n\n.end::before {\n  width: 80px;\n  content: 'Конец';\n  color: var(--blue-main);\n}\n\n.date-stage {\n  margin-right: auto;\n}\n\n.date-time-card {\n  padding: 70px 30px 30px 30px;\n  background-color: #e2ebff;\n  position: relative;\n  display: flex;\n  border: 0;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n  max-width: 100%;\n  border-radius: 10px;\n}\n\n.legend-date-time {\n  position: absolute;\n  top: 30px;\n  display: block;\n  max-width: 100%;\n  font-size: var(--legend-size);\n  line-height: var(--legend-size);\n  padding-bottom: 10px;\n  font-weight: 700;\n}\n\n.load-block {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: #2d56bd;\n  animation: anim 1s alternate ease-in-out infinite;\n}\n\n.load-sheet {\n  text-align: center;\n  font-size: 21px;\n  color: white;\n  font-weight: 600;\n}\n\n.load-text {\n  text-align: center;\n  font-size: var(--font-size);\n  color: white;\n  margin-top: 15px;\n  font-weight: 300;\n  margin-bottom: 20px;\n  max-width: 380px;\n  padding: 0 30px;\n}\n\n@keyframes anim {\n  0% {\n    background: #3766df;\n  }\n\n  100% {\n    background: #582dbd;\n  }\n}\n\n.circle-block {\n  width: 90px;\n  height: 15px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 15px;\n}\n\n.circle-load {\n  width: 15px;\n  height: 15px;\n  border-radius: 15px;\n  background-color: white;\n  animation: anima 1s alternate ease-in-out infinite;\n}\n\n.one-load {\n  animation-delay: 0ms;\n}\n\n.two-load {\n  animation-delay: 200ms;\n}\n\n.three-load {\n  animation-delay: 400ms;\n}\n\n@keyframes anima {\n  0% {\n    background-color: rgba(255, 255, 255, 0.199);\n  }\n\n  100% {\n    background-color: rgb(255, 255, 255);\n  }\n}\n\n.cert-body {\n  position: relative;\n  background-color: #353535b7;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  backdrop-filter: blur(60px);\n  z-index: 888;\n}\n\n.close-window {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 35px;\n  height: 35px;\n  background: url('../assets/images/del_comand.svg') no-repeat center center;\n  background-size: contain;\n  cursor: pointer;\n}\n\n.cert-top-block {\n  position: relative;\n  width: 100%;\n  height: 71%;\n  background-color: #000747;\n  padding: calc(((var(--cert-height) / 2.83) * 2) / 12);\n  padding-bottom: calc(((var(--cert-height) / 2.83) * 2) / 24);\n  display: flex;\n  flex-direction: column;\n}\n\n.cert-image-main {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 0;\n}\n\n.container-cert {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: var(--cert-height);\n  width: calc((var(--cert-height) / 2.83) * 2);\n  overflow: hidden;\n  background-size: contain;\n  margin: 0 auto;\n}\n\n.qr-cert-info {\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  right: calc(((var(--cert-height) / 2.83) * 2) / 12);\n  width: calc(((var(--cert-height) / 2.83) * 2) / 8);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1vh;\n  -webkit-gap: 1vh;\n}\n\n.qr-cert {\n  width: calc(((var(--cert-height) / 2.83) * 2) / 8);\n  height: calc(((var(--cert-height) / 2.83) * 2) / 8);\n  object-fit: contain;\n}\n\n.cert-number {\n  font-size: calc(var(--cert-height) / 75);\n  line-height: calc(var(--cert-height) / 75);\n  font-weight: 400;\n  color: white;\n}\n\n.cert-sheet-heading {\n  position: relative;\n  font-size: calc(var(--cert-height) / 28);\n  line-height: calc(var(--cert-height) / 28);\n  color: white;\n  margin-bottom: calc(var(--cert-height) / 25);\n  z-index: 2;\n}\n\n.cert-challenge-name {\n  position: relative;\n  z-index: 2;\n  font-size: calc(var(--cert-height) / 31);\n  font-weight: 700;\n  color: white;\n}\n\n.cert-top-block-info {\n  position: relative;\n  z-index: 2;\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.cert-text-info {\n  color: white;\n  font-size: calc(var(--cert-height) / 40);\n  line-height: calc(var(--cert-height) / 40);\n}\n\n.cert-top-block-name {\n  font-size: calc(var(--cert-height) / 24.5);\n  line-height: calc(var(--cert-height) / 24.5);\n  font-weight: 700;\n  color: white;\n  margin-top: calc(var(--cert-height) / 80);\n}\n\n.cert-text-bottom {\n  font-size: calc(var(--cert-height) / 57);\n  line-height: calc(var(--cert-height) / 40);\n  font-weight: 400;\n  color: white;\n  margin-top: calc(var(--cert-height) / 40);\n}\n\n.cert-bottom-block {\n  position: relative;\n  width: 100%;\n  height: 30%;\n  background-color: rgb(255, 255, 255);\n  padding: calc(((var(--cert-height) / 2.83) * 2) / 12);\n  padding-top: calc(((var(--cert-height) / 2.83) * 2) / 20);\n  display: flex;\n  flex-direction: column;\n}\n\n.cert-text-signatory {\n  color: rgba(47, 39, 163, 0.822);\n  font-size: calc(var(--cert-height) / 50);\n  line-height: calc(var(--cert-height) / 50);\n}\n\n.cert-text-jobtitle {\n  font-size: calc(var(--cert-height) / 60);\n  line-height: calc(var(--cert-height) / 42);\n  font-weight: 400;\n  color: rgb(78, 78, 78);\n  margin-top: calc(var(--cert-height) / 70);\n  width: 60%;\n}\n\n.podpis {\n  position: absolute;\n  top: calc(((var(--cert-height) / 2.83) * 2) / 30);\n  right: calc(((var(--cert-height) / 2.83) * 2) / 6);\n  width: calc(((var(--cert-height) / 2.83) * 2) / 6);\n  height: calc(((var(--cert-height) / 2.83) * 2) / 6);\n  object-fit: contain;\n  z-index: 3;\n  mix-blend-mode: multiply;\n}\n\n.pechat {\n  position: absolute;\n  top: calc(((var(--cert-height) / 2.83) * 2) / 30);\n  right: calc(((var(--cert-height) / 2.83) * 2) / 20);\n  width: calc(((var(--cert-height) / 2.83) * 2) / 6);\n  height: calc(((var(--cert-height) / 2.83) * 2) / 6);\n  object-fit: contain;\n  mix-blend-mode: multiply;\n}\n\n.podpisant-info {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: calc(((var(--cert-height) / 2.83) * 2) / 30);\n  border-bottom: 0.2vh solid rgb(221, 221, 221);\n}\n\n.about-braim {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-top: calc(((var(--cert-height) / 2.83) * 2) / 30);\n  align-items: center;\n}\n\n.about-braim-text {\n  font-size: calc(((var(--cert-height) / 2.83) * 2) / 60);\n}\n\n.logo-cert {\n  width: calc(((var(--cert-height-full) / 2.83) * 2) / 6);\n  height: calc(((var(--cert-height-full) / 2.83) * 2) / 8);\n  object-fit: contain;\n}\n\n.cert-body-full {\n  position: relative;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  backdrop-filter: blur(60px);\n  z-index: 888;\n}\n\n.container-cert-full {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: var(--cert-height-full);\n  width: calc((var(--cert-height-full) / 2.83) * 2);\n  overflow: hidden;\n  background-size: contain;\n  margin: 0 auto;\n}\n\n.cert-top-block-full {\n  position: relative;\n  width: 100%;\n  height: 72%;\n  background-color: #000747;\n  padding: calc(((var(--cert-height-full) / 2.83) * 2) / 12);\n  padding-bottom: calc(((var(--cert-height-full) / 2.83) * 2) / 24);\n  display: flex;\n  flex-direction: column;\n}\n\n.cert-image-main-full {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 0;\n}\n\n.container-cert-full {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: var(--cert-height-full);\n  width: calc((var(--cert-height-full) / 2.83) * 2);\n  overflow: hidden;\n  background-size: contain;\n  margin: 0 auto;\n}\n\n.qr-cert-info-full {\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  right: calc(((var(--cert-height-full) / 2.83) * 2) / 12);\n  width: calc(((var(--cert-height-full) / 2.83) * 2) / 8);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1vh;\n  -webkit-gap: 1vh;\n}\n\n.qr-cert-full {\n  width: calc(((var(--cert-height-full) / 2.83) * 2) / 8);\n  height: calc(((var(--cert-height-full) / 2.83) * 2) / 8);\n  object-fit: contain;\n}\n\n.cert-number-full {\n  font-size: calc(var(--cert-height-full) / 75);\n  line-height: calc(var(--cert-height-full) / 75);\n  font-weight: 400;\n  color: white;\n}\n\n.cert-sheet-heading-full {\n  position: relative;\n  font-size: calc(var(--cert-height-full) / 28);\n  line-height: calc(var(--cert-height-full) / 28);\n  color: white;\n  margin-bottom: calc(var(--cert-height-full) / 25);\n  z-index: 2;\n}\n\n.cert-challenge-name-full {\n  position: relative;\n  z-index: 2;\n  font-size: calc(var(--cert-height-full) / 31);\n  font-weight: 700;\n  color: white;\n}\n\n.cert-top-block-info-full {\n  position: relative;\n  z-index: 2;\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.cert-text-info-full {\n  color: white;\n  font-size: calc(var(--cert-height-full) / 40);\n  line-height: calc(var(--cert-height-full) / 40);\n}\n\n.cert-top-block-name-full {\n  font-size: calc(var(--cert-height-full) / 24.5);\n  line-height: calc(var(--cert-height-full) / 24.5);\n  font-weight: 700;\n  color: white;\n  margin-top: calc(var(--cert-height-full) / 80);\n}\n\n.cert-text-bottom-full {\n  font-size: calc(var(--cert-height-full) / 57);\n  line-height: calc(var(--cert-height-full) / 40);\n  font-weight: 400;\n  color: white;\n  margin-top: calc(var(--cert-height-full) / 40);\n}\n\n.cert-bottom-block-full {\n  position: relative;\n  width: 100%;\n  height: 30%;\n  background-color: rgb(255, 255, 255);\n  padding: calc(((var(--cert-height-full) / 2.83) * 2) / 12);\n  padding-top: calc(((var(--cert-height-full) / 2.83) * 2) / 20);\n  display: flex;\n  flex-direction: column;\n}\n\n.cert-text-signatory-full {\n  color: rgba(47, 39, 163, 0.822);\n  font-size: calc(var(--cert-height-full) / 50);\n  line-height: calc(var(--cert-height-full) / 50);\n}\n\n.cert-text-jobtitle-full {\n  font-size: calc(var(--cert-height-full) / 58);\n  line-height: calc(var(--cert-height-full) / 42);\n  font-weight: 400;\n  color: rgb(78, 78, 78);\n  margin-top: calc(var(--cert-height-full) / 70);\n  width: 60%;\n}\n\n.podpis-full {\n  position: absolute;\n  top: calc(((var(--cert-height-full) / 2.83) * 2) / 30);\n  right: calc(((var(--cert-height-full) / 2.83) * 2) / 6);\n  width: calc(((var(--cert-height-full) / 2.83) * 2) / 6);\n  height: calc(((var(--cert-height-full) / 2.83) * 2) / 6);\n  object-fit: contain;\n  z-index: 3;\n  mix-blend-mode: multiply;\n}\n\n.pechat-full {\n  position: absolute;\n  top: calc(((var(--cert-height-full) / 2.83) * 2) / 30);\n  right: calc(((var(--cert-height-full) / 2.83) * 2) / 20);\n  width: calc(((var(--cert-height-full) / 2.83) * 2) / 6);\n  height: calc(((var(--cert-height-full) / 2.83) * 2) / 6);\n  object-fit: contain;\n  mix-blend-mode: multiply;\n}\n\n.podpisant-info-full {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: calc(((var(--cert-height-full) / 2.83) * 2) / 30);\n  border-bottom: 0.2vh solid rgb(221, 221, 221);\n}\n\n.about-braim-full {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 2vh;\n  padding-top: calc(((var(--cert-height-full) / 2.83) * 2) / 30);\n  align-items: center;\n}\n\n.about-braim-text-full {\n  font-size: calc(((var(--cert-height-full) / 2.83) * 2) / 60);\n}\n\n.logo-cert-full {\n  display: block;\n  width: calc(((var(--cert-height-full) / 2.83) * 2) / 6);\n  height: calc(((var(--cert-height-full) / 2.83) * 2) / 8);\n  object-fit: contain;\n}\n\n.cert-stat {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: white;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.cert-stat:hover {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  background-color: rgb(179, 205, 255);\n  border-radius: 5px;\n}\n\n.year-search {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding-bottom: 10px;\n}\n\n.year-cert-active {\n  color: var(--blue-main);\n  font-weight: 600;\n  padding: 10px 0;\n  font-size: 18px;\n  line-height: 18px;\n  border-bottom: 2px solid var(--blue-main);\n}\n\n.year-cert {\n  color: var(--blue-main);\n  font-weight: 600;\n  padding: 10px 0;\n  font-size: 18px;\n  line-height: 18px;\n  opacity: 50%;\n}\n\n.logo-braim-cert {\n  display: flex;\n  flex-direction: column;\n  gap: 1vh;\n  width: calc(var(--cert-height) / 9);\n}\n\n.logo-braim-cert img {\n  display: block;\n  width: calc(var(--cert-height) / 9);\n  height: auto;\n}\n\n.logo-braim-cert-full {\n  display: flex;\n  flex-direction: column;\n  gap: 1vh;\n  width: calc(var(--cert-height-full) / 9);\n}\n\n.logo-braim-cert-full img {\n  display: block;\n  width: calc(var(--cert-height-full) / 9);\n  height: auto;\n}\n\n.how-print {\n  position: absolute;\n  bottom: 20px;\n  z-index: 940;\n  padding: 15px 25px;\n  color: white;\n  background-color: var(--blue-main);\n  border-radius: 5px;\n}\n\n.how-print-popup {\n  position: absolute;\n  width: 100vw;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background-color: #353535b7;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  height: 100%;\n  backdrop-filter: blur(60px);\n  z-index: 955;\n}\n\n.how-print-block-popup {\n  position: relative;\n  height: 80%;\n  bottom: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.how-print-info-text {\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 4px);\n  color: white;\n  margin-bottom: 15px;\n  max-width: 600px;\n  text-align: center;\n  padding: 0 30px;\n}\n\n.how-print-info {\n  display: block;\n  height: 90%;\n}\n\n@media print\n{\n  .no-print, .no-print *\n  {\n    display: none !important;\n  }\n}\n\n.without_ampm::-webkit-datetime-edit-ampm-field {\n  display: none;\n}\ninput[type=time]::-webkit-clear-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -o-appearance: none;\n  -ms-appearance:none;\n  appearance: none;\n  margin: -10px;\n}\n\n.settings-test {\n  display: block;\n  position: absolute;\n  z-index: 8;\n  bottom: 20px;\n  right: 20px;\n  padding: 10px 20px 10px 45px;\n  background: url('../assets/images/settings_white_new.svg');\n  background-position-x: 18px;\n  background-position-y: center;\n  background-repeat: no-repeat;\n  background-color: #001AFF;\n  background-size: 16px 16px;\n  box-shadow: 2px 5px 30px #B9CDFF;\n  border: 0;\n  border-radius: 20px;\n  color: white;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.interest-item-theme {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: fit-content;\n  padding: 10px 15px;\n  font-size: 14px;\n  line-height: 14px;\n  color: white;\n  background-color: var(--blue-main);\n  cursor: pointer;\n  border-radius: 5px;\n  transition: ease-in-out 0.3s;\n}\n\n.interest-item-theme:hover {\n  background-color: #174bce;\n  transition: ease-in-out 0.3s;\n}\n\n@media (max-width: 800px) {\n  .interest-item-theme {\n    display: inline-block;\n    width: fit-content;\n    padding: 10px 10px 10px 15px;\n    font-size: 12px;\n    line-height: 12px;\n    color: white;\n    background-color: var(--blue-main);\n    border-radius: 5px;\n  }\n}\n\n.close-white {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  object-fit: contain;\n  margin-left: 12px;\n\n}\n\n.plus-theme {\n  background-color: #001AFF;\n  color: white;\n}\n\n.theme-number::before {\n  content: '/ ';\n  margin-left: 8px;\n}\n\n.test-block-quiestion {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background-color: #d3dcf598;\n  padding: 20px;\n  border: 0;\n  border-radius: 5px;\n}\n\n.test-legend {\n  position: absolute;\n  top: 15px;\n}\n\n.test-question {\n  margin-top: 20px;\n  background: none;\n  font-size: calc(var(--font-size) + 6px);\n  line-height: calc(var(--font-size) + 12px);\n  outline: 0;\n  border: 0;\n}\n\n.test-question:hover,\n.test-question:focus,\n.test-question:active {\n  border: 0;\n  outline: 0;\n}\n\n.load-image-test {\n  display: none;\n}\n\n.load-image-test-block {\n  padding-top: 15px;\n  border-top: 2px solid #33353a33;\n}\n\n.load-image-test-btn {\n  padding: 10px 0 10px 20px;\n  font-size: var(--font-size);\n  line-height: 18px;\n  font-weight: 600;\n  background: url('../assets/images/load_img.svg') no-repeat left center;\n  background-size: auto 18px;\n}\n\n.wrap-answer {\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n  -webkit-gap: 15px;\n  align-items: center;\n}\n\n.ok-answer {\n  width: 20px;\n  height: 18px;\n  background: url('../assets/images/ok_answer.svg') no-repeat center center;\n  background-size: contain;\n  cursor: pointer;\n}\n\n.del-answer {\n  width: 20px;\n  height: 18px;\n  background: url('../assets/images/delete_red.svg') no-repeat center center;\n  background-size: contain;\n  cursor: pointer;\n}\n\n.ok-answer:hover {\n  width: 20px;\n  height: 18px;\n  background: url('../assets/images/ok_answer_blue.svg') no-repeat center center;\n  background-size: contain;\n}\n\n.ok-answer-checked {\n  width: 20px;\n  height: 18px;\n  background: url('../assets/images/ok_answer_blue.svg') no-repeat center center;\n  background-size: contain;\n}\n\n.delete-answer {\n  display: inline;\n  width: fit-content;\n  height: fit-content;\n  color: #FF6666;\n  border-bottom: 1px solid #FF6666;\n}\n\n.row-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n@media (max-width: 900px) {\n  .row-wrapper {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: 15px;\n    -webkit-gap: 15px;\n  }\n}\n\n.btn-info {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding: var(--padding-input);\n  background-color: #d3dcf598;\n  border-radius: 5px;\n}\n\n.btn-info-heading {\n  font-size: calc(var(--font-size) + 2px);\n  line-height: calc(var(--font-size) + 2px);\n  text-align: left;\n  font-weight: 600;\n  padding-left: 25px;\n  background: url('../assets/images/info.svg') no-repeat left center;\n  background-size: auto calc(var(--font-size) + 2px);\n}\n\n.btn-info-heading-plus {\n  font-size: calc(var(--font-size) + 2px);\n  line-height: calc(var(--font-size) + 2px);\n  font-weight: 600;\n  padding-left: 25px;\n  background: url('../assets/images/plus_blue.svg') no-repeat left center;\n  background-size: auto calc(var(--font-size) + 2px);\n  cursor: pointer;\n}\n\n.btn-info-text {\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500;\n  text-align: left;\n  white-space: pre-wrap;\n}\n\n.btn-info-link {\n  color: var(--blue-main);\n  border-bottom: 2px solid var(--blue-main);\n}\n\n.btn-info-settings {\n  font-size: calc(var(--font-size) + 2px);\n  line-height: calc(var(--font-size) + 2px);\n  font-weight: 600;\n  padding-left: 25px;\n  background: url('../assets/images/settings_blue.svg') no-repeat left center;\n  background-size: auto calc(var(--font-size) + 2px);\n}\n\n.btn-info-edit {\n  font-size: calc(var(--font-size) + 2px);\n  line-height: calc(var(--font-size) + 2px);\n  font-weight: 600;\n  padding-left: 25px;\n  background: url('../assets/images/edit_blue.svg') no-repeat left center;\n  background-size: auto calc(var(--font-size) + 2px);\n  color: black;\n}\n\n.block-input-row {\n  position: relative;\n  display: flex;\n  border: 0;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n  width: 100%;\n}\n\n.test-btn-change {\n  display: block;\n}\n\n.row-wrapper-fieldset {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 15px;\n  -webkit-gap: 15px;\n  border: 0;\n  outline: 0;\n}\n\n@media (max-width: 900px) {\n  .row-wrapper-fieldset {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    gap: 15px;\n    -webkit-gap: 15px;\n  }\n}\n\n.test-theme-block {\n  position: relative;\n  background-color: white;\n  padding: 30px;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n@media (max-width: 1280px) {\n  .test-theme-block {\n    background-color: white;\n    padding: 20px;\n    border-radius: 5px;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    -webkit-gap: 15px;\n  }\n}\n\n@media (max-width: 800px) {\n  .test-theme-block {\n    background-color: white;\n    padding: 15px;\n    border-radius: 5px;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    -webkit-gap: 15px;\n  }\n}\n\n.test-theme-form {\n  position: relative;\n  background-color: #d3dcf598;\n  padding: 30px;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n@media (max-width: 1280px) {\n  .test-theme-form {\n    background-color: #d3dcf598;\n    padding: 20px;\n    border-radius: 5px;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    -webkit-gap: 15px;\n  }\n}\n\n@media (max-width: 800px) {\n  .test-theme-form {\n    background-color: #d3dcf598;\n    padding: 15px;\n    border-radius: 5px;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    -webkit-gap: 15px;\n  }\n}\n\n.test-btn-change {\n  background-color: #ffffff;\n  border: 2px solid white;\n  font-weight: 600;\n  border: 2px solid #c2c2c2\n}\n\n.test-btn-change-active {\n  padding-left: 50px;\n  background: url('../assets/images/ok_answer_blue.svg') no-repeat 20px center;\n  background-size: auto 11px;\n  background-color: #ffffff;\n  border: 2px solid var(--blue-main);\n  font-weight: 600;\n  color: var(--blue-main);\n}\n\n.number-question {\n  font-size: calc(var(--font-size) + 2px);\n  line-height: calc(var(--font-size) + 2px);\n  color: var(--blue-main);\n  font-weight: 600;\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  -webkit-gap: 5px;\n  margin-bottom: 15px;\n}\n\n.number-question-text {\n  font-size: calc(var(--font-size) + 2px);\n  line-height: calc(var(--font-size) + 2px);\n  color: var(--blue-main);\n  font-weight: 600;\n}\n\n.test-point {\n  color: var(--blue-main);\n  font-weight: 600;\n}\n\n.test-point::before {\n  content: ':';\n  color: var(--blue-main);\n}\n\n.test-time {\n  color: var(--blue-main);\n  font-weight: 600;\n}\n\n.test-time::before {\n  content: ':';\n  color: var(--blue-main);\n}\n\n.btn-grey {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  background: #33353a77;\n  border: 0;\n  border-radius: 5px;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 700;\n  color: white;\n  cursor: pointer;\n  transition: ease-in-out 0.3s;\n}\n\n.container-img-test {\n  position: relative;\n  width: 100%;\n  height: 400px;\n  overflow: hidden;\n}\n\n.img-test-question-background {\n  position: absolute;\n  top: -10%;\n  left: -10%;\n  right: 0;\n  bottom: 0;\n  width: 120%;\n  height: 120%;\n  object-fit: cover;\n  filter: blur(50px);\n  z-index: 1;\n  opacity: 50%;\n}\n\n.img-test-question {\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.answer-button {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid rgba(175, 180, 202, 0.5);\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  cursor: pointer;\n}\n\n.answer-button:hover {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid var(--blue-main);\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  cursor: pointer;\n}\n\n.answer-button-active {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid var(--blue-main);\n  background: var(--blue-main);\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  color: white;\n  cursor: pointer;\n}\n\n.img-load-block {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.img-load {\n  display: block;\n  width: 35px;\n  height: 35px;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.img-load-text {\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 4px);\n  font-weight: 600;\n}\n\n.img-load-del {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n}\n\n.flex-button-pay {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 30px;\n  -webkit-gap: 30px;\n  width: 100%;\n}\n\n.btn-pay-invoice {\n  display: block;\n  font-size: var(--font-size);\n  text-align: left;\n  color: var(--blue-main);\n  border-bottom: 1px solid var(--blue-main);\n}\n\n.requisites {\n  background: rgba(27, 255, 57, 0.13);\n}\n\n.headline-balance {\n  font-size: 60px;\n  line-height: 60px;\n  margin-top: 15px;\n  font-weight: 600;\n}\n\n.headline-balance::after {\n  content: '₽';\n  font-size: 36px;\n}\n\n.btn-info-red {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding: var(--padding-input);\n  background-color: #ff000021;\n  border-radius: 5px;\n}\n\n.balance-red {\n  background-color: #ff00001c;\n}\n\n.balance-green {\n  background-color: #00ff9d1c;\n}\n\n.btn-info-heading-green {\n  font-size: calc(var(--font-size) + 2px);\n  line-height: calc(var(--font-size) + 2px);\n  text-align: left;\n  font-weight: 600;\n  padding-left: 25px;\n  background: url('../assets/images/done_green.svg') no-repeat left center;\n  background-size: auto calc(var(--font-size) + 2px);\n}\n\n.headline-tarif {\n  font-size: calc(var(--font-size) + 6px);\n  line-height: calc(var(--font-size) + 6px);\n  font-weight: 600;\n}\n\n.btn-tarif-edit {\n  display: block;\n  font-size: var(--font-size);\n  text-align: left;\n  color: var(--blue-main);\n  background: url('../assets/images/edit_blue.svg') no-repeat left center;\n  background-size: auto var(--font-size);\n  padding-left: calc(var(--font-size) + 8px);\n}\n\n.tarif-about {\n  display: flex;\n  flex-direction: column;\n  border-radius: 5px;\n  padding-top: 20px;\n}\n\n.tarif-about-item {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.tarif-about-item:not(:last-child) {\n  padding-bottom: 15px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.123);\n}\n\n.tarif-about-item:not(:first-child) {\n  padding-top: 15px;\n}\n\n.tarif-about-text {\n  font-size: 14px;\n  line-height: 20px;\n  max-width: 70%;\n}\n\n.tarif-about-num {\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 600;\n}\n\n.headline-additional-service {\n  padding-top: 20px;\n  font-size: 21px;\n  line-height: 28px;\n  font-weight: 600;\n}\n\n.btn-info-heading-money {\n  font-size: calc(var(--font-size) + 2px);\n  line-height: calc(var(--font-size) + 2px);\n  text-align: left;\n  font-weight: 600;\n  padding-left: 25px;\n  background: url('../assets/images/money.svg') no-repeat left center;\n  background-size: auto calc(var(--font-size) + 2px);\n}\n\n.btn-info-heading-money:after {\n  content: '₽';\n}\n\n.flex-button-additional-service {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.pay-service-info {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  font-weight: 600;\n  padding-left: 25px;\n  background: url('../assets/images/info.svg') no-repeat left center;\n  background-size: auto var(--font-size);\n}\n\n.pay-service-info-ok {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  font-weight: 600;\n  padding-left: 25px;\n  background: url('../assets/images/done_green.svg') no-repeat left center;\n  background-size: auto var(--font-size);\n}\n\n.day-write-off-on {\n  display: block;\n  width: fit-content;\n  padding: 10px 25px;\n  background: #00074723;\n  border-radius: 5px;\n}\n\n.date-month-list {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  -webkit-gap: 30px;\n  padding-top: 30px;\n  margin-bottom: 30px;\n}\n\n.day-write-month {\n  font-size: 24px;\n  line-height: 24px;\n  font-weight: 600;\n}\n\n.day-month-item {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  -webkit-gap: 5px;\n}\n\n.day-write-off-summ {\n  font-size: 36px;\n  line-height: 36px;\n  color: #FF6666;\n}\n\n.day-write-off-summ::before {\n  content: '—';\n}\n\n.day-write-off-summ::after {\n  content: '₽';\n}\n\n.day-failed-summ {\n  font-size: 36px;\n  line-height: 36px;\n  color: #FF6666;\n}\n\n.day-failed-summ::after {\n  content: '₽';\n}\n\n.day-write-on-summ {\n  font-size: 36px;\n  line-height: 36px;\n  color: #00a35f;\n}\n\n.day-write-on-summ::before {\n  content: '+';\n}\n\n.day-write-on-summ::after {\n  content: '₽';\n}\n\n.day-write-off-desc {\n  font-size: var(--font-size);\n  line-height: var(--text-lineheight);\n}\n\n.pay-date-update {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  text-align: left;\n  font-weight: 600;\n  padding-left: 25px;\n  background: url('../assets/images/clock.svg') no-repeat left center;\n  background-size: auto var(--font-size);\n}\n\n.tarif-flex-status {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.container-schet {\n  width: 1000px;\n  margin: 0 auto;\n}\n\n.header-schet {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 20px 0;\n  margin-bottom: 30px;\n}\n\n.logo-schet {\n  display: block;\n  width: 100px;\n}\n\n.schet-heading {\n  font-size: 36px;\n  line-height: 36px;\n  font-weight: 600;\n  margin-bottom: 30px;\n}\n\n.schet-text {\n  font-size: 16px;\n  line-height: 22px;\n  color: #33353a;\n  margin-bottom: 30px;\n}\n\n.button-print {\n  padding: 10px 20px;\n  color: white;\n  background-color: var(--blue-main);\n  border-radius: 5px;\n  width: fit-content;\n  margin-bottom: 30px;\n}\n\n.schet-text-red {\n  font-size: 16px;\n  line-height: 22px;\n  color: rgb(250, 42, 52);\n  margin-bottom: 30px;\n}\n\n.schet-block {\n  padding: 30px 30px;\n}\n\n.schet-block-header {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.schet-rekvizity {\n  width: 700px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n}\n\n.schet-rekvizity-text {\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 400;\n}\n\n.schet-qr {\n  display: block;\n  width: 180px;\n  height: 180px;\n  object-fit: contain;\n}\n\n.schet-heading-second {\n  font-size: 21px;\n  line-height: 21px;\n  text-align: center;\n  font-weight: 600;\n}\n\n.full-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  margin-bottom: 40px;\n}\n\n.table {\n  border: 1px solid black;\n  border-collapse: collapse;\n  padding: 10px;\n  vertical-align: bottom;\n}\n\n.first-td-two {\n  width: 10%\n}\n\n.first-td-three {\n  width: 40%;\n}\n\n.schet-big-heading {\n  font-size: 24px;\n  line-height: 24px;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.shet-number {\n  font-weight: 600;\n}\n\n.sсhet-date {\n  font-weight: 600;\n}\n\n.poluchatel::before {\n  display: inline-block;\n  content: 'Получатель: ';\n  font-weight: 600;\n}\n\n.payer::before {\n  display: inline-block;\n  content: 'Плательщик: ';\n  font-weight: 600;\n}\n\n.inn::before {\n  display: inline-block;\n  content: 'ИНН: ';\n  font-weight: 600;\n}\n\n.small-col {\n  width: 8%;\n}\n\n.big-col {\n  width: 40%;\n}\n\n.schet-quant::before {\n  display: inline-block;\n  content: 'Всего наименований: ';\n  font-weight: 600;\n}\n\n.schet-summ::before {\n  display: inline-block;\n  content: 'на сумму: ';\n  font-weight: 600;\n}\n\n.rukovoditel {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-top: 80px;\n  padding-bottom: 150px;\n}\n\n.shalashniy {\n  display: inline-block;\n  font-size: 16px;\n  line-height: 20px;\n  width: fit-content;\n}\n\n.line {\n  width: 50%;\n  height: 1px;\n  background-color: black;\n}\n\n.schet-podpis {\n  position: absolute;\n  top: -70px;\n  left: 35%;\n  display: block;\n  width: 20%;\n  mix-blend-mode: multiply;\n}\n\n.schet-pechat {\n  position: absolute;\n  top: -100px;\n  left: 50%;\n  display: block;\n  width: 18%;\n  mix-blend-mode: multiply;\n}\n\n@media print {\n  .no-print {\n    display: none;\n  }\n}\n\n.wait-status {\n  font-size: 36px;\n  line-height: 36px;\n  color: #696d77;\n}\n\n.wait-status::after {\n  content: '₽';\n}\n\n.incorrect-tin {\n  background-color: rgba(255, 0, 0, 0.151);\n}\n\n.checkbox-radio-center {\n  position: relative;\n  top: 0;\n}\n\n.label-checkbox-radio-center {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.rating-cell {\n  padding: 10px 5px 15px 5px ;\n  font-weight: 400;\n}\n\n.position {\n  width: 5%;\n}\n\n.fio-rating {\n  width: 20%;\n}\n\n.university {\n  width: 10%;\n}\n\n.country {\n  width: 10%;\n}\n\n.city-rating {\n  width: 13%;\n}\n\n.point {\n  width: 5%;\n}\n\n.percent {\n  width: 5%;\n}\n\n.yes-no-header {\n  width: 10%;\n}\n\n.max-bal-rating::before {\n  content: 'Максимальное количество баллов: ';\n  color: black;\n}\n\n.rating-print-settings {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #00074798;\n  z-index: 999;\n  backdrop-filter: blur(30px);\n  -webkit-backdrop-filter: blur(30px);\n  display: flex;\n}\n\n.rating-print-export {\n  width: fit-content;\n  padding: 40px;\n  background-color: rgb(255, 255, 255);\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n}\n\n.rating-print-fieldset {\n  width: fit-content;\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  -webkit-gap: 20px;\n  align-items: center;\n  padding: 10px 20px 20px 20px;\n  border-radius: 5px;\n}\n\n.rating-print-label {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.btn-grey {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  background: #b7b9ca;\n  border: 0;\n  border-radius: 5px;\n  font-size: var(--text-size);\n  line-height: var(--text-lineheight);\n  font-weight: 700;\n  color: white;\n  cursor: pointer;\n}\n\n.rating-export-btn {\n  padding: 10px 20px;\n  width: fit-content;\n}\n\n.rating-export-wrapper {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.block-print-export {\n  padding: 50px;\n}\n\n.text-block-print-export {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  -webkit-gap: 30px;\n  margin-bottom: 30px;\n}\n\n.heading-print-export {\n  font-size: 28px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.date-location-print-export {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.info-text-print-export {\n  padding: 40px;\n  border: 2px solid black;\n  font-size: 18px;\n  line-height: 28px;\n  border-radius: 5px;\n}\n\n.jury-print-export {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  -webkit-gap: 30px;\n  margin-bottom: 50px;\n  padding: 40px;\n  border: 2px solid black;\n  border-radius: 5px;\n}\n\n.heading-jury-print-export {\n  font-size: 28px;\n  line-height: 28px;\n  font-weight: 600;\n}\n\n.jury-print-export-list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.jury-print-export-item {\n  width: 23%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.jury-print-export-item:last-child {\n  margin-right: auto;\n}\n\n.name-jury-print-expor {\n  font-size: 21px;\n  line-height: 21px;\n  font-weight: 600;\n}\n\n.block-print-export-stam-official {\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.print-export-first-last-name {\n  font-size: 24px;\n  line-height: 32px;\n  font-weight: 600;\n}\n\n.print-export-dolzhnost {\n  font-size: 18px;\n  margin-top: 5px;\n  font-weight: 400;\n}\n\n.stam-official {\n  position: absolute;\n  right: 0;\n  display: block;\n  height: 200px;\n  width: auto;\n  mix-blend-mode: multiply;\n}\n\n.stam-official-podpis {\n  display: block;\n  position: absolute;\n  left: 0;\n  height: 150px;\n  width: auto;\n  margin-right: auto;\n}\n\n.block-print-export-stam {\n  position: relative;\n  width: 350px;\n  height: 280px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.button-add-print {\n  display: block;\n  position: absolute;\n  z-index: 8;\n  bottom: 20px;\n  right: 20px;\n  padding: 10px 20px 10px 45px;\n  background: url('../assets/images/print_doc.svg');\n  background-position-x: 18px;\n  background-position-y: center;\n  background-repeat: no-repeat;\n  background-color: #001AFF;\n  box-shadow: 2px 5px 30px #B9CDFF;\n  border: 0;\n  border-radius: 20px;\n  color: white;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.fixed-position {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n}\n\n.stage-card-new {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  -webkit-gap: 30px;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  background-color: rgb(224, 233, 255);\n}\n\n.stage-card-new-info {\n  cursor: pointer;\n}\n\n.stage-card-new-false {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  -webkit-gap: 30px;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  background-color: white;\n  border: 2px solid red;\n}\n\n.stage-card-new-work {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  -webkit-gap: 30px;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid rgba(175, 180, 202, 0.5);\n}\n\n.stage-card-new-future {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  -webkit-gap: 30px;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid rgba(175, 180, 202, 0.5);\n  opacity: 0.5;\n}\n\n.stage-card-new-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.status-stage {\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 500;\n  color: var(--text-grey);\n}\n\n.status-stage-admin {\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 600;\n  color: var(--text-grey);\n}\n\n.status-stage-admin::before {\n  content: 'Статус: ';\n  font-weight: 500;\n}\n\n.status-stage-result {\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 600;\n  color: var(--blue-main);\n}\n\n.graph {\n  position: relative;\n  display: block;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.graph-line-container {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 10px;\n  background-color: #c7c7c7;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.graph-line-line {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  background: linear-gradient(90.01deg, #366fff6c 0.01%, #fb00ff6c 49.61%, #FF3D00 99.21%);\n  width: 80%;\n  border-radius: 5px;\n}\n\n.graph-line-false {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  background: red;\n  width: 30%;\n  border-radius: 5px;\n}\n\n.graph-line-result {\n  margin-top: 10px;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.graph-line-result::before {\n  content: 'Итоговый результат: ';\n  font-weight: 400;\n}\n\n.graph-line-result-jury {\n  margin-top: 10px;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.graph-line-result-jury::before {\n  content: 'Ваша оценка: ';\n  font-weight: 400;\n}\n\n.graph-line-projects-jury {\n  margin-top: 10px;\n  font-size: 16px;\n  line-height: 20px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.graph-line-projects-jury::before {\n  content: 'Вы оцениили: ';\n  font-weight: 400;\n}\n\n.stage-card-new-heading {\n  width: fit-content;\n  font-size: 21px;\n  line-height: 28px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  cursor: pointer;\n}\n\n.stage-card-new-text {\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 20px;\n}\n\n.stage-card-new-wrapper-link {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 20px;\n  -webkit-gap: 20px;\n}\n\n.card-standart-link {\n  display: block;\n  width: fit-content;\n  font-size: 12px;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: var(--blue-main);\n  font-weight: 600;\n  padding-bottom: 5px;\n  cursor: pointer;\n  border-bottom: 1px solid var(--blue-main);\n}\n\n.card-standart-link-false {\n  display: block;\n  width: fit-content;\n  font-size: 12px;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: red;\n  font-weight: 600;\n  padding-bottom: 5px;\n  border-bottom: 1px solid red;\n  cursor: pointer;\n}\n\n\n.stage-card-new-gap {\n  width: fit-content;\n  display: flex;\n  flex-direction: row;\n  padding: 10px 20px;\n  background-color: white;\n  gap: 5px;\n  -webkit-gap: 5px;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.stage-card-new-gap-red {\n  width: fit-content;\n  display: flex;\n  flex-direction: row;\n  padding: 10px 20px;\n  background-color: red;\n  color: white;\n  gap: 5px;\n  -webkit-gap: 5px;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.stage-card-new-gap-work {\n  width: fit-content;\n  display: flex;\n  flex-direction: row;\n  padding: 10px 20px;\n  background-color: #d3d7ff;\n  gap: 5px;\n  -webkit-gap: 5px;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.stage-card-new-date {\n  font-weight: 600;\n}\n\n.stage-card-new-comand {\n  font-weight: 600;\n}\n\n.rating-challenge-list {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  -webkit-gap: 30px;\n}\n\n.rating-challenge-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.rating-num {\n  font-size: calc(var(--font-size) + 4px);\n  font-weight: 600;\n  line-height: calc(var(--font-size) + 8px);\n}\n\n.rating-num::after {\n  content: ' баллов';\n}\n\n.rating-criterion {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n}\n\n.rating-challenge-avatar {\n  display: block;\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 50px;\n}\n\n.rating-challenge-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n.rating-challenge-user {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  -webkit-gap: 5px;\n}\n\n.rating-challenge-name {\n  font-size: 16px;\n  line-height: 16px;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.rating-challenge-place {\n  display: block;\n  width: fit-content;\n  font-size: 16px;\n  line-height: 16px;\n  padding: 5px 10px;\n  background-color: #dde4f5;\n  border-radius: 5px;\n}\n\n.rating-chellenge-num {\n  display: block;\n  width: fit-content;\n  padding: 5px 10px;\n  background-color: var(--blue-main);\n  font-size: 18px;\n  line-height: 18px;\n  font-weight: 600;\n  color: white;\n  border-radius: 20px;\n}\n\n.myresults-total {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.myresults-total-heading {\n  font-size: 21px;\n  line-height: 21px;\n  font-weight: 600;\n}\n\n.myresults-total-heading-num {\n  font-size: 21px;\n  line-height: 21px;\n  font-weight: 600;\n  color: var(--blue-main);\n}\n\n.myresults-stage {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n.my-results-stage-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.myresults-stage-heading {\n  font-size: 21px;\n  line-height: 21px;\n  font-weight: 600;\n  height: fit-content;\n}\n\n.content-new {\n  display: inline-block;\n  width: fit-content;\n  height: fit-content;\n  color: var(--blue-main);\n  font-weight: 600;\n}\n\n.content-new:hover {\n  display: inline-block;\n  width: fit-content;\n  height: fit-content;\n  color: var(--blue-main);\n  font-weight: 600;\n}\n\n.red-color {\n  color: red;\n}\n\n.link-landing {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  display: block;\n  width: 25px;\n  height: 25px;\n  background: url('../assets/images/link_landing.svg') center center no-repeat;\n  background-size: contain;\n}\n\n.button-add-question {\n  display: block;\n  position: absolute;\n  z-index: 8;\n  bottom: 20px;\n  right: 20px;\n  padding: 10px 20px 10px 45px;\n  background: url('../assets/images/question.svg');\n  background-position-x: 18px;\n  background-position-y: center;\n  background-repeat: no-repeat;\n  background-color: #001AFF;\n  box-shadow: 2px 5px 30px #B9CDFF;\n  border: 0;\n  border-radius: 20px;\n  color: white;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.rating-profile {\n  /* border-radius: 15px; */\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  padding: var(--user-profile-padding);\n  border-radius: 30px;\n  /* border: 2px solid #d1d1d3; */\n  background-color: rgba(175, 197, 247, 0.171);\n}\n\n.block-nav-list {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: stretch;\n  gap: 15px;\n}\n\n.block-nav-item {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 20px;\n  background-color: rgba(175, 197, 247, 0.171);\n  border-radius: 15px;\n  width: 48%;\n  cursor: pointer;\n}\n\n.block-nav-img {\n  width: 30px;\n  height: 30px;\n  object-fit: contain;\n  margin-right: 15px;\n}\n\n.block-nav-item .block-nav-img {\n  filter: saturate(50%);\n  opacity: 70%;\n  transition: ease-in-out 0.3s;\n}\n\n.block-nav-item:hover .block-nav-img {\n  filter: saturate(100%);\n  opacity: 100%;\n  transition: ease-in-out 0.3s;\n}\n\n.block-nav-heading {\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  margin-bottom: 5px;\n}\n\n.block-nav-text {\n  font-size: 13px;\n  line-height: 16px;\n  font-weight: 500;\n  color: #33353a;\n}\n\n.user-profile-main-block {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  -webkit-gap: 20px;\n  align-items: center;\n}\n\n.user-profile-rating {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  -webkit-gap: 5px;\n}\n\n.user-profile-rating-info {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.user-profile-rating-status-block {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.raring-graph {\n  position: relative;\n  width: 100%;\n  height: 10px;\n  background-color: #e2e2e2;\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.rating-graph-line {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 68%;\n  background: linear-gradient(117deg, #366EFF 0%, #FA00FF 50%, #FF3D00 100%);\n  border-radius: 5px;\n}\n\n.user-profile-rating-num {\n  font-size: 16px;\n  line-height: 22px;\n  padding-left: 27px;\n  background: url('../assets/images/Star_2.svg') left center no-repeat;\n  background-size: 22px 22px;\n}\n\n.grade-block {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  -webkit-gap: 8px;\n}\n\n.fieldset-hidden {\n  outline: none;\n  border: 0;\n}\n\n.label-jury {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  -webkit-gap: 10px;\n  align-items: center;\n}\n\n.label-jury-text {\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n}\n\n.button-add-rate {\n  display: block;\n  position: absolute;\n  z-index: 8;\n  bottom: 20px;\n  right: 20px;\n  padding: 10px 20px 10px 20px;\n  background-color: #001AFF;\n  box-shadow: 2px 5px 30px #B9CDFF;\n  border: 0;\n  border-radius: 20px;\n  color: white;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btn-non-check {\n  position: absolute;\n  display: block;\n  /* width: 40px; */\n  height: calc(100% - 10px);\n  aspect-ratio: 1;\n  top: 5px;\n  right: 5px;\n  bottom: 0;\n  background: none;\n  border-radius: 5px;\n  border: 0;\n  font-size: var(--text-size);\n  line-height: var(--text-lineheight);\n  font-weight: 700;\n  color: white;\n  cursor: pointer;\n}\n\n.active-link-red {\n  border-bottom: 2px solid var(--blue-main);\n  color: rgb(139, 0, 0);\n}\n\n.btn-blue-width {\n  display: block;\n  width: fit-content;\n  padding: var(--padding-input);\n  background: var(--blue-main);\n  border: 0;\n  border-radius: 5px;\n  font-size: var(--text-size);\n  line-height: var(--text-lineheight);\n  font-weight: 700;\n  color: white;\n  cursor: pointer;\n}\n\n.green-challenge-landing {\n  display: inline-block;\n  padding: 10px 20px 10px 40px;\n  color: white;\n  background: url('../assets/images/done_stroke.svg') no-repeat left center;\n  background-size: var(--font-size) auto;\n  background-position-x: 15px;\n  background-color: rgb(6, 158, 112);\n  width: fit-content;\n  border-radius: 5px;\n  border: none;\n  transition: ease-in-out 0.3s;\n}\n\n.green-challenge-card {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding: 20px;\n  background-color: rgba(6, 158, 112, 0.116);\n  border-radius: 5px;\n}\n\n.btn-main-green {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  background-color: rgb(6, 158, 112);\n  border: 0;\n  border-radius: 5px;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 700;\n  color: white;\n  cursor: pointer;\n  transition: ease-in-out 0.3s;\n}\n\n.btn-landing {\n  display: block;\n  width: 100%;\n  padding: var(--padding-input);\n  background-color: var(--blue-main);\n  border: 0;\n  border-radius: 5px;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  font-weight: 700;\n  color: white;\n  cursor: pointer;\n  transition: ease-in-out 0.3s;\n}\n\n.load-image-design-block {\n  padding-top: 15px;\n}\n\n.load-image-design {\n  display: none;\n}\n\n.img-load-design {\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 4px);\n  font-weight: 600;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.play-video-test {\n  display: block;\n  height: 20px;\n  width: auto;\n}\n\n.video-popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #00074798;\n  z-index: 999;\n  backdrop-filter: blur(30px);\n  -webkit-backdrop-filter: blur(30px);\n}\n\n.container-video-popup {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 80%;\n  height: 80%;\n}\n\n.video-popup-youtube {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.modul-list{\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n.modul-item {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding: 20px;\n  border: 2px solid rgba(175, 180, 202, 0.5);\n  border-radius: 5px;\n}\n\n@media (max-width: 800px) {\n  .modul-item {\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    -webkit-gap: 15px;\n    padding: 15px;\n    border: 2px solid rgba(175, 180, 202, 0.5);\n    border-radius: 5px;\n  }\n}\n\n.modul-item-check {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding: 20px;\n  border: 2px solid #366fff33;\n  border-radius: 5px;\n  background-color: #366fff33;\n}\n\n.link-materials {\n  position: relative;\n  z-index: 50;\n  display: block;\n  width: fit-content;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n  padding-bottom: 5px;\n  color: var(--blue-main);\n  border-bottom: 1px solid var(--blue-main);\n}\n\n.link-materials:hover {\n  color: blue;\n  border-bottom: 1px solid blue;\n}\n\n.course-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  padding: var(--padding-input);\n  background-color: #d3dcf598;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.loopa {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  display: block;\n  width: 30px;\n  height: 30px;\n  background: url('../assets/images/loopa.svg') center center no-repeat;\n  background-size: 30px 30px;\n  background-color: rgba(0, 0, 0, 0.356);\n}\n\n.flag-path {\n  fill: red;\n}\n\n.flag-time:nth-child(2n) .flag-form .flag-path {\n  fill: var(--blue-main);\n}\n\n.flag-time:nth-child(3n) .flag-form .flag-path {\n  fill: blue;\n}\n\n.flag-time:nth-child(4n) .flag-form .flag-path {\n  fill: green;\n}\n\n.flag-time:nth-child(5n) .flag-form .flag-path {\n  fill: orange;\n}\n\n.flag-time:nth-child(6n) .flag-form .flag-path {\n  fill: rgb(212, 0, 255);\n}\n\n.container-ctf {\n  width: 100vw;\n  margin: 0 auto;\n  padding: 60px 2vw;\n  background-color: #edf1f3;\n}\n\n.ctf-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.ctf-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.ctf-item:nth-child(2n) {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: black;\n}\n\n.ctf-user {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  -webkit-gap: 10px;\n  width: 150px;\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 600;\n}\n\n.flag-time {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n}\n\n.flag-form {\n  position: relative;\n}\n\n.header-dashboard {\n  width: 100vw;\n  padding: 20px 2.5vw;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  background-color: white;\n  border-bottom: 1px solid rgb(222, 222, 222);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.dashboard {\n  background-color: rgb(221, 225, 235);\n}\n\n.container-dashboard {\n  width: 95vw;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n  margin: 0 auto;\n  padding-top: 80px;\n}\n\n.logo-braim-dash {\n  display: block;\n  height: 20px;\n}\n\n.dashboard-item {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 50px 30px 20px 30px;\n  background-color: white;\n  border-radius: 10px;\n}\n\n/* .dashboard-item:nth-child(2n) {\n  background-color: rgb(221, 225, 235);\n} */\n\n.ctf-name-comand {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  display: block;\n  padding: 5px 10px;\n  border-radius: 20px;\n  font-size: 14px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: white;\n  background-color: var(--blue-main);\n}\n\n.ctf-rating {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: block;\n  padding: 5px 10px;\n  border-radius: 20px;\n  font-size: 14px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: white;\n  background-color: red;\n}\n\n.block-points-ctf {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  height: 30px;\n  cursor: pointer;\n}\n\nctf-line-time {\n  position: absolute;\n  z-index: 1;\n  top: 14px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #b5b8cf;\n}\n\n.point-ctf {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 3;\n  height: 30px;\n  width: 30px;\n  background-color: #FF3D00;\n  border-radius: 15px;\n}\n\n.ctf-rating-point {\n  display: block;\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  width: 10px;\n  height: 10px;\n  background-color: #ff9b7d;\n  border-radius: 10px;\n}\n\n.ctf-rating-top::after {\n  content: ' / ';\n}\n\n\n.flag::before {\n  width: 80px;\n  content: 'Флаг';\n  color: var(--blue-main);\n}\n\n.end::before {\n  width: 80px;\n  content: 'Конец';\n  color: var(--blue-main);\n}\n\n.link-flag {\n  display: block;\n  padding: 15px 20px 15px 43px;\n  width: fit-content;\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 6px);\n  font-weight: 800;\n  color: white;\n  text-transform: uppercase;\n  background: url('../assets/images/link_landing.svg') no-repeat left center;\n  background-size: auto calc(var(--font-size) + 6px);\n  background-position-x: 15px;\n  background-color: var(--blue-main);\n  border-radius: 5px;\n}\n\n.stage-button-new {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid rgba(63, 63, 63, 0.1);\n  cursor: pointer;\n}\n\n.ctf-main-info {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  background-color: white;\n  border: 2px solid rgba(63, 63, 63, 0.1);\n  padding: var(--padding-input);\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n}\n\n.ctf-heading {\n  font-size: 28px;\n  line-height: 33px;\n  font-weight: 800;\n  color: var(--blue-main);\n}\n\n.ctf-main-info-rating {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 20px;\n  -webkit-gap: 20px;\n}\n\n.ctf-main-info-rating-info {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n  padding: var(--padding-input);\n  background-color: rgb(232, 235, 241);\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  border: 2px solid rgba(63, 63, 63, 0.1);\n  color: black;\n  width: calc((100% - 20px) / 2);\n}\n\n@media (max-width: 950px) {\n  .ctf-main-info-rating {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n    -webkit-gap: 20px;\n  }\n\n  .ctf-main-info-rating-info {\n    width: 100%;\n  }\n}\n\n.ctf-rating-num {\n  font-size: 28px;\n  line-height: 28px;\n  font-weight: 800;\n  color: var(--blue-main);\n}\n\n.ctf-main-text {\n  font-size: var(--font-size);\n  line-height: var(--text-lineheight);\n}\n\n.flag-path {\n  fill: red;\n}\n\n.flag-time:nth-child(2n) .flag-form .flag-path {\n  fill: var(--blue-main);\n}\n\n.flag-time:nth-child(3n) .flag-form .flag-path {\n  fill: blue;\n}\n\n.flag-time:nth-child(4n) .flag-form .flag-path {\n  fill: green;\n}\n\n.flag-time:nth-child(5n) .flag-form .flag-path {\n  fill: orange;\n}\n\n.flag-time:nth-child(6n) .flag-form .flag-path {\n  fill: rgb(212, 0, 255);\n}\n\n.container-ctf {\n  width: 100vw;\n  margin: 0 auto;\n  padding: 60px 2vw;\n  background-color: #edf1f3;\n}\n\n.ctf-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.ctf-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.ctf-item:nth-child(2n) {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: black;\n}\n\n.ctf-user {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  -webkit-gap: 10px;\n  width: 150px;\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 600;\n}\n\n.flag-time {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n}\n\n.flag-form {\n  position: relative;\n}\n\n.header-dashboard {\n  width: 100vw;\n  padding: 20px 2.5vw;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  background-color: white;\n  border-bottom: 1px solid rgb(222, 222, 222);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 999;\n}\n\n.dashboard {\n  background-color: rgb(221, 225, 235);\n}\n\n.container-dashboard {\n  position: relative;\n  width: 95vw;\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  -webkit-gap: 30px;\n  margin: 0 auto;\n  padding-top: 80px;\n  padding-bottom: 80px;\n}\n\n.wrap-dash {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 30px;\n  -webkit-gap: 30px;\n  width: 100%;\n}\n\n.logo-braim-dash {\n  display: block;\n  height: 20px;\n}\n\n/* .dashboard-item:nth-child(2n) {\n  background-color: rgb(221, 225, 235);\n} */\n\n.ctf-name-comand {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  display: block;\n  padding: 5px 10px;\n  border-radius: 20px;\n  font-size: 14px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: white;\n  background-color: var(--blue-main);\n}\n\n.ctf-rating {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: block;\n  padding: 5px 10px;\n  border-radius: 20px;\n  font-size: 14px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: white;\n  background-color: red;\n}\n\n.block-points-ctf {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  height: 30px;\n  cursor: pointer;\n}\n\nctf-line-time {\n  position: absolute;\n  z-index: 1;\n  top: 14px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #b5b8cf;\n}\n\n.point-ctf {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 3;\n  height: 30px;\n  width: 30px;\n  background-color: #FF3D00;\n  border-radius: 15px;\n}\n\n.ctf-rating-point {\n  display: block;\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  width: 10px;\n  height: 10px;\n  background-color: #ff9b7d;\n  border-radius: 10px;\n}\n\n.ctf-rating-top::after {\n  content: ' / ';\n}\n\n\n.flag::before {\n  width: 80px;\n  content: 'Флаг';\n  color: var(--blue-main);\n}\n\n.end::before {\n  width: 80px;\n  content: 'Конец';\n  color: var(--blue-main);\n}\n\n.link-flag {\n  display: block;\n  padding: 15px 20px 15px 43px;\n  width: fit-content;\n  font-size: var(--font-size);\n  line-height: calc(var(--font-size) + 6px);\n  font-weight: 800;\n  color: white;\n  text-transform: uppercase;\n  background: url('../assets/images/link_landing.svg') no-repeat left center;\n  background-size: auto calc(var(--font-size) + 6px);\n  background-position-x: 15px;\n  background-color: var(--blue-main);\n  border-radius: 5px;\n}\n\n.stage-button-new {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  padding: var(--padding-input);\n  border-radius: 5px;\n  border: 2px solid rgba(63, 63, 63, 0.1);\n  cursor: pointer;\n}\n\n.ctf-main-info {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  background-color: white;\n  border: 2px solid rgba(63, 63, 63, 0.1);\n  padding: var(--padding-input);\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n}\n\n.ctf-heading {\n  font-size: 28px;\n  line-height: 33px;\n  font-weight: 800;\n  color: var(--blue-main);\n}\n\n.ctf-main-info-rating {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 20px;\n  -webkit-gap: 20px;\n}\n\n.ctf-main-info-rating-info {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n  padding: var(--padding-input);\n  background-color: rgb(232, 235, 241);\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  border: 2px solid rgba(63, 63, 63, 0.1);\n  color: black;\n  width: calc((100% - 20px) / 2);\n}\n\n@media (max-width: 950px) {\n  .ctf-main-info-rating {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n    -webkit-gap: 20px;\n  }\n\n  .ctf-main-info-rating-info {\n    width: 100%;\n  }\n}\n\n.ctf-rating-num {\n  font-size: 28px;\n  line-height: 28px;\n  font-weight: 800;\n  color: var(--blue-main);\n}\n\n.ctf-main-text {\n  font-size: var(--font-size);\n  line-height: var(--text-lineheight);\n}\n\n.moadl-dashboard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  width: 100vw;\n  height: 100vh;\n  background-color: #00074798;\n  backdrop-filter: blur(20px);\n}\n\n.modal-container-dashboard {\n  width: 400px;\n  background-color: white;\n  padding: var(--padding-input);\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.graph-container {\n  position: relative;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 30px;\n  -webkit-gap: 30px;\n  /* background-color: #000747; */\n}\n\n.graph-vert-line {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  right: 0;\n  bottom: 30px;\n  height: calc(100% - 40px);\n  width: 40px;\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: flex-end;\n  justify-content: space-between;\n  border-right: 1px solid #696d7765;\n}\n\n.graph-vert-item {\n  text-align: right;\n  display: block;\n  width: 100%;\n  height: fit-content;\n  padding-right: 5px;\n  font-size: 10px;\n  line-height: 10px;\n}\n\n.graph-vert-item:first-child {\n  height: fit-content;\n}\n\n\n.graph-gor-line {\n  position: absolute;\n  left: 50px;\n  bottom: 0;\n  right: 0;\n  height: 40px;\n  width: calc(100% - 70px);\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  border-top: 1px solid #696d7765;\n}\n\n.graph-gor-item {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 40px;\n}\n\n.dash-line-time {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 1px;\n  height: 15px;\n  background-color: #696d7765;\n}\n\n.graph-gor-item:last-child {\n  width: fit-content;\n}\n\n.dott-graph {\n  display: block;\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  left: 20%;\n  top: 50%;\n  font-size: 60px;\n  background-color: red;\n  z-index: 999;\n}\n\ncanvas {\n  background: none;\n}\n\n.grapth-dot-list {\n  display: block;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.graph-dot {\n  display: block;\n  position: absolute;\n  z-index: 15;\n  width: 10px;\n  height: 10px;\n  transform: translate(-5px, -5px);\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.graph-dot-1 {\n  z-index: 11;\n}\n\n.graph-dot-2 {\n  z-index: 10;\n}\n\n.graph-dot-3 {\n  z-index: 9;\n}\n\n.graph-dot-4 {\n  z-index: 8;\n}\n\n.graph-dot-5 {\n  z-index: 7;\n}\n\n.graph-dot-6 {\n  z-index: 6;\n}\n\n.graph-dot-7 {\n  z-index: 5;\n}\n\n.graph-dot-8 {\n  z-index: 4;\n}\n\n.graph-dot-9 {\n  z-index: 3;\n}\n\n.graph-dot-10 {\n  z-index: 2;\n}\n\n.graph-position {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  transform: scale(1, -1);\n}\n\n#graph1 {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n  background-color: none;\n  background: none;\n}\n\n#graph2 {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 9;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n#graph3 {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 9;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n#graph4 {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 9;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n#graph5 {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 9;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n#graph6 {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 9;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n#graph7 {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 9;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n#graph8 {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 9;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n#graph9 {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 9;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n#graph10 {\n  display: block;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  z-index: 9;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n\n.left-dashboard {\n  display: flex;\n  flex-direction: column;\n  width: 400px;\n  position: sticky;\n  top: 80px;\n}\n\n:root {\n  --dashboard-width: calc(95vw - (400px + 30px));\n  --dashboard-height: calc(((95vw - (400px + 30px)) / 2) + 25px);\n}\n\n.right-block-dash {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  -webkit-gap: 40px;\n  width: var(--dashboard-width);\n}\n\n.dahsboard-right {\n  position: relative;\n  padding: 20px 20px 40px 50px;\n  display: flex;\n  width: var(--dashboard-width);\n  height: var(--dashboard-height);\n  flex-direction: column;\n  background-color: white;\n  border-radius: 20px;\n}\n\n.dashboard-list {\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  border-radius: 20px;\n  padding: 20px 0;\n  width: 100%;\n}\n\n.dashboard-item {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n  -webkit-gap: 15px;\n  align-items: center;\n  background-color: white;\n  cursor: pointer;\n  padding: 0 20px 0 0;\n  transition: filter, transform 0.2s ease-in-out;\n}\n\n.dash-rating-item {\n  position: relative;\n  width: calc((100% - 60px) / 3);\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n  -webkit-gap: 15px;\n  align-items: center;\n  background-color: white;\n  cursor: pointer;\n  padding: 0 20px 0 0;\n  transition: filter, transform 0.2s ease-in-out;\n}\n\n.dash-rating {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 30px;\n  -webkit-gap: 30px;\n  row-gap: 0;\n}\n\n/* .dash-rating-item {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n  -webkit-gap: 15px;\n  align-items: center;\n  background-color: white;\n  cursor: pointer;\n  padding: 0 20px 0 0;\n  transition: filter, transform 0.2s ease-in-out;\n} */\n\n.dash-rating-position {\n  position: relative;\n  font-size: 18px;\n  line-height: 22px;\n  font-weight: 800;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 65px;\n  height: 45px;\n  border-right: 1px solid #696d7765;\n}\n\n.color-dash {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 5%;\n  height: 100%;\n  transition: width 0.3s ease-in-out;\n}\n\n.top-1 {\n  background: red;\n}\n\n.top-2 {\n  background: rgb(255, 123, 0);\n}\n\n.top-3 {\n  background: rgb(255, 187, 0);\n}\n\n.top-4 {\n  background: rgb(74, 202, 0);\n}\n\n.top-5 {\n  background: rgb(0, 202, 175);\n}\n\n.top-6 {\n  background: rgb(1, 153, 255);\n}\n\n.top-7 {\n  background: rgb(1, 48, 255);\n}\n\n.top-8 {\n  background: rgb(132, 1, 255);\n}\n\n.top-9 {\n  background: rgb(255, 1, 242);\n}\n\n.top-10 {\n  background: rgb(177, 0, 103);\n}\n\n.all-people {\n  background: var(--blue-main);\n}\n\n.dashboard-item:hover {\n  filter: drop-shadow(2px 2px 20px rgba(33, 94, 173, 0.2));\n  z-index: 900;\n  /* transform: scale(1.03); */\n}\n\n.dashboard-item:hover .color-dash {\n  width: 100%;\n  z-index: -1;\n}\n\n.dashboard-item:hover .dash-rating-position {\n  color: white;\n}\n\n.dash-rating-item:hover {\n  filter: drop-shadow(2px 2px 20px rgba(33, 94, 173, 0.2));\n  z-index: 900;\n  /* transform: scale(1.03); */\n}\n\n.dash-rating-item:hover .color-dash {\n  width: 100%;\n  z-index: -1;\n}\n\n.dash-rating-item:hover .dash-rating-position {\n  color: white;\n}\n\n.dash-comand-name {\n  display: block;\n  font-size: 16px;\n  line-height: 16px;\n  width: calc(100% - (65px + 95px));\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.dash-rating-num {\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 800;\n  color: var(--blue-main);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 100%;\n  position: absolute;\n  text-align: center;\n  top: 0;\n  right: 15px;\n}\n\n.header-dash-top {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px 20px 20px;\n  border-bottom: 1px solid #696d7765;\n}\n\n.heading-dash {\n  font-size: 21px;\n  line-height: 21px;\n  font-weight: 800;\n}\n\n.btn-wrap-dash {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 5px;\n  -webkit-gap: 5px;\n}\n\n.dash-select {\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 500;\n  color: white;\n  background-color: var(--blue-main);\n  padding: 5px 10px;\n  border-radius: 15px;\n  cursor: pointer;\n  transition: background-color ease-in-out 0.3s;\n}\n\n.dash-select:hover {\n  background-color: #0013be;\n}\n\n.dash-footer {\n  padding: 20px 20px 5px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  -webkit-gap: 10px;\n  font-size: 12px;\n  line-height: 18px;\n  border-top: 1px solid #696d7765;\n}\n\n.dot-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  z-index: 999;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  background: #00074798;\n}\n\n.dot-info-block {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  -webkit-gap: 20px;\n  background-color: white;\n  max-width: 400px;\n  padding: 20px;\n  border-radius: 20px;\n}\n\n@media (max-width: 1440px) {\n  .dash-rating-item {\n    width: calc((100% - 30px) / 2);\n  }\n}\n\n@media (max-width: 1100px) {\n  .dash-rating-item {\n    width: 100%;\n  }\n}\n\n@media (max-width: 900px) {\n  .wrap-dash {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 30px;\n    -webkit-gap: 30px;\n    width: 100%;\n  }\n\n  .left-dashboard {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    position: relative;\n    top: 0;\n  }\n\n  .right-block-dash {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    -webkit-gap: 40px;\n    width: 100%;\n  }\n\n  :root {\n    --dashboard-width: 95vw;\n    --dashboard-height: calc((95vw / 2) + 25px);\n  }\n\n  .dahsboard-right {\n    position: relative;\n    padding: 20px 20px 40px 50px;\n    display: flex;\n    width: var(--dashboard-width);\n    height: var(--dashboard-height);\n    flex-direction: column;\n    background-color: white;\n    border-radius: 20px;\n  }\n\n  .dash-comand-name {\n    font-size: 13px;\n    line-height: 13px;\n  }\n\n  .dash-rating-position {\n    font-size: 13px;\n    line-height: 13px;\n  }\n\n  .dash-rating-num {\n    font-size: 13px;\n    line-height: 13px;\n  }\n}\n\n.date-item-left {\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  left: 0;\n  top: 15px;\n  width: fit-content;\n}\n\n.date-item-right {\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  right: 0;\n  top: 15px;\n  width: fit-content;\n}\n\n.stage-mbti-flex {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  -webkit-gap: 15px;\n}\n\n.stage-mbti .stage-card-new-gap-work {\n  background-color: #0013be;\n}\n\n.block-input-percent {\n  border: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n.recomend-block {\n  width: fit-content;\n  padding: 10px 20px 10px 10px;\n  border-radius: 30px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  -webkit-gap: 10px;\n  background: linear-gradient(90deg, rgba(57,255,80,1) 0%, rgba(0,255,218,1) 100%);\n}\n\n.recomend-percent {\n  display: block;\n  padding: 5px 10px;\n  background-color: white;\n  color: black;\n  border-radius: 15px;\n  font-weight: 700;\n}\n\n.recomend-text {\n  color: black;\n  font-weight: 700;\n}\n\n.recomend-all {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  -webkit-gap: 5px;\n  padding: 20px 25px;\n  /*background: url('../assets/images/backrecom.jpg') no-repeat center center;*/\n  background-size: 100% 100%;\n  border-radius: 15px;\n  cursor: pointer;\n}\n\n.recomend-all p {\n  color: white;\n}\n\n.my-challenge-plan {\n  position: absolute;\n  top: 0;\n  left: 20px;\n  right: 20px;\n  width: calc(100% - 40px);\n  height: var(--main-center-head);\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  -webkit-gap: 12px;\n  padding: 30px;\n  padding-top: 20px;\n  padding-bottom: 0;\n  border-radius: 15px;\n  /*background: url('../assets/images/backrecom.jpg') no-repeat center center;*/\n  background-size: 100% 100%;\n}\n\n.my-challenge-plan .fio-or-name {\n  color: white;\n}\n\n.date-item-left {\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  left: 0;\n  top: 15px;\n  width: fit-content;\n}\n\n.date-item-right {\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  right: 0;\n  top: 15px;\n  width: fit-content;\n}\n\n.result-rating-form {\n  display: block;\n  padding: 15px 0;\n  font-size: 24px;\n  line-height: 24px;\n  color: var(--blue-main);\n  font-weight: 800;\n}\n\n.result-rating-form::before {\n  content: 'Итого баллов: ';\n  font-weight: 400;\n}\n\n.results-profile-rating {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  -webkit-gap: 5px;\n  padding: var(--padding-input);\n  border-radius: 15px;\n  border: 2px solid #b5b8cf;\n}\n\n.filter-list {\n  cursor: pointer;\n  position: absolute;\n  bottom: 20px;\n  z-index: 20;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  -webkit-gap: 10px;\n  padding: 15px 20px;\n  border-radius: 20px;\n  font-size: 16px;\n  line-height: 16px;\n  color: white;\n  border: 0;\n  outline: 0;\n  background-color: #001AFF;\n}\n\n.admin-profile {\n  padding: 0;\n  color: white;\n}\n\n.admin-profile-btn {\n  background-color: darkblue;\n  outline: 0;\n  border: 0;\n}\n\n.admin-profile-btn:hover {\n  background-color: #000752;\n  outline: 0;\n  border: 0;\n}\n\n.admin-profile-decline-btn {\n  background-color: red;\n  outline: 0;\n  border: 0;\n}\n\n.admin-profile-decline-btn:hover {\n  background-color: darkred;\n  outline: 0;\n  border: 0;\n}\n\n.filter_download-info {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  -webkit-gap: 30px;\n  padding: var(--padding-input);\n  background-color: rgba(54, 110, 255, 0.1);\n  border: 2px solid rgba(54, 110, 255, 0.1);\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n}\n\n.filter_dowload-list {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 5px;\n  -webkit-gap: 5px;\n}\n\n.filter_dowload-item {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  -webkit-gap: 5px;\n  padding: 10px 10px 10px 10px;\n  background-color: var(--blue-main);\n  font-size: 12px;\n  line-height: 12px;\n  color: white;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n}\n\n.filter_dowload-btn {\n  display: block;\n  width: 12px;\n  height: 12px;\n  background: url('../assets/images/close_white.svg') no-repeat center center;\n  background-size: 12px 12px;\n  cursor: pointer;\n}\n\n.filter_radio-flex {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 20px;\n  -webkit-gap: 20px;\n  padding: 20px 0;\n}\n\n.radio_filter-dowload {\n  display: flex;\n  align-self: center;\n  gap: 2px;\n  -webkit-gap: 2px;\n  width: fit-content;\n  font-weight: 500;\n  font-size: var(--font-size);\n  line-height: var(--font-size);\n}\n\n.filter_date {\n  display: flex;\n  border: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  -webkit-gap: 10px;\n}\n\n@media (max-width: 650px) {\n  .main-list-center {\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    gap: 15px;\n    -webkit-gap: 15px;\n    /* width: var(--block-center); */\n    padding: var(--block-padding);\n    padding-top: var(--main-center-head);\n    padding-bottom: 0;\n    height: 100%;\n    width: 100%;\n  }\n}\n\n@media (max-width: 650px) {\n  .left-block {\n    width: var(--block-size);\n    display: flex;\n    flex-direction: column;\n    height: auto;\n    background-color: white;\n    z-index: 2;\n    overflow: hidden;\n  }\n}\n\n@media (max-width: 650px) {\n  .header {\n    position: sticky;\n    top: 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: var(--header-padding);\n    height: var(--header-height);\n    /* border-bottom: 1px solid #DCDDE0; */\n    background-color: white;\n  }\n}\n\n@media (max-width: 650px) {\n  .right-block {\n    position: fixed;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 4;\n    width: var(--block-size);\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    max-width: 100%;\n    background: rgba(255, 255, 255, 0.8);\n    backdrop-filter: blur(50px);\n    -webkit-backdrop-filter: blur(50px);\n    transition: ease-in-out 0.5s;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
